/**
 * Cart event handler - External JS file version
 * File: jsc-reset-scripts.js
 */

// Define the cartJSEvent function for global access
// window.cartJSEvent = function() {
//   console.log('Binding cart.requestStarted and cart.requestComplete from external file');
  
//   // Check if jQuery is available
//   if (typeof jQuery === 'undefined' && typeof $ === 'undefined') {
//     console.error('jQuery not available in external file');
//     return false;
//   }
  
//   // Force use jQuery in non-conflicting mode
//   (function($) {
//     // Direct event binding with verification
//     $(document).on('cart.requestStarted', function(event, cart) {
//       console.log('cart.requestStarted fired');
//       $('.jsc-page-loading').show();
//     });
    
//     $(document).on('cart.requestComplete', function(event, cart) {
//       console.log('cart.requestComplete fired');
//       $('.jsc-page-loading').hide();
      
//       if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
//         document.dispatchEvent(new CustomEvent('customcart:refresh'));
//       }
      
//       if ($('.main-cart-section').length > 0) {
//         document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
//       }
//     });
    
//     // Verify events are properly bound
//     console.log('Events bound successfully from external file');
    
//   })(window.jQuery || window.$); // Support both jQuery and $ in Shopify
  
//   console.log('Cart events initialization complete from external file');
//   return true;
// };

// // Attempt to auto-initialize if jQuery is already available
// document.addEventListener('DOMContentLoaded', function() {
//   console.log('DOMContentLoaded in external file - checking for jQuery');
//   if (window.jQuery || window.$) {
//     console.log('jQuery found in external file, auto-initializing');
//     window.cartJSEvent();
//   } else {
//     console.log('jQuery not yet available in external file, will be initialized from inline script');
//   }
// });
document.addEventListener('DOMContentLoaded', function () {
  // Wait a moment to ensure external script has a chance to load
  setTimeout(function() {
    console.log("Initialize cart request");
    $(document).off('cart.requestStarted');
    $(document).off('cart.requestComplete');
    $(document).on('cart.requestStarted', function(event, cart) {
      console.log('cart.requestStarted fired');
      $('.jsc-page-loading').show();
    });
    
    $(document).on('cart.requestComplete', function(event, cart) {
      console.log('cart.requestComplete fired');
      $('.jsc-page-loading').hide();
      
      if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
      document.dispatchEvent(new CustomEvent('customcart:refresh'));
      }
      
      if ($('.main-cart-section').length > 0) {
      document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
      }
    });
  }, 300); // Wait 300ms to give external script time to load
});

var masterpromorunThemeATC = false;
  $(function () {
  
  // Protect #AddToCart from third-party scripts by intercepting enable attempts
  var addToCartBtn = document.getElementById('AddToCart');
  if (addToCartBtn) {
    var textSpan = addToCartBtn.querySelector('.single-add-to-cart-button--text');
    
    // Helper function to check if button should be disabled for current variant
    function shouldButtonBeDisabled() {
      var currentVariantId = $('.variant-selected-form').val();
      var variantData = $('.variant-list-data[data-var-id="' + currentVariantId + '"]');
      
      if (variantData.length > 0) {
        var showComingSoon = variantData.attr('showcomingsoonwheninstock') === 'true';
        var isVipVariant = variantData.attr('data-vip') === 'true';
        var isVipCustomer = $("#vipCustomer").length >= 1;
        var variantAvailable = variantData.attr('data-var-avail') === 'true';
        
        return showComingSoon || (isVipVariant && !isVipCustomer) || !variantAvailable;
      }
      return false;
    }
    
    // Helper function to get correct text for current variant
    function getCorrectButtonText() {
      var currentVariantId = $('.variant-selected-form').val();
      var variantData = $('.variant-list-data[data-var-id="' + currentVariantId + '"]');
      
      if (variantData.length > 0) {
        var showComingSoon = variantData.attr('showcomingsoonwheninstock') === 'true';
        var isVipVariant = variantData.attr('data-vip') === 'true';
        var isVipCustomer = $("#vipCustomer").length >= 1;
        var variantAvailable = variantData.attr('data-var-avail') === 'true';
        var launchDateTime = variantData.attr('data-launch-time-date');
        
        if (showComingSoon || (isVipVariant && !isVipCustomer)) {
          return (launchDateTime && launchDateTime !== '') ? launchDateTime : 'Coming Soon';
        } else if (!variantAvailable) {
          return 'Sold Out';
        } else if (typeof window.jscIsPreorderOverLimitFromEl === 'function' && window.jscIsPreorderOverLimitFromEl(variantData)) {
          return 'Sold Out';
        } else if (variantData.attr('data-preorder-enable') === 'true') {
          return 'Pre-Order';
        }
      }
      return 'Add To Bag';
    }

    function getAvailableAtcLabel() {
      var currentVariantId = $('.variant-selected-form').val();
      if (typeof window.jscGetAtcLabel === 'function' && currentVariantId) {
        return window.jscGetAtcLabel(currentVariantId);
      }
      return getCorrectButtonText();
    }
    
    // Store original methods
    var originalRemoveAttribute = addToCartBtn.removeAttribute.bind(addToCartBtn);
    var originalDescriptor = Object.getOwnPropertyDescriptor(HTMLButtonElement.prototype, 'disabled');
    
    // Override removeAttribute to block removing 'disabled' when it should stay
    addToCartBtn.removeAttribute = function(attr) {
      if (attr === 'disabled' && shouldButtonBeDisabled()) {
        return; // Block the removal
      }
      originalRemoveAttribute(attr);
    };
    
    // Override disabled property setter to block enabling when it should stay disabled
    Object.defineProperty(addToCartBtn, 'disabled', {
      get: function() {
        return originalDescriptor.get.call(this);
      },
      set: function(value) {
        // If trying to enable but should stay disabled, block it
        if (value === false && shouldButtonBeDisabled()) {
          return; // Block enabling
        }
        originalDescriptor.set.call(this, value);
      },
      configurable: true
    });
    
    // Protect button text from incorrect changes using MutationObserver
    if (textSpan) {
      // Helper to check if text looks like disabled-state text
      function isDisabledStateText(text) {
        if (!text) return false;
        text = String(text).trim();
        return text === 'Coming Soon' || 
               text === 'Sold Out' || 
               /^Launching\s/i.test(text) ||  // "Launching 16.01 12pm SGT"
               /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s/i.test(text) ||
               /^\d{1,2}[\s\/\-\.]/.test(text) ||  // "16.01" or "16/01" etc
               /\d{4}/.test(text) ||  // Contains year like 2024
               /\d{1,2}(am|pm|AM|PM)/i.test(text);  // Contains time like "12pm"
      }
      
      // Helper to check if text contains invalid values
      function isInvalidText(text) {
        if (!text) return true;
        text = String(text).trim();
        return text === '' || 
               text === 'null' || 
               text === 'undefined' || 
               text.includes('null') || 
               text.includes('undefined');
      }
      
      // Helper to ensure textSpan exists and recreate if removed
      function ensureTextSpanExists() {
        var existingSpan = addToCartBtn.querySelector('.single-add-to-cart-button--text');
        if (!existingSpan) {
          // Span was removed - recreate it
          var newSpan = document.createElement('span');
          newSpan.className = 'single-add-to-cart-button--text';
          
          // Determine correct text
          if (!addToCartBtn.disabled && !addToCartBtn.hasAttribute('disabled')) {
            newSpan.textContent = getAvailableAtcLabel();
          } else {
            newSpan.textContent = getCorrectButtonText();
          }
          
          // Clean up button - remove text nodes and null spans
          var nodesToRemove = [];
          for (var i = 0; i < addToCartBtn.childNodes.length; i++) {
            var node = addToCartBtn.childNodes[i];
            if (node.nodeType === Node.TEXT_NODE) {
              nodesToRemove.push(node);
            } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'SPAN') {
              // Remove spans with null content or no class
              var spanText = node.textContent ? node.textContent.trim() : '';
              if (spanText === 'null' || spanText === 'undefined' || spanText === '' || 
                  (!node.classList.contains('single-add-to-cart-button--text') && 
                   !node.classList.contains('loading-overlay'))) {
                nodesToRemove.push(node);
              }
            }
          }
          nodesToRemove.forEach(function(node) {
            addToCartBtn.removeChild(node);
          });
          
          // Insert new span at beginning
          addToCartBtn.insertBefore(newSpan, addToCartBtn.firstChild);
          
          return newSpan;
        }
        
        // Also clean up any null spans that might exist
        var allSpans = addToCartBtn.querySelectorAll('span');
        allSpans.forEach(function(span) {
          var spanText = span.textContent ? span.textContent.trim() : '';
          if ((spanText === 'null' || spanText === 'undefined') && 
              !span.classList.contains('single-add-to-cart-button--text') &&
              !span.classList.contains('loading-overlay')) {
            span.parentNode.removeChild(span);
          }
        });
        
        // Clear button value if it's null
        if (addToCartBtn.value === 'null' || addToCartBtn.value === 'undefined') {
          addToCartBtn.removeAttribute('value');
        }
        
        return existingSpan;
      }
      
      // Observe button for child changes (in case span is removed or null added)
      var buttonObserver = new MutationObserver(function(mutations) {
        // Clean up any null spans or values
        var allSpans = addToCartBtn.querySelectorAll('span');
        allSpans.forEach(function(span) {
          var spanText = span.textContent ? span.textContent.trim() : '';
          if ((spanText === 'null' || spanText === 'undefined' || spanText === '') && 
              !span.classList.contains('single-add-to-cart-button--text') &&
              !span.classList.contains('loading-overlay')) {
            span.parentNode.removeChild(span);
          }
        });
        
        // Clear button value if it's null
        if (addToCartBtn.value === 'null' || addToCartBtn.value === 'undefined') {
          addToCartBtn.removeAttribute('value');
        }
        
        // Ensure text span exists
        var currentTextSpan = addToCartBtn.querySelector('.single-add-to-cart-button--text');
        if (!currentTextSpan) {
          buttonObserver.disconnect();
          textSpan = ensureTextSpanExists();
          // Re-observe the new span
          textObserver.observe(textSpan, { childList: true, characterData: true, subtree: true });
          buttonObserver.observe(addToCartBtn, { childList: true });
        }
      });
      buttonObserver.observe(addToCartBtn, { childList: true });
      
      // Intercept textContent setter to prevent incorrect text from ever being set
      var originalTextContentDescriptor = Object.getOwnPropertyDescriptor(Node.prototype, 'textContent');
      Object.defineProperty(textSpan, 'textContent', {
        get: function() {
          return originalTextContentDescriptor.get.call(this);
        },
        set: function(value) {
          // STRICT RULE: if button is NOT disabled, only allow "Add To Bag" or "Pre-Order"
          if (!addToCartBtn.disabled && !addToCartBtn.hasAttribute('disabled')) {
            if (value === 'Add To Bag' || value === 'Pre-Order') {
              value = getAvailableAtcLabel();
            } else if (!isInvalidText(value) && !isDisabledStateText(value)) {
              value = getAvailableAtcLabel();
            }
          }
          // Fix invalid/null values
          if (isInvalidText(value)) {
            if (!addToCartBtn.disabled && !addToCartBtn.hasAttribute('disabled')) {
              value = getAvailableAtcLabel();
            } else {
              value = getCorrectButtonText();
            }
          }
          originalTextContentDescriptor.set.call(this, value);
        },
        configurable: true
      });
      
      // Also intercept innerText for jQuery .text() compatibility
      var originalInnerTextDescriptor = Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'innerText');
      if (originalInnerTextDescriptor) {
        Object.defineProperty(textSpan, 'innerText', {
          get: function() {
            return originalInnerTextDescriptor.get.call(this);
          },
          set: function(value) {
            // STRICT RULE: if button is NOT disabled, only allow "Add To Bag" or "Pre-Order"
            if (!addToCartBtn.disabled && !addToCartBtn.hasAttribute('disabled')) {
              if (value === 'Add To Bag' || value === 'Pre-Order') {
                value = getAvailableAtcLabel();
              } else if (!isInvalidText(value) && !isDisabledStateText(value)) {
                value = getAvailableAtcLabel();
              }
            }
            // Fix invalid/null values
            if (isInvalidText(value)) {
              if (!addToCartBtn.disabled && !addToCartBtn.hasAttribute('disabled')) {
                value = getAvailableAtcLabel();
              } else {
                value = getCorrectButtonText();
              }
            }
            originalInnerTextDescriptor.set.call(this, value);
          },
          configurable: true
        });
      }
      
      // Backup observer for edge cases (e.g., innerHTML changes)
      var textObserver = new MutationObserver(function(mutations) {
        // Check if textSpan still exists
        if (!document.contains(textSpan)) {
          textObserver.disconnect();
          textSpan = ensureTextSpanExists();
          textObserver.observe(textSpan, { childList: true, characterData: true, subtree: true });
          return;
        }
        
        var currentText = originalTextContentDescriptor.get.call(textSpan);
        currentText = currentText ? currentText.trim() : '';
        
        // Ensure class is preserved
        if (!textSpan.classList.contains('single-add-to-cart-button--text')) {
          textSpan.classList.add('single-add-to-cart-button--text');
        }
        
        // STRICT RULE: if button is NOT disabled, text MUST be Add To Bag or Pre-Order
        if (!addToCartBtn.disabled && !addToCartBtn.hasAttribute('disabled')) {
          var correctAvailableText = getAvailableAtcLabel();
          if (currentText !== correctAvailableText) {
            textObserver.disconnect();
            originalTextContentDescriptor.set.call(textSpan, correctAvailableText);
            textObserver.observe(textSpan, { childList: true, characterData: true, subtree: true });
          }
        } else {
          // Button is disabled - fix invalid/null text
          if (isInvalidText(currentText)) {
            textObserver.disconnect();
            originalTextContentDescriptor.set.call(textSpan, getCorrectButtonText());
            textObserver.observe(textSpan, { childList: true, characterData: true, subtree: true });
          }
        }
      });
      
      textObserver.observe(textSpan, { childList: true, characterData: true, subtree: true });
    }
  }
  
  //cartJSEvent();
  intervalshowfestivegif();
  renderFeatCollTextColor();
  $(document).click(function(e){
    var container = $(".jsc-store-list-wrap");
    if(!container.is(e.target) && container.has(e.target).length === 0){
      $('.shopLinkList').hide();
    }
    var container = $(".jsc-select-currency");
    if(!container.is(e.target) && container.has(e.target).length === 0){
      $('.jsc-select-currency .currencyList').hide();
    }
  });
  getUserIPInfo();
  if ( $('.product-slider-pdp').length > 0 ) {
    onloadGetProductImgArray();
  }
  $('.jsc-link-container').off('click').on('click', headerbgchange);
  if (location.href.includes('.jp')) {
    $('[href="https://www.beyondthevines.com/a/return"]').text('www.beyondthevines.jp/a/return');
    $('[href="https://www.beyondthevines.com/a/return"]').attr('href','https://www.beyondthevines.jp/a/return');
  }else if (location.href.includes('.ph')) {
    $('[href="https://www.beyondthevines.com/a/return"]').text('www.beyondthevines.ph/a/return');
    $('[href="https://www.beyondthevines.com/a/return"]').attr('href','https://www.beyondthevines.ph/a/return');
  }
  //gwpPopupATCfirstload();
  updateGridHeight();
  updateGridHeightcollection();
  updateGridHeightrecommendation();
  updateGridHeightblog();
  updateFeatCollContainerHeight();
  preselectBundleProducts();
  // updateMobileImage(); //featured collection mobile image
  featureCollectionAutoTitleSwitcher();
  preventSearchBarToScroll();
  var disabled;
  swapvipcheck(disabled,true);
  earlyaccesslimit();
  onloadlabelcheck();
  masterPromo();
  handleGiftWrapChange();
  handleGiftWrapChangeCartDrawer();
  cartNotesToggle();
  onloadchecksoldoutBundle();
  onloadselectcolbundle();
  syncCollectionBundlePriceDisplay();
  loadBundleCollectionProducts();
  syncCollectionBundleEmbroideryUI($(document));
  onloadStoreLink();
  showPopupSection();
  
  // Trigger updateGiftWrap on cart updates
  document.addEventListener('cart:updated', function() {
    updateGiftWrap();
    removeMainProdLineItemProperties();
    removeGiftAndMainItemLineItemProperties();
    removeEmbroideryAndClearMain();
    if (typeof window.jscRemoveOverLimitPreorderCartItems === 'function') {
      window.jscRemoveOverLimitPreorderCartItems();
    }
  });
  if (typeof window.jscRemoveOverLimitPreorderCartItems === 'function') {
    window.jscRemoveOverLimitPreorderCartItems();
  }
  datePickerListener();
  initFaqSlider();
  initComplementary();
  initJscPwpGeneralScrollstripNav();
  scheduleJscPwpScrollstripReveal();
  window.setTimeout(jscClampAllPwpGeneralScrollstripsFirstCell, 120);
  window.setTimeout(jscClampAllPwpGeneralScrollstripsFirstCell, 400);
  if (!window._jscPwpStripRevealLoadBound) {
    window._jscPwpStripRevealLoadBound = true;
    window.addEventListener(
      'load',
      function () {
        finalizeAllAwaitingPwpScrollstrips();
        jscClampAllPwpGeneralScrollstripsFirstCell();
      },
      { once: true }
    );
  }
  if (!window._jscPwpStripAwaitFallbackQueued) {
    window._jscPwpStripAwaitFallbackQueued = true;
    window.setTimeout(function () {
      finalizeAllAwaitingPwpScrollstrips();
      jscClampAllPwpGeneralScrollstripsFirstCell();
      $('.jsc-pwp-general-scrollstrip-wrap.jsc-pwp-strip-awaiting')
        .removeClass('jsc-pwp-strip-awaiting')
        .addClass('is-jsc-pwp-strip-stable');
    }, 3500);
  }
  document.addEventListener('quick-view:open', function () {
    requestAnimationFrame(function () {
      const $qvScope = $('.side-panel.product-drawer, #Product-Drawer');
      loadBundleCollectionProducts($qvScope);
      syncCollectionBundlePriceDisplay();
      syncCollectionBundleEmbroideryUI($qvScope);
      refreshProductDrawerPwpGeneralFlickity();
      initJscPwpGeneralScrollstripNav();
      scheduleJscPwpScrollstripReveal();
      window.setTimeout(jscRefinePwpDrawerGeneralScrollstrips, 50);
      window.setTimeout(jscRefinePwpDrawerGeneralScrollstrips, 120);
      window.setTimeout(jscRefinePwpDrawerGeneralScrollstrips, 280);
      window.setTimeout(jscRefinePwpDrawerGeneralScrollstrips, 420);
      window.setTimeout(jscClampAllPwpGeneralScrollstripsFirstCell, 120);
      window.setTimeout(jscClampAllPwpGeneralScrollstripsFirstCell, 400);
    });
  });
  document.addEventListener('shopify:section:load', function () {
    loadBundleCollectionProducts();
  });
  $(document).on('click', '.jsc-pwp-general-scrollstrip-nav--prev', function (e) {
    e.preventDefault();
    var $wrap = $(this).closest('.jsc-pwp-general-scrollstrip-wrap');
    var strip = $wrap.find('.jsc-pwp-general-scrollstrip')[0];
    if (!strip) return;
    var idx = getJscPwpGeneralStripActiveIndex(strip);
    if (idx > 0) scrollJscPwpGeneralStripToIndex(strip, idx - 1);
    window.setTimeout(function () {
      updateJscPwpGeneralScrollstripNav($wrap);
    }, 380);
  });
  $(document).on('click', '.jsc-pwp-general-scrollstrip-nav--next', function (e) {
    e.preventDefault();
    var $wrap = $(this).closest('.jsc-pwp-general-scrollstrip-wrap');
    var strip = $wrap.find('.jsc-pwp-general-scrollstrip')[0];
    if (!strip) return;
    var cards = getJscPwpGeneralStripCardEls(strip);
    var idx = getJscPwpGeneralStripActiveIndex(strip);
    if (idx < cards.length - 1) scrollJscPwpGeneralStripToIndex(strip, idx + 1);
    window.setTimeout(function () {
      updateJscPwpGeneralScrollstripNav($wrap);
    }, 380);
  });
  $(document).on('scroll', '.jsc-pwp-general-scrollstrip', function () {
    updateJscPwpGeneralScrollstripNav($(this).closest('.jsc-pwp-general-scrollstrip-wrap'));
  });
  updateFaqID();
  applyToSelectInput();
  initCartDrawerYMLSlider();
  initFeaturedCollectionSlider();
  featureCollectionAutoTitleSwitcherSlider();
  checkScreenSizeForOrderPagination();
  checkAndUpdateReturnGoButtonText();
  shopLookHover();
  $(".product-add-to-cart-sticky--inner").on("click", function() {
    updateProductAddToCartSticky();
  });
  $(document).on('click', '.ReturnGO_UploadImages-module_upload', function() {
    handleUploadButtonClick();
  });
    initflickityCarouselPage();
  initflickityCarouselstorePageonclick();

  //Marquee
  // var clonenewMarquee = $(".js-marquee").first().find('div:not(.js-marquee)').clone();
  // $("#scroll_textblog").children().remove();
  // $("#scroll_textblog").append(clonenewMarquee);
  newMarquee();
  newBlogMarquee();

  appendtogglesize();
  $(".tablesizelist ul.tabs a").click(function() {
    $(".tablesizelist ul.tabs a").removeClass('js-active');
    $(".tablesizelist ul.tabs-content li").removeClass('active');
    $(".tabs-content " +$(this).attr("href")).addClass('active');
    $(this).addClass('js-active');
    if($(this).text() == "Size Conversion"){
      $(".tablesizelist .togglesize").hide();
    }else{
      $(".tablesizelist .togglesize").show();
    }
  });
  $("#viewSize span").click(function() {
    $(".sizepopupoverlay").show();
    $(".sizepopup").show();
    $("body").css('overflow', 'hidden');
  });

  initWrapperCloseButton();
  changeProductNoteToSentenceCase();
  $(window).resize(function() {
    updateFeatCollContainerHeight();
  });
  var flickityCheckCount = 0;
  var flickityCheckLimit = 50;
  var flickityCheck = setInterval(function() {
    flickityCheckCount += 1;
    if (typeof $.fn.flickity === 'function') {
      clearInterval(flickityCheck);
      initswatchflickity();
    } else if (flickityCheckCount >= flickityCheckLimit) {
      clearInterval(flickityCheck);
    }
  }, 10);

  checkFirstNonHiddenVariant();
});

checkFirstNonHiddenVariant = () => {
  $('.variations').each(function () {
    var $variations = $(this);
    var $checkedLabel = $variations.find('input[type="radio"]:checked + label');
    if ($checkedLabel.length) return;
    var $firstInput = $variations.find('input[type="radio"]').filter(function () {
      return $(this).next('label').length > 0;
    }).first();
    if ($firstInput.length) {
      $firstInput.next('label').click();
    }
  });
}

//swap variant label - start
getProductInfoScopeFromSection = (sectionId) => {
  if (sectionId) {
    var productInfo = document.getElementById('ProductInfo-' + sectionId);
    if (productInfo) return $(productInfo);
    var variantSelects = document.getElementById('variant-selects-' + sectionId);
    if (variantSelects) return $(variantSelects).closest('.product-information--inner');
  }
  var drawerContent = document.getElementById('Product-Drawer-Content');
  if (drawerContent) {
    var $drawerScope = $(drawerContent).find('.product-information--inner').first();
    if ($drawerScope.length) return $drawerScope;
  }
  return $('.pdp-section-info').first();
};

updateVariantLabelVisibility = ($scope, variantId) => {
  if (!$scope || !$scope.length || !variantId) return;

  $scope.find(".jsc-var-label").hide();
  $scope.find(".jsc-var-label").each(function () {
    if ($(this).attr('data-label-id') == variantId) {
      $(this).show();
    }
  });

  var hasQtyRowLabel = false;
  var hasDiscountCodeLabel = false;
  var hasFewPiecesLabel = $scope.find('.pdp-few-pieces-label.active, .pdp-last-pieces-label.active').length > 0;
  $('.hide-sold-label').hide(); //This hide the sold label when there is notify button - #10574
  $scope.find('.label-qty-wrap-qv .jsc-var-label').each(function () {
    if ($(this).attr('data-label-id') == variantId) {
      hasQtyRowLabel = true;
    }
  });
  $scope.find('.label-qty-wrap-qv .jsc-label:not(.jsc-var-label)').each(function () {
    if ($(this).is(':visible')) {
      hasQtyRowLabel = true;
    }
  });
  $scope.find('.label-discount-code-wrap .jsc-var-label').each(function () {
    if ($(this).attr('data-label-id') == variantId) {
      hasDiscountCodeLabel = true;
    }
  });
  $scope.find('.label-discount-code-wrap .jsc-label:not(.jsc-var-label)').each(function () {
    hasDiscountCodeLabel = true;
  });
  if (hasQtyRowLabel || hasFewPiecesLabel) {
    $scope.find('.label-qty-wrap-qv').show();
  } else {
    $scope.find('.label-qty-wrap-qv').hide();
  }
  if (hasDiscountCodeLabel) {
    $scope.find('.label-discount-code-wrap').show();
  } else {
    $scope.find('.label-discount-code-wrap').hide();
  }
};

updateVariantLabelContent = ($scope, variantId) => {
  if (!$scope || !$scope.length || !variantId) return;
  updateVariantLabelVisibility($scope, variantId);

  $scope.find(".variant-list-data").each(function () {
    var datavariddesciption = $(this).val();
    if (datavariddesciption == variantId) {
      var $accordion = $scope.find(".prod-desc-accordion");
      var $sku = $accordion.find('.product-sku').detach();
      $accordion.html($(this).attr('variantdescription'));
      $accordion.append($sku);
      $scope.find(".washcare-accordion").html($(this).attr('variantwashcare'));
      var measurementdesc = $(this).attr('variantMeasurement');
      if (measurementdesc) {
        $scope.find(".prod-measurement-accordion").html(measurementdesc);
      }
    }
  });
};

swaplabel = (evt) => {
  setTimeout(function () {
    var $scope = $(evt).parents('.product-information--inner');
    var variantId = $scope.find(".variant-selected-form").val();
    updateVariantLabelContent($scope, variantId);
  }, 10);
};

onloadlabelcheck = () => {
  $('.product-information--inner').each(function () {
    var $scope = $(this);
    var variantId = $scope.find(".variant-selected-form").val();
    if (variantId) {
      updateVariantLabelVisibility($scope, variantId);
    }
  });
};

if (!window.jscVariantLabelListenerAttached) {
  window.jscVariantLabelListenerAttached = true;
  document.addEventListener('product:variant-change', function (ev) {
    var d = ev.detail;
    if (!d || !d.variant) return;
    var variantId = String(d.variant.id);
    var $scope = getProductInfoScopeFromSection(d.sectionId);
    if ($scope && $scope.length) {
      updateVariantLabelContent($scope, variantId);
    }
    if (typeof syncCollectionBundlePriceDisplay === 'function') {
      window.setTimeout(syncCollectionBundlePriceDisplay, 0);
    }
  });
}
//swap variant label - end

//swap variant image - start
function jscIsCollectionBundlePage() {
  return $('.bundle-select-prod-main.bundle-collection-mode').length > 0
    || $('.bundle-collection-wrap[data-bundle-mode="collection"]').length > 0;
}
function jscIsCollectionBundleCompositeCell(el) {
  if (!el || !el.classList) {
    return false;
  }
  if (el.getAttribute('data-bundle-composite') === 'collection') {
    return true;
  }
  var mediaId = el.getAttribute('data-media-id') || '';
  var elId = el.id || '';
  return el.classList.contains('bundlelistimg')
    && (mediaId.indexOf('bundle-collection') !== -1 || elId.indexOf('bundle-collection') !== -1);
}
function jscShouldAppendCollectionBundleParentCell(el) {
  return !jscIsCollectionBundlePage() || jscIsCollectionBundleCompositeCell(el);
}
var $imgContainer = $('.product-slider-pdp');
var $childArrayElement = $imgContainer.find('.product-images__slide');
var $navContainer = $('.selectedNav');
var $navCell = $('.navCell');

onloadGetProductImgArray = () =>{
  $imgContainer = $('.product-slider-pdp');
  $childArrayElement = $imgContainer.find('.product-images__slide');
  $navContainer = $('.selectedNav');
  $navCell = $navContainer.find('.navCell');

  var $isShow = false;
  var $bundleColor = '';
  var $setBundleImg = '';
  $(".swatch_options.bundle-child-swatch input:checked").each(function () {
    var $swatchVal = $(this).val();
    if ($swatchVal) {
      var $swatchchildValue = $swatchVal.toLowerCase();
      $setBundleImg += $swatchchildValue + '-';
    }
  });
  if ($setBundleImg.length > 0) {
    $setBundleImg = $setBundleImg.substring(0, $setBundleImg.length - 1);
  }
  
  var $hasColorOption = $('.pdp-section-info .variations .product-form__input--color input[type="radio"]:checked').length > 0;
  var $selectedColor = '';
  
  // Safely get selected color only if color option exists
  if ($hasColorOption) {
    var $colorInput = $('.pdp-section-info .variations .product-form__input--color input[type="radio"]:checked').val();
    if ($colorInput !== undefined && $colorInput !== '') {
      $selectedColor = $colorInput.toLowerCase();
    }
  }
  
  if ($(".pdp-section-info .variations").find('.product-form__input--color input[type="radio"]:checked').length > 1) {
    var bundlecolor = '';
    $(".pdp-section-info .variations").find('.product-form__input--color input[type="radio"]:checked').each(function () {
      var val = $(this).val();
      if (val) {
        bundlecolor = bundlecolor + val.toLowerCase() + '-';
      }
    });
    if (bundlecolor.length > 0) {
      bundlecolor = bundlecolor.substring(0,bundlecolor.length - 1);
      $bundleColor = bundlecolor;
    }
  }
  
  var $prodTitle = $('.pdp-section-info .product-title').attr('data-title');
  if ($prodTitle) {
    $prodTitle = $prodTitle.toLowerCase();
  } else {
    $prodTitle = '';
  }

  if ($(".pdp-section-info .prod-bundle-select").length > 1) {
    $selectedColor = $prodTitle;
  }

  // Destroy slider
  destroyProductSlider();
  destroyNavSlider();
 
  // remove all product image
  $imgContainer.children().remove();
  $navCell.remove();
  
  // Loop and append the correct cell
  for (var i = 0; i < $childArrayElement.length; i++) {
    var $thisAltText = $($childArrayElement[i]).attr('data-img-alt');
    if ($thisAltText) {
      $thisAltText = $thisAltText.toLowerCase();
    } else {
      $thisAltText = '';
    }
    
    if ($childArrayElement[i].classList.contains('bundlevarimg')) {
      // Skip bundle variant images for now
    } else if (!jscShouldAppendCollectionBundleParentCell($childArrayElement[i])) {
      // Collection bundle parent images only live inside the composite bundlelistimg slide
    } else {
      // If no color option, show all images. Otherwise filter by color
      var shouldAppend = false;
      if (!$hasColorOption || !$selectedColor) {
        // No color option - show all images
        shouldAppend = true;
      } else {
        // Filter by color
        shouldAppend = ($thisAltText == $selectedColor || 
                       $thisAltText == $setBundleImg || 
                       $thisAltText == $bundleColor || 
                       $thisAltText == $prodTitle || 
                       ($selectedColor && $thisAltText.includes($selectedColor + "-textMain")) || 
                       ($selectedColor && $thisAltText.includes($selectedColor + "-youtube")) || 
                       ($selectedColor && $thisAltText.includes($selectedColor + "-vimeo")));
      }
      
      if (shouldAppend) {
        $imgContainer.append($childArrayElement[i]);
        $isShow = true;
      }
    }
  }
  
  // Ensure the first image has is-active class to make it visible (needed for variant images)
  if ($imgContainer.children().length > 0) {
    var $firstImage = $imgContainer.children().first();
    if ($firstImage.hasClass('product-images__slide-item--variant') && !$firstImage.hasClass('is-active')) {
      $firstImage.addClass('is-active');
    }
    // Also ensure it doesn't have aria-hidden
    $firstImage.removeAttr('aria-hidden');
  }
  
  // Loop and append the correct cell for nav img slider
  for (var i = 0; i < $navCell.length; i++) {
    var $thisAltText = $($navCell[i]).attr('data-img-alt');
    if ($thisAltText) {
      $thisAltText = $thisAltText.toLowerCase();
    } else {
      $thisAltText = '';
    }
    
    if ($navCell[i].classList.contains('bundlevarimg')) {
      // Skip bundle variant images for now
    } else if (!jscShouldAppendCollectionBundleParentCell($navCell[i])) {
      // Collection bundle parent thumbs only live inside the composite bundlelistimg cell
    } else {
      // If no color option, show all images. Otherwise filter by color
      var shouldAppend = false;
      if (!$hasColorOption || !$selectedColor) {
        // No color option - show all images
        shouldAppend = true;
      } else {
        // Filter by color
        shouldAppend = ($thisAltText == $selectedColor || 
                       $thisAltText == $setBundleImg || 
                       $thisAltText == $bundleColor || 
                       $thisAltText == $prodTitle || 
                       ($selectedColor && $thisAltText.includes($selectedColor + "-textMain")) || 
                       ($selectedColor && $thisAltText.includes($selectedColor + "-youtube")) || 
                       ($selectedColor && $thisAltText.includes($selectedColor + "-vimeo")));
      }
      
      if (shouldAppend) {
        $navContainer.append($navCell[i]);
        $isShow = true;
      }
    }
  }

  $(".swatch_options.bundle-child-swatch input:checked").each(function (index) {
    var productIndex = index + 1;
    var $swatchVal = $(this).val();
    if (!$swatchVal) return;
    var $swatchchild = $swatchVal.toLowerCase();

      for (var i = 0; i < $childArrayElement.length; i++) {
        if ($childArrayElement[i].classList.contains('bundlevarimg_' + productIndex)) {
        var $alt = $($childArrayElement[i]).attr('data-img-alt');
        if ($alt) {
          $alt = $alt.toLowerCase();
        } else {
          $alt = '';
        }
          if (
            $alt == $swatchchild ||
            $alt == $prodTitle ||
            ($swatchchild && $alt.includes($swatchchild + "-textMain")) ||
            ($swatchchild && $alt.includes($swatchchild + "-youtube")) ||
            ($swatchchild && $alt.includes($swatchchild + "-vimeo"))
          ) {
            if ($(".pdp-section-info .prod-bundle-select").length <= 0) {
            $imgContainer.append($childArrayElement[i]);
            }
            $isShow = true;
          }
        }
      }

      for (var i = 0; i < $navCell.length; i++) {
        if ($navCell[i].classList.contains('bundlevarimg_' + productIndex)) {
        var $alt = $($navCell[i]).attr('data-img-alt');
        if ($alt) {
          $alt = $alt.toLowerCase();
        } else {
          $alt = '';
        }
          if (
            $alt == $swatchchild ||
            $alt == $prodTitle ||
            ($swatchchild && $alt.includes($swatchchild + "-textMain")) ||
            ($swatchchild && $alt.includes($swatchchild + "-youtube")) ||
            ($swatchchild && $alt.includes($swatchchild + "-vimeo"))
          ) {
            if ($(".pdp-section-info .prod-bundle-select").length <= 0) {
            $navContainer.append($navCell[i]);
            }
            $isShow = true;
          }
        }
      }
  });
  
  // Ensure all variant images that should be visible have is-active class
  // This is needed because CSS hides variant images unless they have is-active or are first-child
  if ($imgContainer && $imgContainer.children().length > 0) {
    var $variantImages = $imgContainer.find('.product-images__slide-item--variant');
    // If there are variant images, ensure at least the first one is active
    if ($variantImages.length > 0) {
      // Remove is-active from all variant images first
      $variantImages.removeClass('is-active');
      // Add is-active to the first one
      $variantImages.first().addClass('is-active');
      // Also ensure the first one doesn't have aria-hidden
      $variantImages.first().removeAttr('aria-hidden');
    }
  }
  
  //initiate flickity function
  initProductSlider($isShow);
  initNavSlider();

  var prevWidth = window.innerWidth;

  $( window ).resize(function() {
    var width = window.innerWidth;
    if (width !== prevWidth) {
    // Destroy slider
    destroyProductSlider();
    destroyNavSlider();
    initProductSlider(true);
    initNavSlider();
    }

  });
}

variantImageSwap = (color,bundle) =>{
  setTimeout(() => {
    var $setBundleImg = '';
    $(".swatch_options.bundle-child-swatch input:checked").each(function () {
      var $swatchchildValue = $(this).val().toLowerCase();
      $setBundleImg += $swatchchildValue + '-';
    });
    $setBundleImg = $setBundleImg.substring(0, $setBundleImg.length - 1);
    var $isShow = false;
    var $bundleColor = '';
    if (bundle) {
      var $selectedColor = $(".swatch_options.bundle-child-swatch input:checked").first().val().toLowerCase();
    }else{
      var $selectedColor = color.toLowerCase();
    }
    console.log("$selectedColor", $(".swatch_options.bundle-child-swatch input:checked").first().val());  
    if ($(".pdp-section-info .variations").find('.product-form__input--color input[type="radio"]:checked').length > 1) {
      var bundlecolor = '';
      $(".pdp-section-info .variations").find('.product-form__input--color:not(.--sticky) input[type="radio"]:checked').each(function () {
        bundlecolor = bundlecolor + $(this).val().toLowerCase() + '-';
      });
      bundlecolor = bundlecolor.substring(0,bundlecolor.length - 1);
      $bundleColor = bundlecolor;
    }
    var $prodTitle = $('.pdp-section-info .product-title').attr('data-title').toLowerCase();
  
    // Destroy slider
    destroyProductSlider();
    destroyNavSlider();
  
    // remove all product image
    $imgContainer.children().remove();
    $navCell.remove();
    
    // Loop and append the correct cell
    for (var i = 0; i < $childArrayElement.length; i++) {
      var $thisAltText = $($childArrayElement[i]).attr('data-img-alt').toLowerCase();
      if ($childArrayElement[i].classList.contains('bundlevarimg')) {
        
      } else if (!jscShouldAppendCollectionBundleParentCell($childArrayElement[i])) {
        
      } else {
      if ($thisAltText == $selectedColor || $thisAltText == $setBundleImg || $thisAltText == $bundleColor || $thisAltText == $prodTitle || $thisAltText.includes($selectedColor + "-textMain") || $thisAltText.includes($selectedColor + "-youtube") || $thisAltText.includes($selectedColor + "-vimeo")) {
        $imgContainer.append($childArrayElement[i]);
        $isShow = true;
      }
      }
    }
    
    // Loop and append the correct cell for nav img slider
    for (var i = 0; i < $navCell.length; i++) {
      var $thisAltText = $($navCell[i]).attr('data-img-alt').toLowerCase();
      if ($navCell[i].classList.contains('bundlevarimg')) {
        
      } else if (!jscShouldAppendCollectionBundleParentCell($navCell[i])) {
        
      } else {
      if ($thisAltText == $selectedColor || $thisAltText == $setBundleImg || $thisAltText == $bundleColor || $thisAltText == $prodTitle || $thisAltText.includes($selectedColor + "-textMain") || $thisAltText.includes($selectedColor + "-youtube") || $thisAltText.includes($selectedColor + "-vimeo")) {
        $navContainer.append($navCell[i]);
        $isShow = true;
      }
      }
    }

    if ($(".pdp-section-info .prod-bundle-select").length <= 0) {
    $(".swatch_options.bundle-child-swatch input:checked").each(function (index) {
      var productIndex = index + 1;
      var $swatchchild = $(this).val().toLowerCase();
  
        for (var i = 0; i < $childArrayElement.length; i++) {
          if ($childArrayElement[i].classList.contains('bundlevarimg_' + productIndex)) {
          var $alt = $($childArrayElement[i]).attr('data-img-alt').toLowerCase();
            if (
              $alt == $swatchchild ||
              $alt == $prodTitle ||
              $alt.includes($swatchchild + "-textMain") ||
              $alt.includes($swatchchild + "-youtube") ||
              $alt.includes($swatchchild + "-vimeo")
            ) {
              $imgContainer.append($childArrayElement[i]);
            }
          }
        }
  
        for (var i = 0; i < $navCell.length; i++) {
          if ($navCell[i].classList.contains('bundlevarimg_' + productIndex)) {
          var $alt = $($navCell[i]).attr('data-img-alt').toLowerCase();
            if (
              $alt == $swatchchild ||
              $alt == $prodTitle ||
              $alt.includes($swatchchild + "-textMain") ||
              $alt.includes($swatchchild + "-youtube") ||
              $alt.includes($swatchchild + "-vimeo")
            ) {
              $navContainer.append($navCell[i]);
            }
          }
        }
    });
    }else{

      $(".pdp-section-info .prod-bundle-select .swatch_options.bundle-child-swatch .swatchbundlecol input:checked").each(function (index) {
        var productIndex = index + 1;
        var $swatchchild = $(this).val().toLowerCase();
        var swatchprodid = $(this).attr('data-product-id');
    
          for (var i = 0; i < $childArrayElement.length; i++) {
            if ($childArrayElement[i].classList.contains('bundlevarimg_' + swatchprodid)) {
            var $alt = $($childArrayElement[i]).attr('data-img-alt').toLowerCase();
              if (
                $alt == $swatchchild ||
                $alt == $prodTitle ||
                $alt.includes($swatchchild + "-textMain") ||
                $alt.includes($swatchchild + "-youtube") ||
                $alt.includes($swatchchild + "-vimeo")
              ) {
                $imgContainer.append($childArrayElement[i]);
              }
            }
          }
    
          for (var i = 0; i < $navCell.length; i++) {
            if ($navCell[i].classList.contains('bundlevarimg_' + swatchprodid)) {
            var $alt = $($navCell[i]).attr('data-img-alt').toLowerCase();
              if (
                $alt == $swatchchild ||
                $alt == $prodTitle ||
                $alt.includes($swatchchild + "-textMain") ||
                $alt.includes($swatchchild + "-youtube") ||
                $alt.includes($swatchchild + "-vimeo")
              ) {
                $navContainer.append($navCell[i]);
              }
            }
          }
      });
    }
    
    //initiate flickity function
    initProductSlider($isShow);
    initNavSlider();
  }, 1);
}

initNavSlider = () =>{
  $('.selectedNav').removeClass('showthumbnailimg');
  var $_navCell = $('.navCell');
  var $cellLength = $_navCell.length;
  var $_flickityObj = {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'left',
    wrapAround: true};
  var $cellnotwraparound = true;
 
  if ($(window).width() > 481) {
    if ($cellLength > 7) {
      $('.selectedNav').flickity($_flickityObj);
      $cellnotwraparound = false;
    }
  } else {
    if ($cellLength > 8) {
      $('.selectedNav').flickity($_flickityObj);
      $cellnotwraparound = false;
    }
  }
  if ($cellnotwraparound) {
    $('.selectedNav').addClass('showthumbnailimg');
  }
}

initProductSlider = (isShow) =>{
  // Only initialize if isShow is true and there are images in the container
  if (isShow && $imgContainer && $imgContainer.children().length > 0) {

    var obj = {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'center',
    wrapAround: true};

    $imgContainer.flickity(obj);

    // Flickity instance
    var flkty = $imgContainer.data('flickity');
    // elements
    var $cellButtonGroup = $('.selectedNav');
    var $cellButtons = $cellButtonGroup.find('.navCell');
 
    // update selected cellButtons - only if Flickity was initialized
    if (flkty) {
      // Ensure the selected cell has is-active class and is visible
      var $selectedCell = $imgContainer.find('.flickity-cell.is-selected');
      if ($selectedCell.length > 0) {
        $selectedCell.addClass('is-active');
        $selectedCell.removeAttr('aria-hidden');
      }
      
      $imgContainer.on( 'select.flickity', function() {
        // Update is-active class for variant images
        var $allCells = $imgContainer.find('.flickity-cell');
        $allCells.removeClass('is-active');
        var $selectedCell = $imgContainer.find('.flickity-cell.is-selected');
        if ($selectedCell.length > 0) {
          $selectedCell.addClass('is-active');
          $selectedCell.removeAttr('aria-hidden');
        }
        
        $cellButtons.filter('.is-selected')
          .removeClass('is-selected');
        $cellButtons.eq( flkty.selectedIndex )
          .addClass('is-selected');
        if ($(this).find('.is-selected').find('video').length > 0) {
          $(this).find('.is-selected').find('video')[0].play();
        }
      });
 
      // select cell on button click
      $cellButtonGroup.on( 'click', '.navCell', function() {
        var index = $(this).index();
        $imgContainer.flickity( 'select', index );
      });
    }
  }
  // previous
    $('.button--previous').on( 'click', function() {
      $imgContainer.flickity('previous');
    });
  // next
    $('.button--next').on( 'click', function() {
      $imgContainer.flickity('next');
    });
}

destroyProductSlider = () =>{
  $('.product-slider-pdp').flickity();
  $('.product-slider-pdp').flickity('destroy');
}

destroyNavSlider = () =>{
  $('.selectedNav').flickity();
  $('.selectedNav').flickity('destroy');
}

//swap variant image - end

//swap variant image quick view - start
var $imgContainerQV;
var $childArrayElementQV;
var $navContainerQV;
var $navCellQV;

onloadGetProductImgArrayQV = ($imgContainerQV,$childArrayElementQV) =>{
  var $bundleColor = '';
  var $selectedColor = '';
  var $hasColorOption = $('.side-panel.product-drawer .variations .product-form__input--color input[type="radio"]:checked').length > 0;
  
  // Safely get selected color only if color option exists
  if ($hasColorOption) {
    var $colorInput = $('.side-panel.product-drawer .variations .product-form__input--color input[type="radio"]:checked').val();
    if ($colorInput) {
      $selectedColor = $colorInput.toLowerCase();
    }
  }
  
  var $prodTitle = $('.side-panel.product-drawer .product-title').attr('data-title');
  if ($prodTitle) {
    $prodTitle = $prodTitle.toLowerCase();
  } else {
    $prodTitle = '';
  }
  
  if ($(".side-panel.product-drawer").find('.product-form__input--color:not(.--sticky) input[type="radio"]:checked').length > 1) {
    var bundlecolor = '';
    $(".side-panel.product-drawer").find('.product-form__input--color:not(.--sticky) input[type="radio"]:checked').each(function () {
      var val = $(this).val();
      if (val) {
        bundlecolor = bundlecolor + val.toLowerCase() + '-';
      }
    });
    if (bundlecolor.length > 0) {
      bundlecolor = bundlecolor.substring(0,bundlecolor.length - 1);
      $bundleColor = bundlecolor;
    }
  }
  if ($(".side-panel.product-drawer .prod-bundle-select").length > 1) {
    $selectedColor = $prodTitle;
  }
 
  // Destroy slider
  $imgContainerQV.flickity();
  $imgContainerQV.flickity('destroy');
  $navContainerQV.flickity();
  $navContainerQV.flickity('destroy');
 
  // remove all product image
  $imgContainerQV.children().remove();
  $navContainerQV.children().remove();
  
  var $isShow = false;
  
  // Loop and append the correct cell
  for (var i = 0; i < $childArrayElementQV.length; i++) {
    var $thisAltText = $($childArrayElementQV[i]).attr('data-img-alt');
    if ($thisAltText) {
      $thisAltText = $thisAltText.toLowerCase();
    } else {
      $thisAltText = '';
    }
    
    if ($childArrayElementQV[i].classList.contains('bundlevarimg')) {
      // Skip bundle variant images for now
    } else {
      // If no color option, show all images. Otherwise filter by color
      var shouldAppend = false;
      if (!$hasColorOption || !$selectedColor) {
        // No color option - show all images
        shouldAppend = true;
      } else {
        // Filter by color
        shouldAppend = ($thisAltText == $selectedColor || 
                       $thisAltText == $bundleColor || 
                       $thisAltText == $prodTitle || 
                       ($selectedColor && $thisAltText.includes($selectedColor + "-textMain")) || 
                       ($selectedColor && $thisAltText.includes($selectedColor + "-youtube")) || 
                       ($selectedColor && $thisAltText.includes($selectedColor + "-vimeo")));
      }
      
      if (shouldAppend) {
        $imgContainerQV.append($childArrayElementQV[i]);
        $isShow = true;
      }
    }
  }
  
  // Ensure the first image has is-active class to make it visible (needed for variant images)
  if ($imgContainerQV.children().length > 0) {
    var $firstImage = $imgContainerQV.children().first();
    if ($firstImage.hasClass('product-images__slide-item--variant') && !$firstImage.hasClass('is-active')) {
      $firstImage.addClass('is-active');
    }
    // Also ensure it doesn't have aria-hidden
    $firstImage.removeAttr('aria-hidden');
  }

  // Loop and append the correct cell for nav img slider
  for (var i = 0; i < $navCellQV.length; i++) {
    var $thisAltText = $($navCellQV[i]).attr('data-img-alt');
    if ($thisAltText) {
      $thisAltText = $thisAltText.toLowerCase();
    } else {
      $thisAltText = '';
    }
    
    if ($navCellQV[i].classList.contains('bundlevarimg')) {
      // Skip bundle variant images for now
    } else {
      // If no color option, show all images. Otherwise filter by color
      var shouldAppend = false;
      if (!$hasColorOption || !$selectedColor) {
        // No color option - show all images
        shouldAppend = true;
      } else {
        // Filter by color
        shouldAppend = ($thisAltText == $selectedColor || 
                       $thisAltText == $bundleColor || 
                       $thisAltText == $prodTitle || 
                       ($selectedColor && $thisAltText.includes($selectedColor + "-textMain")) || 
                       ($selectedColor && $thisAltText.includes($selectedColor + "-youtube")) || 
                       ($selectedColor && $thisAltText.includes($selectedColor + "-vimeo")));
      }
      
      if (shouldAppend) {
        $navContainerQV.append($navCellQV[i]);
        $isShow = true;
      }
    }
  }

  $(".side-panel .swatch_options.bundle-child-swatch input:checked").each(function (index) {
    var productIndex = index + 1;
    var $swatchVal = $(this).val();
    if (!$swatchVal) return;
    var $swatchchild = $swatchVal.toLowerCase();

      for (var i = 0; i < $childArrayElementQV.length; i++) {
        if ($childArrayElementQV[i].classList.contains('bundlevarimg_' + productIndex)) {
        var $alt = $($childArrayElementQV[i]).attr('data-img-alt');
        if ($alt) {
          $alt = $alt.toLowerCase();
        } else {
          $alt = '';
        }
          if (
            $alt == $swatchchild ||
            $alt == $prodTitle ||
            ($swatchchild && $alt.includes($swatchchild + "-textMain")) ||
            ($swatchchild && $alt.includes($swatchchild + "-youtube")) ||
            ($swatchchild && $alt.includes($swatchchild + "-vimeo"))
          ) {
            if ($(".side-panel.product-drawer .prod-bundle-select").length <= 0) {
            $imgContainerQV.append($childArrayElementQV[i]);
            $isShow = true;
            }
          }
        }
      }

      for (var i = 0; i < $navCellQV.length; i++) {
        if ($navCellQV[i].classList.contains('bundlevarimg_' + productIndex)) {
        var $alt = $($navCellQV[i]).attr('data-img-alt');
        if ($alt) {
          $alt = $alt.toLowerCase();
        } else {
          $alt = '';
        }
          if (
            $alt == $swatchchild ||
            $alt == $prodTitle ||
            ($swatchchild && $alt.includes($swatchchild + "-textMain")) ||
            ($swatchchild && $alt.includes($swatchchild + "-youtube")) ||
            ($swatchchild && $alt.includes($swatchchild + "-vimeo"))
          ) {
            if ($(".side-panel.product-drawer .prod-bundle-select").length <= 0) {
            $navContainerQV.append($navCellQV[i]);
            $isShow = true;
            }
          }
        }
      }
  });
  
  //initiate flickity function - only if there are images
  if ($imgContainerQV.children().length > 0) {
    var obj = {
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'center',
      wrapAround: true};

    $imgContainerQV.flickity(obj);

    // Flickity instance
    var flkty = $imgContainerQV.data('flickity');
    // elements
    var $cellButtonGroup = $('.side-panel .selectedNav');
    var $cellButtons = $cellButtonGroup.find('.navCell');

    // update selected cellButtons - only if Flickity was initialized
    if (flkty) {
      // Ensure the selected cell has is-active class and is visible
      var $selectedCell = $imgContainerQV.find('.flickity-cell.is-selected');
      if ($selectedCell.length > 0) {
        $selectedCell.addClass('is-active');
        $selectedCell.removeAttr('aria-hidden');
      }
      
      $imgContainerQV.on( 'select.flickity', function() {
        // Update is-active class for variant images
        var $allCells = $imgContainerQV.find('.flickity-cell');
        $allCells.removeClass('is-active');
        var $selectedCell = $imgContainerQV.find('.flickity-cell.is-selected');
        if ($selectedCell.length > 0) {
          $selectedCell.addClass('is-active');
          $selectedCell.removeAttr('aria-hidden');
        }
        
        $cellButtons.filter('.is-selected')
          .removeClass('is-selected');
        $cellButtons.eq( flkty.selectedIndex )
          .addClass('is-selected');
        if ($(this).find('.is-selected').find('video').length > 0) {
          $(this).find('.is-selected').find('video')[0].play();
        }
      });

      // select cell on button click
      $cellButtonGroup.on( 'click', '.navCell', function() {
        var index = $(this).index();
        $imgContainerQV.flickity( 'select', index );
      });
    }
  }

  $('.side-panel .selectedNav').removeClass('showthumbnailimg');
  var $_navCell = $('.side-panel .navCell');
  var $cellLength = $_navCell.length;
  var $_flickityObj = {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'left',
    wrapAround: true};
  var $cellnotwraparound = true;

  if ($(window).width() > 481) {
    if ($cellLength > 5) {
  $('.side-panel .selectedNav').flickity($_flickityObj);
  $cellnotwraparound = false;
    }
  } else {
    if ($cellLength > 8) {
  $('.side-panel .selectedNav').flickity($_flickityObj);
  $cellnotwraparound = false;
    }
  }
  if ($cellnotwraparound) {
    $('.side-panel .selectedNav').addClass('showthumbnailimg');
  }

}

variantImageSwapqv = (color, bundle) =>{
setTimeout(() => {
  var $isShow = false;
  var $bundleColor = '';
  if (bundle) {
    var $selectedColor = $(".side-panel .swatch_options.bundle-child-swatch input:checked").first().val().toLowerCase();
  }else{
    var $selectedColor = color.toLowerCase();
  }
  if ($(".side-panel.product-drawer").find('.product-form__input--color:not(.--sticky) input[type="radio"]:checked').length > 1) {
    var bundlecolor = '';
    $(".side-panel.product-drawer").find('.product-form__input--color:not(.--sticky) input[type="radio"]:checked').each(function () {
      bundlecolor = bundlecolor + $(this).val().toLowerCase() + '-';
    });
    bundlecolor = bundlecolor.substring(0,bundlecolor.length - 1);
    $bundleColor = bundlecolor;
  }
  var $prodTitle = $('.side-panel.product-drawer .product-title').attr('data-title').toLowerCase();

  // Destroy slider
  $imgContainerQV.flickity();
  $imgContainerQV.flickity('destroy');
  $navContainerQV.flickity();
  $navContainerQV.flickity('destroy');

  // remove all product image
  $imgContainerQV.children().remove();
  $navContainerQV.children().remove();
  
  // Loop and append the correct cell
  for (var i = 0; i < $childArrayElementQV.length; i++) {
    var $thisAltText = $($childArrayElementQV[i]).attr('data-img-alt').toLowerCase();
    if ($childArrayElementQV[i].classList.contains('bundlevarimg')) {
      
    }else{
    if ($thisAltText == $selectedColor || $thisAltText == $bundleColor || $thisAltText == $prodTitle || $thisAltText.includes($selectedColor + "-textMain") || $thisAltText.includes($selectedColor + "-youtube") || $thisAltText.includes($selectedColor + "-vimeo")) {
      $imgContainerQV.append($childArrayElementQV[i]);
      $isShow = true;
    }
    }
  }

  // Loop and append the correct cell for nav img slider
  for (var i = 0; i < $navCellQV.length; i++) {
    var $thisAltText = $($navCellQV[i]).attr('data-img-alt').toLowerCase();
    if ($navCellQV[i].classList.contains('bundlevarimg')) {
      
    }else{
    if ($thisAltText == $selectedColor || $thisAltText == $bundleColor || $thisAltText == $prodTitle || $thisAltText.includes($selectedColor + "-textMain") || $thisAltText.includes($selectedColor + "-youtube") || $thisAltText.includes($selectedColor + "-vimeo")) {
      $navContainerQV.append($navCellQV[i]);
    }
    }
  }

  if ($(".side-panel.product-drawer .prod-bundle-select").length <= 0) {
  $(".side-panel .swatch_options.bundle-child-swatch input:checked").each(function (index) {
    var productIndex = index + 1;
    var $swatchchild = $(this).val().toLowerCase();

      for (var i = 0; i < $childArrayElementQV.length; i++) {
        if ($childArrayElementQV[i].classList.contains('bundlevarimg_' + productIndex)) {
        var $alt = $($childArrayElementQV[i]).attr('data-img-alt').toLowerCase();
          if (
            $alt == $swatchchild ||
            $alt == $prodTitle ||
            $alt.includes($swatchchild + "-textMain") ||
            $alt.includes($swatchchild + "-youtube") ||
            $alt.includes($swatchchild + "-vimeo")
          ) {
            console.log($childArrayElementQV[i]);
            $imgContainerQV.append($childArrayElementQV[i]);
          }
        }
      }

      for (var i = 0; i < $navCellQV.length; i++) {
        if ($navCellQV[i].classList.contains('bundlevarimg_' + productIndex)) {
        var $alt = $($navCellQV[i]).attr('data-img-alt').toLowerCase();
          if (
            $alt == $swatchchild ||
            $alt == $prodTitle ||
            $alt.includes($swatchchild + "-textMain") ||
            $alt.includes($swatchchild + "-youtube") ||
            $alt.includes($swatchchild + "-vimeo")
          ) {
            $navContainerQV.append($navCellQV[i]);
          }
        }
      }
  });
  }else{

    $(".side-panel .prod-bundle-select .swatch_options.bundle-child-swatch .swatchbundlecol input:checked").each(function (index) {
      var productIndex = index + 1;
      var $swatchchild = $(this).val().toLowerCase();
      var swatchprodid = $(this).attr('data-product-id');
  
        for (var i = 0; i < $childArrayElementQV.length; i++) {
          if ($childArrayElementQV[i].classList.contains('bundlevarimg_' + swatchprodid)) {
          var $alt = $($childArrayElementQV[i]).attr('data-img-alt').toLowerCase();
            if (
              $alt == $swatchchild ||
              $alt == $prodTitle ||
              $alt.includes($swatchchild + "-textMain") ||
              $alt.includes($swatchchild + "-youtube") ||
              $alt.includes($swatchchild + "-vimeo")
            ) {
              $imgContainerQV.append($childArrayElementQV[i]);
            }
          }
        }
  
        for (var i = 0; i < $navCellQV.length; i++) {
          if ($navCellQV[i].classList.contains('bundlevarimg_' + swatchprodid)) {
          var $alt = $($navCellQV[i]).attr('data-img-alt').toLowerCase();
            if (
              $alt == $swatchchild ||
              $alt == $prodTitle ||
              $alt.includes($swatchchild + "-textMain") ||
              $alt.includes($swatchchild + "-youtube") ||
              $alt.includes($swatchchild + "-vimeo")
            ) {
              $navContainerQV.append($navCellQV[i]);
            }
          }
        }
    });
  }
  
  //initiate flickity function
  var obj = {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'center',
    wrapAround: true};

  $imgContainerQV.flickity(obj);

  // Flickity instance
  var flkty = $imgContainerQV.data('flickity');
  // elements
  var $cellButtonGroup = $('.side-panel .selectedNav');
  var $cellButtons = $cellButtonGroup.find('.navCell');

  // update selected cellButtons
  $imgContainerQV.on( 'select.flickity', function() {
    $cellButtons.filter('.is-selected')
      .removeClass('is-selected');
    $cellButtons.eq( flkty.selectedIndex )
      .addClass('is-selected');
    if ($(this).find('.is-selected').find('video').length > 0) {
      $(this).find('.is-selected').find('video')[0].play();
    }
  });

  // select cell on button click
  $cellButtonGroup.on( 'click', '.navCell', function() {
    var index = $(this).index();
    $imgContainerQV.flickity( 'select', index );
  });

  $('.side-panel .selectedNav').removeClass('showthumbnailimg');
  var $_navCell = $('.side-panel .navCell');
  var $cellLength = $_navCell.length;
  var $_flickityObj = {
    prevNextButtons: false,
    pageDots: false,
    cellAlign: 'left',
    wrapAround: true};
  var $cellnotwraparound = true;

  if ($(window).width() > 481) {
    if ($cellLength > 5) {
  $('.side-panel .selectedNav').flickity($_flickityObj);
  $cellnotwraparound = false;
    }
  } else {
    if ($cellLength > 4) {
  $('.side-panel .selectedNav').flickity($_flickityObj);
  $cellnotwraparound = false;
    }
  }
  if ($cellnotwraparound) {
    $('.side-panel .selectedNav').addClass('showthumbnailimg');
  }

}, 1);

}
//swap variant image quick view - end

openclosesearchmobile = (page_title) => {
  var $headerSearchMobile = $('.header-search-mobile');
  var $img = $('.header-search-wrap.header-search-mob-icon .svg-search');
  var $svgpath = $('.header-search-wrap.header-search-mob-icon .svg-search path');
  var $greenIcon = $('.header-search-wrap.header-search-mob-icon .jsc-close-green');
  var $searchIcon = $('.header-search-wrap.header-search-mob-icon .search-icon');
  var $searchIconColor = $('.header-search-wrap.header-search-mobile .search-icon .jsc-colour-page');

  var $searchInnerIcon = $('.search-icon .cls-1.jsc-colour-page');
  var $headerSearchMobile = $('.header-search-mobile');

  var screenWidth = window.innerWidth;
  var $mobileToggleWrapper = $('.mobile-toggle-wrapper.active');
  var color_page = false;

  if ($mobileToggleWrapper.length > 0) {
    var mobileToggleWrapperIsOpen = true;
  } else {
    var mobileToggleWrapperIsOpen = false;
  }
  
  if (page_title.includes("Addresses") || page_title.includes("Terms of Service") || page_title.includes("Privacy Policy")) {
    // var $img = $('.header-search-wrap.header-search-mob-icon .svg-search.jsc-close-white');
    var color_page = true;
  }
  $headerSearchMobile.toggleClass('active');
  $('.main-header-content').toggle();

  if ($headerSearchMobile.is(':visible')) {
    // Add overlay when search mobile is active
    $('body').addClass('search-mobile-overlay-active');
    if(color_page){
      $img.removeClass('hide');
      $searchIcon.hide();
    }else{
      $img.removeClass('hide');
      $searchIcon.hide();
    }
  } else {
    // Remove overlay when closing
    $('body').removeClass('search-mobile-overlay-active');
    // Clear search input when closing
    $('.header-search-form #side-panel-search-input').val('');
    // Hide predictive search results
    $('.predictive-search-custom .side-panel-content--has-tabs').removeClass('active');
    if(color_page){
      $img.addClass('hide');
      $searchIcon.show();
    }else{
      $img.addClass('hide');
      $searchIcon.show();
    }
  }
}

carouselHeight = () =>{
  $('.featured-collection-carousel');
}

//Start: grid height
updateGridHeight = () => {
  $('.featured-collection-carousel').find('.carousel__slide').find('.product-card-title, .price, .jsc-preorder-grid-ship').css("height","auto");
  $('.featured-collection-carousel').each(function(){
    var $this = $(this);
    var $maxHeight = 0;
    var $maxprodInfo = 0;
    var $maxPriceHeight = 0;
    var $maxShipHeight = 0;
    $(this).find('.carousel__slide').each(function(){
      var $thisGrid = $(this);
      var $ConTentHeight = $thisGrid.find('.product-card-title').height();
      if ($maxHeight < $ConTentHeight) {
        $maxHeight = $ConTentHeight;
      }
      var $prodInfo = $thisGrid.find('.product-card-info').height();
      if ($maxprodInfo < $prodInfo) {
        $maxprodInfo = $prodInfo;
      }
      var $priceHeight = $thisGrid.find('.price').height();
      if ($maxPriceHeight < $priceHeight) {
        $maxPriceHeight = $priceHeight;
      }
      var $shipHeight = $thisGrid.find('.jsc-preorder-grid-ship').outerHeight() || 0;
      if ($maxShipHeight < $shipHeight) {
        $maxShipHeight = $shipHeight;
      }
    });
    $this.find('.carousel__slide').find('.product-card-title').css("height", $maxHeight + "px");
    $this.find('.carousel__slide').find('.product-card-info').css("height", $maxprodInfo + "px");
    $this.find('.carousel__slide').find('.price').css("height", $maxPriceHeight + "px");
    $this.find('.carousel__slide').find('.jsc-preorder-grid-ship').css("height", $maxShipHeight + "px");

  });

  var prevWidth = window.innerWidth;
  $( window ).resize(function() {
    var width = window.innerWidth;
    if (width !== prevWidth) {
    $('.featured-collection-carousel').find('.carousel__slide').find('.product-card-title, .price, .jsc-preorder-grid-ship').removeAttr("style");
    $('.featured-collection-carousel').find('.carousel__slide').find('.product-card-info').removeAttr("style");

    setTimeout(function(){
      $('.featured-collection-carousel').each(function(){
        var $this = $(this);
        var $maxHeight = 0;
        var $maxprodInfo = 0;
        var $maxPriceHeight = 0;
        var $maxShipHeight = 0;
        $(this).find('.carousel__slide').each(function(){
          var $thisGrid = $(this);
          var $ConTentHeight = $thisGrid.find('.product-card-title').height();
          if ($maxHeight < $ConTentHeight) {
            $maxHeight = $ConTentHeight;
          }
          var $prodInfo = $thisGrid.find('.product-card-info').height();
          if ($maxprodInfo < $prodInfo) {
            $maxprodInfo = $prodInfo;
          }
          var $priceHeight = $thisGrid.find('.price').height();
          if ($maxPriceHeight < $priceHeight) {
            $maxPriceHeight = $priceHeight;
          }
          var $shipHeight = $thisGrid.find('.jsc-preorder-grid-ship').outerHeight() || 0;
          if ($maxShipHeight < $shipHeight) {
            $maxShipHeight = $shipHeight;
          }
        });
        $this.find('.carousel__slide').find('.product-card-title').css("height", $maxHeight + "px");
        $this.find('.carousel__slide').find('.product-card-info').css("height", $maxprodInfo + "px");
        $this.find('.carousel__slide').find('.price').css("height", $maxPriceHeight + "px");
        $this.find('.carousel__slide').find('.jsc-preorder-grid-ship').css("height", $maxShipHeight + "px");
      });
    },1000);

    }

  });

}
updateGridHeightcollection = () => {
  $('.collection-container').find('.product-card').find('.product-card-title, .jsc-preorder-grid-ship').css("height","auto");
  $('.collection-container').each(function(){
    var $this = $(this);
    var $maxHeight = 0;
    var $maxprodInfo = 0;
    var $maxShipHeight = 0;
    $(this).find('.product-card').each(function(){
      var $thisGrid = $(this);
      var $ConTentHeight = $thisGrid.find('.product-card-title').height();
      if ($maxHeight < $ConTentHeight) {
        $maxHeight = $ConTentHeight;
      }
      var $prodInfo = $thisGrid.find('.product-card-info').height();
      if ($maxprodInfo < $prodInfo) {
        $maxprodInfo = $prodInfo;
      }
      var $shipHeight = $thisGrid.find('.jsc-preorder-grid-ship').outerHeight() || 0;
      if ($maxShipHeight < $shipHeight) {
        $maxShipHeight = $shipHeight;
      }
    });
    $this.find('.product-card').find('.product-card-title').css("height", $maxHeight + "px");
    $this.find('.product-card').find('.jsc-preorder-grid-ship').css("height", $maxShipHeight + "px");

  });

  var prevWidth = window.innerWidth;
  $( window ).resize(function() {
    var width = window.innerWidth;
    if (width !== prevWidth) {
    $('.collection-container').find('.product-card').find('.product-card-title, .jsc-preorder-grid-ship').removeAttr("style");

    setTimeout(function(){
      $('.collection-container').each(function(){
        var $this = $(this);
        var $maxHeight = 0;
        var $maxprodInfo = 0;
        var $maxShipHeight = 0;
        $(this).find('.product-card').each(function(){
          var $thisGrid = $(this);
          var $ConTentHeight = $thisGrid.find('.product-card-title').height();
          if ($maxHeight < $ConTentHeight) {
            $maxHeight = $ConTentHeight;
          }
          var $prodInfo = $thisGrid.find('.product-card-info').height();
          if ($maxprodInfo < $prodInfo) {
            $maxprodInfo = $prodInfo;
          }
          var $shipHeight = $thisGrid.find('.jsc-preorder-grid-ship').outerHeight() || 0;
          if ($maxShipHeight < $shipHeight) {
            $maxShipHeight = $shipHeight;
          }
        });
        $this.find('.product-card').find('.product-card-title').css("height", $maxHeight + "px");
        $this.find('.product-card').find('.jsc-preorder-grid-ship').css("height", $maxShipHeight + "px");
      });
    },1000);
    }

  });

}
updateGridHeightrecommendation = () => {
  $('.product-recommendations').find('.product-card').find('.product-card-title, .jsc-preorder-grid-ship').css("height","auto");
  $('.product-recommendations').each(function(){
    var $this = $(this);
    var $maxHeight = 0;
    var $maxprodInfo = 0;
    var $maxShipHeight = 0;
    $(this).find('.product-card').each(function(){
      var $thisGrid = $(this);
      var $ConTentHeight = $thisGrid.find('.product-card-title').height();
      if ($maxHeight < $ConTentHeight) {
        $maxHeight = $ConTentHeight;
      }
      var $prodInfo = $thisGrid.find('.product-card-info').height();
      if ($maxprodInfo < $prodInfo) {
        $maxprodInfo = $prodInfo;
      }
      var $shipHeight = $thisGrid.find('.jsc-preorder-grid-ship').outerHeight() || 0;
      if ($maxShipHeight < $shipHeight) {
        $maxShipHeight = $shipHeight;
      }
    });
    $this.find('.product-card').find('.product-card-title').css("height", $maxHeight + "px");
    $this.find('.product-card').find('.jsc-preorder-grid-ship').css("height", $maxShipHeight + "px");

  });

  var prevWidth = window.innerWidth;
  $( window ).resize(function() {
    var width = window.innerWidth;
    if (width !== prevWidth) {
    $('.product-recommendations').find('.product-card').find('.product-card-title, .jsc-preorder-grid-ship').removeAttr("style");

    setTimeout(function(){
      $('.product-recommendations').each(function(){
        var $this = $(this);
        var $maxHeight = 0;
        var $maxprodInfo = 0;
        var $maxShipHeight = 0;
        $(this).find('.product-card').each(function(){
          var $thisGrid = $(this);
          var $ConTentHeight = $thisGrid.find('.product-card-title').height();
          if ($maxHeight < $ConTentHeight) {
            $maxHeight = $ConTentHeight;
          }
          var $prodInfo = $thisGrid.find('.product-card-info').height();
          if ($maxprodInfo < $prodInfo) {
            $maxprodInfo = $prodInfo;
          }
          var $shipHeight = $thisGrid.find('.jsc-preorder-grid-ship').outerHeight() || 0;
          if ($maxShipHeight < $shipHeight) {
            $maxShipHeight = $shipHeight;
          }
        });
        $this.find('.product-card').find('.product-card-title').css("height", $maxHeight + "px");
        $this.find('.product-card').find('.jsc-preorder-grid-ship').css("height", $maxShipHeight + "px");
      });
    },1000);
  }

  });

}
//End: grid height

openMenuColor = () => {
  setTimeout(function(){
    $("#mobile-menu").addClass("menu-color");
  },500);
}

closeMenuColor = () =>{
  $("#mobile-menu").removeClass("menu-color");

}

//start: open mega menu from featured collection section
jscOpenMenu = (e, title, redirect, collectionURL) => {
  var $menuDrawer = $('.mobile-toggle-wrapper');

  var found = false;

  $menuDrawer.find('.jsc-link-container').each(function() {
    var $thisTitle = $(this).attr('data-title');

    if ($thisTitle == title && redirect == 'false') {
      // console.log(title, 'open this menu nav');
      $menuDrawer.addClass('active').attr('open', '');
      $('body').addClass('overflow-hidden');
      $(this).addClass('menu-opening').attr('open', '');
      $(this).addClass('submenu-open');
      $(this).parents('.mobile-menu-drawer').addClass('menu-color');
      $('#header').css("background","var(--hamburger-active-color)");
      $('#mobile-menu').css("background","var(--hamburger-active-color)");
      $('.jsc-account-menu').css("background","var(--hamburger-active-color)");
      found = true;
    }
  });

  if (!found) {
    if (redirect == 'true'){
      window.location.href = collectionURL;
    }else{
      $('a[title="' + title + '"]').each(function() {
        window.location.href = $(this).attr('href');
        return false;
      });
    }
  }
}
//end: open mega menu from featured collection section

//start: featured collection onload
// updateMobileImage = () => {
//   //start: to replace mobile image
//   if ($(window).width() < 481) {
//     $('.jsc-feat-coll-image').each(function(){
      
//       var $this_image = $(this).attr('data-mobile-image');
//       if ($this_image) {
//         $(this).find('img').attr('srcset',$this_image);
//         $(this).find('img').attr('src',$this_image);
//         if ($('.jsc-fc-slider-carousel').length == 0) {
//           $('.featured-collection-list--bg img, .featured-collection-list--bg svg').css({
//             'position': 'relative',
//             'display': 'none'
//           });
    
//           $('.featured-collection-list--inner').css({
//             'position': 'absolute',
//             'top': '0px'
//           });
    
//           $('.featured-collection-list--bg').css('position', 'relative');
//         }
//       }
//       $(this).find('img.feat-list-desk').remove();
//       setTimeout(function () {
//         $('.feat-list-mob').removeClass('feat-list-mob');
//         $('.feat-list-desk').removeClass('feat-list-desk');
//         if ($('.jsc-fc-slider-carousel').length > 0) {
//           $('.jsc-feat-coll-image').removeClass('hide');
//         }
//       }, 10);
//     });
//   }else{
//     $('.jsc-feat-coll-image').each(function(){

//       var $this_image = $(this).attr('data-desk-image');
//       if ($this_image) {
//         $(this).find('img').attr('srcset',$this_image);
//         $(this).find('img').attr('src',$this_image);
//         if ($('.jsc-fc-slider-carousel').length == 0) {
//           $('.featured-collection-list--bg img, .featured-collection-list--bg svg').css({
//             'position': 'absolute',
//             'display': 'unset'
//           });

//           $('.featured-collection-list--inner').css({
//             'position': 'relative',
//             'top': '0px'
//           }); 

//           $('.featured-collection-list--bg').css('position', 'absolute');
//         }
//       }
//       $(this).find('img.feat-list-mob').remove();
//       setTimeout(function () {
//         $('.feat-list-mob').removeClass('feat-list-mob');
//         $('.feat-list-desk').removeClass('feat-list-desk');
//         if ($('.jsc-fc-slider-carousel').length > 0) {
//           $('.jsc-feat-coll-image').removeClass('hide');
//         }
//       }, 10);
//     });
//   }
//   var prevWidth = window.innerWidth;
//   $(window).resize(function(){
//     var width = window.innerWidth;
//     if (width !== prevWidth) {
//     if ($(window).width() < 481) {
//       $('.jsc-feat-coll-image').each(function(){
        
//         var $this_image = $(this).attr('data-mobile-image');
//         if ($this_image) {
//           $(this).find('img').attr('srcset',$this_image);
//           $(this).find('img').attr('src',$this_image);
//           if ($('.jsc-fc-slider-carousel').length == 0) {
//             $('.featured-collection-list--bg img, .featured-collection-list--bg svg').css({
//               'position': 'relative',
//               'display': 'none'
//             });
//             $('.featured-collection-list--inner').css({
//               'position': 'absolute',
//               'top': '0px'
//             });
//             $('.featured-collection-list--bg').css('position', 'relative');
//           }
//         }
//       });
//     }else{
//       $('.jsc-feat-coll-image').each(function(){
        
//         var $this_image = $(this).attr('data-desk-image');
//         if ($this_image) {
//           $(this).find('img').attr('srcset',$this_image);
//           $(this).find('img').attr('src',$this_image);
//             if ($('.jsc-fc-slider-carousel').length == 0) {
//             $('.featured-collection-list--bg img, .featured-collection-list--bg svg').css({
//               'position': 'absolute',
//               'display': 'unset'
//             });

//             $('.featured-collection-list--inner').css({
//               'position': 'relative',
//               'top': '0px'
//             }); 

//             $('.featured-collection-list--bg').css('position', 'absolute');
//           }
//         }
//       });
//     }
//   }
//   });
//   //end: to replace mobile image
// }
//end: featured collection onload

//Start: store link list
onloadStoreLink = () =>{ 
  var storeLinkSelected = sessionStorage.getItem("storeLink"); 
  var urlParams = new URLSearchParams(window.location.search);
  var hasGlobalParam = urlParams.has('global');
  var countryParam = urlParams.get('country');
  
  // Country flag image mapping
  var countryFlagMap = {
    'MY': 'https://cdn.shopify.com/s/files/1/0207/5974/0480/files/msia.png?v=1773196804',
    'AU': 'https://cdn.shopify.com/s/files/1/0207/5974/0480/files/australia.png?v=1773196804',
    'TW': 'https://cdn.shopify.com/s/files/1/0207/5974/0480/files/taiwan.png?v=1773196804',
    'HK': 'https://cdn.shopify.com/s/files/1/0207/5974/0480/files/HK.png?v=1773196804',
    'NZ': 'https://cdn.shopify.com/s/files/1/0207/5974/0480/files/NZ.png?v=1773196803',
    'US': 'https://cdn.shopify.com/s/files/1/0207/5974/0480/files/USA.webp?v=1774316775',
    'SG': 'https://cdn.shopify.com/s/files/1/0716/6912/1303/files/Country_flags-02.png?v=1698127816',
    'Global': 'https://cdn.shopify.com/s/files/1/0716/6912/1303/files/global.png?v=1698136264'
  };
  
  // Check URL parameter first (takes priority)
  if (hasGlobalParam) {
    sessionStorage.setItem("storeLink", 'Global');
    storeLinkSelected = 'Global';
    
    // Remove ?global from URL after saving to sessionStorage
    urlParams.delete('global');
    var newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    history.replaceState(null, '', newUrl);
  } else if (countryParam) {
    // Handle country parameter (MY, AU, TW, HK, NZ, US)
    sessionStorage.setItem("storeLink", countryParam);
    storeLinkSelected = countryParam;
    
    // Remove ?country from URL after saving to sessionStorage
    urlParams.delete('country');
    var newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    history.replaceState(null, '', newUrl);
  }
  
  // Apply selection UI updates (with small delay to ensure DOM is ready)
  setTimeout(function() {
    if (storeLinkSelected) {
      // Remove all active states first
      $('.store_active').removeClass('store_active');
      
      if (storeLinkSelected == 'Global') {
        // Apply Global selection
        $('.store_link_selected .everett-light-r').text('Global'); 
        $('.global_selected').addClass('store_active');
        $('.img_store_flag').attr('src', countryFlagMap['Global']);
      } else if (countryFlagMap[storeLinkSelected]) {
        // Apply country selection (MY, AU, TW, HK, NZ, US, SG)
        $('.store_link_selected .everett-light-r').text(storeLinkSelected);
        $('.img_store_flag').attr('src', countryFlagMap[storeLinkSelected]);
        
        // Add active class to the matching list item
        $('.shopLinkList li[data-store="' + storeLinkSelected + '"]').addClass('store_active');
      }
    }
  }, 100);
} 
onClickStoreLink = (evt) =>{ 
  var store = $(evt).attr('data-store');
  var country = $(evt).attr('data-country');
  var href = $(evt).attr('data-href');
  sessionStorage.setItem("storeLink", store);
  console.log(href);
  
  // Map store codes to country ISO codes for currency selector
  var countryCodeMap = {
    'SG': 'SG',
    'TH': 'TH',
    'ID': 'ID',
    'PH': 'PH',
    'JP': 'JP',
    'MY': 'MY',
    'AU': 'AU',
    'TW': 'TW',
    'HK': 'HK',
    'NZ': 'NZ',
    'US': 'US',
    'Global': 'SG' // Default to SG for Global
  };
  
  // Update currency selector if country code is available
  if (country && countryCodeMap[country]) {
    var countryCode = countryCodeMap[country];
    var currencySelect = $('.jsc-select-currency select.thb-currency-code');
    
    // Try to find and select the matching country in currency selector
    if (currencySelect.length > 0) {
      var optionFound = false;
      currencySelect.find('option').each(function() {
        var optionValue = $(this).val();
        if (optionValue === countryCode) {
          currencySelect.val(countryCode);
          optionFound = true;
          return false; // break loop
        }
      });
      
      // If exact match not found, try to find by country name
      if (!optionFound && country !== 'Global') {
        currencySelect.find('option').each(function() {
          var optionText = $(this).text().toUpperCase();
          if (optionText.indexOf(countryCode) !== -1) {
            currencySelect.val($(this).val());
            return false; // break loop
          }
        });
      }
    }
  }
  
  // If selecting Global and already on SG domain, no need for ?global parameter
  if (store === 'Global' && window.location.hostname === 'www.beyondthevines.com') {
    window.location.href = 'https://www.beyondthevines.com/';
  } else {
    window.location.href = href;
  }
}
opencloseStore = (evt) =>{ 
  $(evt).siblings('.shopLinkList').toggle();
  $('[onclick="opencloseCurrency(this);"]').siblings('.currencyList').hide();
}
//end: store link list

//Start: currency list
opencloseCurrency = (evt) =>{ 
  $(evt).siblings('.currencyList').toggle();
  $('[onclick="opencloseStore(this);"]').siblings('.shopLinkList').hide();
}
changeCurrency = (evt) =>{ 
  $(evt).parents('.currencyList').siblings('select').val($(evt).attr('data-value')).change();
  setTimeout(function () {
    $(evt).parents('form').submit();
  }, 10);
}
//end: currency list

//Start: vip disabled ATC
swapvipcheck = (disabled,firstLoad) =>{ 
  setTimeout(function () {
  $('.product-grid-container .product-information--inner').each(function () {
    var thisprodInfo = $(this);
    var $mainProductOnly = function(sel) { return thisprodInfo.find(sel).filter(function() { return $(this).closest('.jsc-pwp-pdp-section').length === 0; }); };
    var vipVar = false;
    var bishide = false;
    var forcecomingsoon = false;
    console.log('swapvipcheck');
    var selectedVarId = thisprodInfo.find(".variant-selected-form").val();
    var availableAtcLabel = (typeof window.jscGetAtcLabel === 'function') ? window.jscGetAtcLabel(selectedVarId) : 'Add To Bag';
    if ($mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").hasClass('sold-out') || disabled) {
      //console.log('sold out');
    }else{
    $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
    $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
    $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
    $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").find(".single-add-to-cart-button--text").text(availableAtcLabel);
    //For add to cart sticky
    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
    $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(availableAtcLabel);
    //Add to bag and direct to cart page button
    $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
    $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").removeAttr('disabled');
    }
    thisprodInfo.find(".variant-list-data").each(function () {
      var datavarid = $(this).attr('data-var-id');
      var datavip = $(this).attr('data-vip');
      var dataavai = $(this).attr('data-var-avail');
      var showcomingsoonwheninstock = $(this).attr('showcomingsoonwheninstock');
      if (datavarid == thisprodInfo.find(".variant-selected-form").val() && showcomingsoonwheninstock == 'true') {
        forcecomingsoon = true;
        var dataLaunchDateTime = $(this).attr('data-launch-time-date');
        $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
        $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
        $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
        if(dataLaunchDateTime != '' && dataLaunchDateTime){
          $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").find(".single-add-to-cart-button--text").text(dataLaunchDateTime);
        }else{
          $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").find(".single-add-to-cart-button--text").text('Coming Soon');
        }
        $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
        $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
        $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
        //Add to bag and direct to cart page button
        $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
        $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
      }else{
        //check each if the variant is VIP if VIP check whether VIP customer is login.
        if (datavarid == thisprodInfo.find(".variant-selected-form").val() && datavip) {
          if (datavip == 'true') {
            vipVar = true;
            if ($("#vipCustomer").length >= 1 && dataavai == 'true') {
              $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
              $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
              $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
              $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").find(".single-add-to-cart-button--text").text(availableAtcLabel);
              //For add to cart sticky
              $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
              $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
              $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(availableAtcLabel);
              //Add to bag and direct to cart page button
              $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
              $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").removeAttr('disabled');
            }else{
              var dataLaunchDateTime = $(this).attr('data-launch-time-date');
              $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
              $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
              $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
              $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").find(".single-add-to-cart-button--text").text(dataLaunchDateTime);
              //For add to cart sticky
              $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
              $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
              $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(dataLaunchDateTime);
              //Add to bag and direct to cart page button
              $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
              $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
            }
          }
        }
        //Hide/Show PWP Section
        var dataPWP = $(this).attr('data-pwp-show');
        if (datavarid == thisprodInfo.find(".variant-selected-form").val()) {
          if (dataPWP == 'true') {
            $("#jsc-pwp-section").show();
          }else{
            $("#jsc-pwp-section").hide();
          }
        }

        var databishide = $(this).attr('data-bis-hide');
        if (datavarid == thisprodInfo.find(".variant-selected-form").val()) {
          if (databishide == 'true') {
            bishide = true;
          }
        }
        if (thisprodInfo.find(".bis-hidden-prod").length > 0) {
          bishide = true;
        }
      }
    });
    if (vipVar == false) {
      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").removeClass('vip_atc');
      //For add to cart sticky
      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('vip_atc');

      if (firstLoad == true) {
        if ($mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").hasClass('sold-out')) {
          $mainProductOnly('.product-form__input--color input[type="radio"]:checked').addClass('is-disabled');
          $('.product-add-to-cart-sticky--content').find('.product-form__input--color input[type="radio"]:checked').addClass('is-disabled');
          thisprodInfo.find(".swym-bid-pdp").show();
          $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").hide();
          $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
          //For add to cart sticky
          $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").show();
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").hide();
          //Add to bag and direct to cart page button
          $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").hide()
          if (bishide) {
            thisprodInfo.find(".swym-bid-pdp").hide();
            $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").show();
            thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
            //For add to cart sticky
            $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
            $('.product-add-to-cart-sticky--content').find(".shopify-payment-button:not(.bundle-atc)").show();
            //Add to bag and direct to cart page button
            $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").show();
          }
          if (forcecomingsoon) {
            thisprodInfo.find(".swym-bid-pdp").hide();
            $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").show();
            //For add to cart sticky
            $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
            //Add to bag and direct to cart page button
            $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").show();
          }
        }else{
          thisprodInfo.find(".swym-bid-pdp").hide();
          $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").show();
          thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
          //For add to cart sticky
          $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
          $('.product-add-to-cart-sticky--content').find(".shopify-payment-button:not(.bundle-atc)").show();
          //Add to bag and direct to cart page button
          $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").show();
          enablePWPATC();
        }
      }else{
        if (disabled) {
          $mainProductOnly('.product-form__input--color input[type="radio"]:checked').addClass('is-disabled');
          $('.product-add-to-cart-sticky--content').find('.product-form__input--color input[type="radio"]:checked').addClass('is-disabled');
          thisprodInfo.find(".swym-bid-pdp").show();
          $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").hide();
          thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").hide();
          //For add to cart sticky
          $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").show();
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").hide();
          $('.product-add-to-cart-sticky--content').find(".shopify-payment-button:not(.bundle-atc)").hide();
          //Add to bag and direct to cart page button
          $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").hide();
          if (bishide) {
            thisprodInfo.find(".swym-bid-pdp").hide();
            $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").show();
            thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
            //For add to cart sticky
            $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
            $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
            $('.product-add-to-cart-sticky--content').find(".shopify-payment-button:not(.bundle-atc)").show();
            //Add to bag and direct to cart page button
            $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").show();
          }
        }else{
          thisprodInfo.find(".swym-bid-pdp").hide();
          $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").show();
          thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
          //For add to cart sticky
          $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
          $('.product-add-to-cart-sticky--content').find(".shopify-payment-button:not(.bundle-atc)").show();
          //Add to bag and direct to cart page button
          $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)").show();
          enablePWPATC();
        }
      }
    }else{
      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").addClass('vip_atc');
      thisprodInfo.find(".swym-bid-pdp").hide();
      $mainProductOnly(".single-add-to-cart-button:not(.bundle-atc)").show();
      thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
      //For add to cart sticky
      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('vip_atc');
      $('.product-add-to-cart-sticky--content').find(".swym-bid-pdp").hide();
      $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").show();
      $('.product-add-to-cart-sticky--content').find(".shopify-payment-button:not(.bundle-atc)").show();

      var $buyNowBtn = $mainProductOnly(".jsc-buy-it-now-button:not(.bundle-atc)");
      var isComingSoon = $buyNowBtn.attr("data-is-coming-soon") === "true";

      if (isComingSoon) {
        $buyNowBtn.hide();
        $buyNowBtn.addClass("jsc-sold-out-styling");
        $buyNowBtn.attr("disabled", "disabled");
      } else {
        $buyNowBtn.show();
        $buyNowBtn.removeClass("jsc-sold-out-styling");
        $buyNowBtn.removeAttr("disabled");
      }
      enablePWPATC();
    }
    if (typeof window.jscApplyPreorderUI === 'function' && selectedVarId) {
      window.jscApplyPreorderUI(selectedVarId, thisprodInfo);
    }
  });
  }, 10);
}

swapvipcheckGrid = (disabled) =>{ 
  $('.side-panel-inner .product-information--inner').each(function () {
    var thisprodInfo = $(this);
    var vipVar = false;
    var bishide = false;
    console.log('swapvipcheckGrid');
    var selectedVarId = thisprodInfo.find(".variant-selected-form").val();
    var availableAtcLabel = (typeof window.jscGetAtcLabel === 'function') ? window.jscGetAtcLabel(selectedVarId) : 'Add To Bag';
    if (thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").hasClass('sold-out') || disabled) {
      //console.log('sold out');
    }else{
    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
    $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
    thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(availableAtcLabel);
    //Add to bag and direct to cart page button
    thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
    thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").removeAttr('disabled');
    }
    thisprodInfo.find(".variant-list-data").each(function () {
      var datavarid = $(this).attr('data-var-id');
      var datavip = $(this).attr('data-vip');
      var dataavai = $(this).attr('data-var-avail');
      var dataLaunchDateTime = $(this).attr('data-launch-time-date');
      //check each if the variant is VIP if VIP check whether VIP customer is login.
      if (datavarid == thisprodInfo.find(".variant-selected-form").val() && datavip) {
        if (datavip == 'true') {
          vipVar = true;
          if ($("#vipCustomer").length >= 1 && dataavai == 'true') {
            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
            $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeAttr('disabled');
            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(availableAtcLabel);
            //Add to bag and direct to cart page button
            thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
            thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").removeAttr('disabled');
          }else{
            console.log("here22", dataLaunchDateTime);
            console.log(thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)"));
            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
            $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
            thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text(dataLaunchDateTime);
            //Add to bag and direct to cart page button
            thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
            thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
          }
        }
      }

      var databishide = $(this).attr('data-bis-hide');
      if (datavarid == thisprodInfo.find(".variant-selected-form").val()) {
        if (databishide == 'true') {
          bishide = true;
        }
      }
      if (thisprodInfo.find(".bis-hidden-prod").length > 0) {
        bishide = true;
      }
    });
    if (vipVar == false) {
      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").removeClass('vip_atc');
      if (thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").hasClass('sold-out') || disabled) {
        thisprodInfo.find(".swym-bid-qv").show();
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").hide();
        thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").hide();
        //Add to bag and direct to cart page button
        thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").hide();
        if (bishide) {
          thisprodInfo.find(".swym-bid-qv").hide();
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
          thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
          //Add to bag and direct to cart page button
          thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").show();
        }
      }else{
        thisprodInfo.find(".swym-bid-qv").hide();
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
        thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
        //Add to bag and direct to cart page button
        thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").show();
        enablePWPATC();
      }
    }else{
      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('vip_atc');
      thisprodInfo.find(".swym-bid-qv").hide();
      thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").show();
      thisprodInfo.find(".shopify-payment-button:not(.bundle-atc)").show();
      //Add to bag and direct to cart page button
      thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").show();
      enablePWPATC();
    }
    $('.var-limit-list').each(function(){
      var varID = $(this).val();
      if (varID == thisprodInfo.find(".variant-selected-form").val()) {
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
        $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
        //Add to bag and direct to cart page button
        thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
        thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
      }
    });
    $('.var-limit-product-list').each(function(){
      var varID = $(this).val();
      if (varID == thisprodInfo.find(".variant-selected-form").attr('data-prod-id')) {
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
        $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
        thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
        //Add to bag and direct to cart page button
        thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
        thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
      }
    });
    if (thisprodInfo.find('.jsc-mask-popup.jsc-embroidery').length > 0) {
      jscUpdateEmbroideryPersonalizeAtc(thisprodInfo);
    }
    if (typeof window.jscApplyPreorderUI === 'function' && selectedVarId) {
      window.jscApplyPreorderUI(selectedVarId, thisprodInfo);
    }
  });
}
//end: vip disabled ATC

//Start: Open BIS PDP
openBIS = (evt) =>{ 
  $('button.swym-add-to-watchlist').click();
}
//end: Open BIS PDP

//Start: sort list
opencloseSort = (evt) =>{
  var screenWidth = window.innerWidth;
  if (screenWidth <= 768) {
    $(evt).toggleClass('sort-button-open');
    $(evt).parent().find('.currencyList').toggle().toggleClass('sortList');
  } else {
    $(evt).siblings('.currencyList').toggle();
  }
}
changeSort = (evt) =>{ 
  $(evt).parents('.currencyList').siblings('select').val($(evt).attr('data-value')).change();
  setTimeout(function () {
    $(evt).parents('form').submit();
  }, 10);
}
//end: sort list

handleSortResize = () => {
  $('.currencyList').removeClass('sortList').hide(); // Hide to ensure it does not remain visible
  $('.sort-button-open').removeClass('sort-button-open');
}

var prevWidth = window.innerWidth;
$( window ).resize(function() {
  var width = window.innerWidth;
  if (width !== prevWidth) {
  handleSortResize();
}
});

// Start - CartJS Function
// const cartJSEvent = () => {
//   console.log('Binding cart.requestStarted and cart.requestComplete');
  
//   // Use vanilla JS as fallback if jQuery methods aren't working consistently
//   try {
//     // Try jQuery method first
//     $(document).on('cart.requestStarted', function(event, cart) {
//     console.log('cart.requestStarted fired');
//     var $html = `<div class="jsc-page-loading">
//       <div class="jsc-spinner-container">
//         <div class="jsc-spinner"></div>
//       </div>
//     </div>`;
//     $('body').prepend($html);
//     });
//     console.log('Successfully bound cart.requestStarted event with jQuery');
//   } catch (error) {
//     console.error('Error binding cart.requestStarted with jQuery:', error);
//     // Fallback to vanilla JS event handling if needed
//     document.addEventListener('cart.requestStarted', function(event) {
//       console.log('cart.requestStarted fired (vanilla JS)');
//       var html = '<div class="jsc-page-loading"><div class="jsc-spinner-container"><div class="jsc-spinner"></div></div></div>';
//       document.body.insertAdjacentHTML('afterbegin', html);
//     });
//   }
  
//   try {
//     // Try jQuery method first
//     $(document).on('cart.requestComplete', function(event, cart) {
//     console.log('cart.requestComplete fired');
//     $('.jsc-page-loading').remove();
    
//     if ($('#Cart-Drawer').length > 0) {
//       document.dispatchEvent(new CustomEvent('customcart:refresh'));
//     }
    
//     if ($('.main-cart-section').length > 0) {
//       document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
//     }
//     });
//     console.log('Successfully bound cart.requestComplete event with jQuery');
//   } catch (error) {
//     console.error('Error binding cart.requestComplete with jQuery:', error);
//     // Fallback to vanilla JS event handling if needed
//     document.addEventListener('cart.requestComplete', function(event) {
//       console.log('cart.requestComplete fired (vanilla JS)');
//       document.querySelectorAll('.jsc-page-loading').forEach(function(el) {
//         el.remove();
//       });
      
//       if (document.getElementById('Cart-Drawer')) {
//         document.dispatchEvent(new CustomEvent('customcart:refresh'));
//       }
      
//       if (document.querySelector('.main-cart-section')) {
//         document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
//       }
//     });
//   }

//   // Additional check to verify events are properly bound
//   console.log('Cart events initialization complete');
// };

cartJSAddQuery = (vid, qty, prop, opendrawer) => {
  // Using ShopifyCartAPI instead of CartJS
  ShopifyCartAPI.addItems([{
    id: vid,
    quantity: qty,
    properties: prop
  }])
  .then(data => {
    console.log('Added item to cart');
  })
  .catch(error => {
    console.log("Error occur !", error);
  });
}

cartJSAddSQuery = (jsonObj, quickatc) => {
  // Using ShopifyCartAPI instead of CartJS
  ShopifyCartAPI.addItems(jsonObj)
  .then(data => {
    console.log('success');
  })
  .catch(error => {
    console.log("Error occur !", error);
  });
}

cartJSUpdateQuery = (vid, qty, prop, isOpenDrawer) => {
  // Using ShopifyCartAPI instead of CartJS
  ShopifyCartAPI.changeItem(vid, qty, prop)
  .then(data => {
    console.log('Updated item in cart');
  })
  .catch(error => {
    console.log("Error occur !", error);
  });
}
// End - CartJS Function
// Re-add missing embroidery bundle children before removeGift; on add failure strip whole bind (data-remove-keys).
addEmbroideryBundleChildren = function(done) {
  var finish = typeof done === 'function' ? done : function() {};
  var $toAdd = $('.jsc-add-embroidery-bundle-child');
  if ($toAdd.length === 0) {
    finish();
    return;
  }
  if (typeof ShopifyCartAPI === 'undefined' || !ShopifyCartAPI.getCart || !ShopifyCartAPI.addItems) {
    $toAdd.each(function() {
      var $el = $(this);
      var vid = parseInt($el.val(), 10);
      var qty = parseInt($el.attr('data-quantity'), 10) || 1;
      var bindId = $el.attr('data-bind-id');
      if (!bindId || !vid) return;
      cartJSAddQuery(vid, qty, { '_Bind ID': bindId, '_Bundle Product': 'Child' });
    });
    finish();
    return;
  }
  ShopifyCartAPI.getCart()
    .then(function(cart) {
      var tasks = [];
      $toAdd.each(function() {
        var $el = $(this);
        var vid = parseInt($el.val(), 10);
        var qty = parseInt($el.attr('data-quantity'), 10) || 1;
        var bindId = $el.attr('data-bind-id');
        var removeKeys = $el.attr('data-remove-keys') || '';
        var props = { '_Bind ID': bindId, '_Bundle Product': 'Child' };
        if (!bindId || !vid) return;
        if (cartHasGift(cart, String(vid), props)) return;
        tasks.push({ vid: vid, qty: qty, props: props, removeKeys: removeKeys });
      });
      if (tasks.length === 0) {
        return Promise.resolve();
      }
      var p = Promise.resolve();
      tasks.forEach(function(t) {
        p = p.then(function() {
          return ShopifyCartAPI.addItems([{ id: t.vid, quantity: t.qty, properties: t.props }]).catch(function(err) {
            console.log('Embroidery bundle child add failed; removing embroidery children and clearing main bind props', err);
            var keys = (t.removeKeys || '').split(',').filter(Boolean);
            if (keys.length === 0) return;
            return ShopifyCartAPI.getCart().then(function(cart) {
              var mainItem = null;
              var childKeys = [];
              keys.forEach(function(k) {
                if (!cart || !cart.items) return;
                for (var i = 0; i < cart.items.length; i++) {
                  if (cart.items[i].key !== k) continue;
                  var props = cart.items[i].properties || {};
                  if (props['_Bundle Product'] === 'Main') {
                    mainItem = cart.items[i];
                  } else {
                    childKeys.push(k);
                  }
                  break;
                }
              });
              var removeChildren = Promise.all(
                childKeys.map(function(k) {
                  return ShopifyCartAPI.changeItem(k, 0, {}, {
                    showLoading: false,
                    hideLoading: false,
                    dispatchRefresh: false
                  });
                })
              );
              return removeChildren.then(function() {
                if (!mainItem) return;
                var variantId = mainItem.variant_id || mainItem.id;
                var qty = mainItem.quantity || 1;
                if (!variantId) return;
                return ShopifyCartAPI.changeItem(mainItem.key, 0, {}, {
                  showLoading: false,
                  hideLoading: false,
                  dispatchRefresh: false
                }).then(function() {
                  return ShopifyCartAPI.addItems([{ id: variantId, quantity: qty }], {
                    showLoading: false,
                    hideLoading: false,
                    dispatchRefresh: false
                  });
                });
              });
            }).then(function() {
              if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
                document.dispatchEvent(new CustomEvent('customcart:refresh'));
              }
              if ($('.main-cart-section').length > 0) {
                document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
              }
              document.dispatchEvent(new CustomEvent('cart:updated'));
            });
          });
        });
      });
      return p.then(function() {
        if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
          document.dispatchEvent(new CustomEvent('customcart:refresh'));
        }
        if ($('.main-cart-section').length > 0) {
          document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
    })
    .then(function() {
      finish();
    })
    .catch(function() {
      finish();
    });
};
// Start - Master Promo Function
masterPromo = () =>{
  console.log("Initialize cart request master promo");
  $(document).off('cart.requestStarted');
  $(document).off('cart.requestComplete');
  $(document).on('cart.requestStarted', function(event, cart) {
    console.log('cart.requestStarted fired');
    $('.jsc-page-loading').show();
  });
  
  $(document).on('cart.requestComplete', function(event, cart) {
    console.log('cart.requestComplete fired');
    $('.jsc-page-loading').hide();
    
    if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
    document.dispatchEvent(new CustomEvent('customcart:refresh'));
    }
    
    if ($('.main-cart-section').length > 0) {
    document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
    }
  });
  addEmbroideryBundleChildren(function() {
    addGift();
    removeGift();
    updateGift();
    removepacketgiftOnload();
    enablePWPATC();
    updateGiftWrap();
    removeMainProdLineItemProperties();
    removeGiftAndMainItemLineItemProperties();
    removeEmbroideryAndClearMain();
  });
}
// End - Master Promo Function
// Start - Packet Gift Function
removepacketgift = () =>{
  sessionStorage.setItem("redPacket", "Remove");
}
removepacketgiftOnload = () =>{
  if ($('.disabledoptout').length > 0) {
    sessionStorage.removeItem('redPacket');
  }
  var removeRED = sessionStorage.getItem("redPacket");
  if ($('.jsc-packet-gift').length > 0 && removeRED == 'Remove') {
    $('.jsc-packet-gift').each(function(){
      var varID = $(this).val();
      CartJS.updateItemById(varID, 0);
    });
  }
}
// End - Packet Gift Function
// Start - Gift Function
// Returns true if cart already has an item with this variant and matching gift properties
cartHasGift = (cart, varID, propObj) => {
  if (!cart || !cart.items || !Array.isArray(cart.items)) return false;
  var id = parseInt(varID, 10);
  for (var i = 0; i < cart.items.length; i++) {
    var item = cart.items[i];
    var vid = item.variant_id || item.id;
    if (vid != id) continue;
    var props = item.properties || {};
    var match = true;
    for (var k in propObj) {
      if (propObj.hasOwnProperty(k) && String(props[k]) !== String(propObj[k])) {
        match = false;
        break;
      }
    }
    if (match) return true;
  }
  return false;
};
addGift = () =>{
  if ($('.jsc-add-gift').length === 0) return;
  if (window._addGiftInProgress) return;
  window._addGiftInProgress = true;
  var addCandidates = [];
  $('.jsc-add-gift').each(function(){
    var varID = $(this).val();
    var varProp = $(this).attr("data-prop");
    var varqty = parseInt($(this).attr('data-quantity'), 10) || 1;
    var $obj = {};
    $obj['_Cart_GWP'] = 'Free Gift';
    var shouldAdd = false;
    if (varProp && varProp == 'packet') {
      var removeRED = sessionStorage.getItem("redPacket");
      $obj['_Cart_GWP_packet'] = 'True';
      shouldAdd = (removeRED != 'Remove');
    } else if (varProp && varProp == 'packet2') {
      var removeRED2 = sessionStorage.getItem("redPacket2");
      $obj['_Cart_GWP_packet2'] = 'True';
      shouldAdd = (removeRED2 != 'Remove');
    } else if (varProp && varProp == 'collab') {
      $obj['_Cart_GWP_Collab'] = $(this).attr("data-colab");
      shouldAdd = true;
    } else if (varProp && varProp == 'singletier') {
      $obj['_Cart_GWP_SingleTier'] = $(this).attr('data-tier') || '1';
      shouldAdd = true;
    } else if (varProp && varProp == 'multitier') {
      var tierValue = $(this).attr("data-tier");
      $obj['_Cart_GWP_MultiTier'] = tierValue;
      shouldAdd = true;
    } else if (varProp && varProp == 'multigwp') {
      $obj['_Cart_GWP_Multi'] = 'True';
      shouldAdd = true;
    } else {
      shouldAdd = true;
    }
    if (shouldAdd) {
      addCandidates.push({ varID: varID, varqty: varqty, prop: $obj });
    }
  });
  if (addCandidates.length === 0) {
    window._addGiftInProgress = false;
    return;
  }
  // Dedupe by variant + prop key so multiple same elements don't add twice in one run
  var seen = {};
  var toAdd = [];
  for (var c = 0; c < addCandidates.length; c++) {
    var key = addCandidates[c].varID + '|' + JSON.stringify(addCandidates[c].prop);
    if (seen[key]) continue;
    seen[key] = true;
    toAdd.push(addCandidates[c]);
  }
  var clearProgress = function() { window._addGiftInProgress = false; };
  if (typeof ShopifyCartAPI === 'undefined' || !ShopifyCartAPI.getCart) {
    toAdd.forEach(function(o){ cartJSAddQuery(o.varID, o.varqty > 1 ? o.varqty : 1, o.prop); });
    clearProgress();
    return;
  }
  ShopifyCartAPI.getCart().then(function(cart) {
    toAdd.forEach(function(o) {
      if (cartHasGift(cart, o.varID, o.prop)) return;
      cartJSAddQuery(o.varID, o.varqty > 1 ? o.varqty : 1, o.prop);
    });
    clearProgress();
  }).catch(function() {
    toAdd.forEach(function(o){ cartJSAddQuery(o.varID, o.varqty > 1 ? o.varqty : 1, o.prop); });
    clearProgress();
  });
}
removeGift = () =>{
  if ($('.jsc-remove-gift').length > 0) {
    var jsonObj = {};
    var itemsToRemove = [];
    $('.checkout-button').attr('disabled', true);
    $('.jsc-remove-gift').each(function(){
      var varID = $(this).val();
      //CartJS.updateItemById(varID, 0);
      jsonObj[varID] = 0;
      itemsToRemove.push(varID);
    });
    
    // Use ShopifyCartAPI to remove items and ensure cart refresh
    if (typeof ShopifyCartAPI !== 'undefined' && ShopifyCartAPI.changeItem) {
      // Remove items sequentially to ensure proper cart refresh
      var removePromises = itemsToRemove.map(function(itemKey) {
        return ShopifyCartAPI.changeItem(itemKey, 0, {}, {
          showLoading: false,
          hideLoading: false,
          dispatchRefresh: false // We'll dispatch refresh after all removals
        });
      });
      
      Promise.all(removePromises)
        .then(results => {
          // Trigger cart refresh after all removals complete
          if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
            document.dispatchEvent(new CustomEvent('customcart:refresh'));
          }
          if ($('.main-cart-section').length > 0) {
            document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
          }
          // Also trigger the general cart update event
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(error => {
          // Fallback to CartJS if ShopifyCartAPI fails
          CartJS.updateItemQuantitiesById(jsonObj);
        });
    } else {
      // Fallback to CartJS
      CartJS.updateItemQuantitiesById(jsonObj);
    }
  }
}
updateGift = () =>{
  if ($('.jsc-update-gift').length > 0) {
    $('.checkout-button').attr('disabled', true);
    var updatePromises = [];
    $('.jsc-update-gift').each(function(){
      var itemKey = $(this).val();
      var QTY = parseInt($(this).attr('data-quantity'));
      var jsonObj = {};
      jsonObj[itemKey] = QTY;
      
      // Use ShopifyCartAPI for consistency with removeGift function
      if (typeof ShopifyCartAPI !== 'undefined' && ShopifyCartAPI.updateItems) {
        var promise = ShopifyCartAPI.updateItems(jsonObj, {
          showLoading: false,
          hideLoading: false,
          dispatchRefresh: false // We'll dispatch refresh after all updates
        })
        .then(data => {
          console.log('Update gift - Success updating item', itemKey, 'to quantity', QTY, data);
          return data;
        })
        .catch(error => {
          console.log("Error occurred while updating gift quantities:", error);
          throw error;
        });
        updatePromises.push(promise);
      } else {
        // Fallback to CartJS
        CartJS.updateItemQuantitiesById(jsonObj, {
          "success": function(data, textStatus, jqXHR) {
            console.log('Update gift - updateItemQuantitiesById-key-id', jqXHR);
          },
          "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occurred while updating gift quantities:", errorThrown);
          }
        });
      }
    });
    
    // Wait for all updates to complete, then refresh cart
    if (updatePromises.length > 0) {
      Promise.all(updatePromises)
        .then(results => {
          // Trigger cart refresh after all updates complete
          if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
            document.dispatchEvent(new CustomEvent('customcart:refresh'));
          }
          if ($('.main-cart-section').length > 0) {
            document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
          }
          // Also trigger the general cart update event
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(error => {});
    }
  }
}
// End - Gift Function
// Start - GWP Popup Function
gwpPopupATCfirstload = () =>{
  var $obj = {};
  $obj['_Cart_GWP'] = 'Free Gift';
  $obj['_Cart_GWP_popup'] = 'true';
  var varID = $('.jsc-gwp-cart-prod-ele').attr("data-id");
  var removeGWPpopup = sessionStorage.getItem("gwppopup");
  var $checkboxInput = $('.jsc-gwp-cart-checkbox').find('input');

  if ($checkboxInput.prop('checked')) {
  } else if (removeGWPpopup != 'remove' && varID) {
    cartJSAddQuery(varID, 1, $obj);
    sessionStorage.setItem("gwppopup", "added");
  }
}

gwpPopupATC = (evt) => {
  var $obj = {};
  $obj['_Cart_GWP'] = 'Free Gift';
  $obj['_Cart_GWP_popup'] = 'true';
  var varID = parseInt($(evt).attr("data-id"));
  // console.log("evt", evt);
  // console.trace();

  var $checkboxInput = $('.jsc-gwp-cart-checkbox').find('input');

  if ($checkboxInput.prop('checked')) {
    console.log("checkboxInputPROP TRUE", $checkboxInput.prop('checked'));
    cartJSAddQuery(varID, 1, $obj);
    // CartJS.addItem(varID, 1, {"_Cart_GWP": "Free Gift", "_Cart_GWP_popup":"true"},
    // {
    //   "success": function(data, textStatus, jqXHR) {
    //     console.log('Added item to cart', jqXHR);
    //     updateNote();
    //   },
    //   "error": function(jqXHR, textStatus, errorThrown) {
    //     console.log("Error occurred!", errorThrown, jqXHR);
    //   }
    // });
    sessionStorage.setItem("gwppopup", "added");
  } else {
    console.log("checkboxInputPROP FALSE", $checkboxInput.prop('checked'), varID);
    var jsonObj = {};
    //CartJS.updateItemById(varID, 0);
    jsonObj[varID] = 0;
    CartJS.updateItemQuantitiesById(jsonObj);
    sessionStorage.setItem("gwppopup", "remove");
  }
};

// End - Gift Function
// Start - Packet Gift Function
removecollabgift = () =>{
  sessionStorage.setItem("collab", "Remove");
}
removecollabgiftOnload = () =>{
  var removeRED = sessionStorage.getItem("collab");
  if ($('.jsc-collab-gift').length > 0 && removeRED == 'Remove') {
    $('.jsc-collab-gift').each(function(){
      var varID = $(this).val();
      CartJS.updateItemById(varID, 0);
    });
  }
}
// End - Packet Gift Function
// Start - PWP Function
enablePWPATC = () =>{
  $('.pwp-child-form').each(function(){
    var childprodID = $(this).attr('data-product-id');
    var enablePWP = false;
    $('.jsc-pwp-enable').each(function(){
      var checkedprodID = $(this).val();
      if (childprodID == checkedprodID) {
        enablePWP = true;
      }
    });
    if (enablePWP == false) {
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").attr('disabled', 'disabled');
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").addClass('jsc-sold-out-styling');
      //Add to bag and direct to cart page button
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
      $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
      $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").attr('disabled', 'disabled');
      if ($('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
        $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
      }else{
        $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").text('Coming Soon');
      }      
    }else{
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").removeAttr('disabled', 'disabled');
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").removeClass('jsc-sold-out-styling');
      $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
      $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").removeAttr('disabled', 'disabled');
      //Add to bag and direct to cart page button
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".jsc-buy-it-now-button:not(.bundle-atc)").removeAttr('disabled', 'disabled');
      $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".jsc-buy-it-now-button:not(.bundle-atc)").removeClass('jsc-sold-out-styling');
      $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".jsc-buy-it-now-button:not(.bundle-atc)").removeAttr('disabled', 'disabled');
      if ($('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
        $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").text('Add To Bag');
      }else{
        $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").text('Add To Bag');
      } 
    }
    $('.jsc-pwp-limit').each(function(){
      var checkedprodID = $(this).val();
      if (checkedprodID == childprodID) {
        $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").attr('disabled', 'disabled');
        $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").addClass('jsc-sold-out-styling');
        $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
        $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
        $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").attr('disabled', 'disabled');
        if ($('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").length > 0) {
          $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc) .single-add-to-cart-button--text").text('Coming Soon');
        }else{
          $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".single-add-to-cart-button:not(.vip_atc):not(.soldout):not(.bundle-atc)").text('Coming Soon');
        }
        //Add to bag and direct to cart page button
        $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
        $('.side-panel-inner .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
        $('.product-grid-container .pwp-child-form.product-information--inner[data-product-id="'+ childprodID +'"]').find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
      }
    });
  });
}
// End - PWP Function
// End - PDP accordion
closeOtherAccordion = (evt) =>{
  $(evt).parents('.product-information--inner').find('.product__accordion').each(function(){
    if ( $(this).is(evt) ) {
    }else{
      $(this).find('details').removeAttr("open");
    }
  });
}
// End - PDP accordion
initProductInfoTabs = () => {
  if (window.jscProductInfoTabsBound) return;
  window.jscProductInfoTabsBound = true;

  var dragState = null;
  var DRAG_THRESHOLD = 8;

  document.addEventListener('mousedown', function (event) {
    if (event.button !== 0) return;
    var nav = event.target.closest('.product-info-tabs__nav');
    if (!nav) return;
    dragState = {
      nav: nav,
      startX: event.pageX,
      scrollLeft: nav.scrollLeft,
      moved: false
    };
  });

  document.addEventListener('mousemove', function (event) {
    if (!dragState) return;
    var dx = event.pageX - dragState.startX;
    if (!dragState.moved && Math.abs(dx) < DRAG_THRESHOLD) return;
    if (!dragState.moved) {
      dragState.moved = true;
      dragState.nav.classList.add('is-dragging');
    }
    dragState.nav.scrollLeft = dragState.scrollLeft - dx;
    event.preventDefault();
  });

  document.addEventListener('mouseup', function () {
    if (!dragState) return;
    var nav = dragState.nav;
    var moved = dragState.moved;
    nav.classList.remove('is-dragging');
    dragState = null;
    if (moved) {
      nav.dataset.dragScrolled = 'true';
      window.setTimeout(function () {
        delete nav.dataset.dragScrolled;
      }, 50);
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.product-info-tabs__tab');
    if (!button) return;
    var tabsRoot = button.closest('[data-product-info-tabs]');
    if (!tabsRoot) return;
    var nav = tabsRoot.querySelector('.product-info-tabs__nav');
    if (nav && nav.dataset.dragScrolled === 'true') {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    var targetId = button.getAttribute('data-tab-target');
    var buttons = tabsRoot.querySelectorAll('.product-info-tabs__tab');
    var panels = tabsRoot.querySelectorAll('.product-info-tabs__panel');
    buttons.forEach(function (btn) {
      var isActive = btn === button;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-tab-panel') === targetId;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }, true);
};

hideFindInStoreForInternational = () => {
  document.querySelectorAll('[data-product-info-tabs]').forEach(function (tabsRoot) {
    var buttons = tabsRoot.querySelectorAll('.product-info-tabs__tab');
    var panels = tabsRoot.querySelectorAll('.product-info-tabs__panel');
    var activeWasHidden = false;
    buttons.forEach(function (button) {
      var heading = (button.getAttribute('data-tab-heading') || button.textContent || '').trim();
      if (heading === 'Find In Store') {
        if (button.classList.contains('is-active')) activeWasHidden = true;
        button.style.display = 'none';
        button.setAttribute('aria-hidden', 'true');
        var targetId = button.getAttribute('data-tab-target');
        panels.forEach(function (panel) {
          if (panel.getAttribute('data-tab-panel') === targetId) {
            panel.style.display = 'none';
            panel.classList.remove('is-active');
            panel.setAttribute('hidden', '');
          }
        });
      }
    });
    if (activeWasHidden) {
      var firstVisible = Array.prototype.find.call(buttons, function (btn) {
        return btn.style.display !== 'none';
      });
      if (firstVisible) firstVisible.click();
    }
  });
  $('.product__accordion').each(function () {
    const summaryElement = $(this).find('summary');
    if (summaryElement.length && summaryElement.text().trim() === 'Find In Store') {
      $(this).hide();
    }
  });
};

initProductInfoTabs();
// Start - Bundle Product Page Function
// Count slots that have a loaded variant UI (one per slot — avoids double-counting
// nested .bundle-prod-var + .bundle-child-swatch inside the same slot).
countBundleSlotsWithLoadedVars = ($scope) => {
  const $root = ($scope && $scope.length) ? $scope : $(document);
  let count = 0;
  $root.find('.prod-bundle-select').each(function () {
    if ($(this).find('.bundle-prod-var, .selected-prod-bundle-var .bundle-child-swatch').first().length > 0) {
      count += 1;
    }
  });
  return count;
};
onloadchecksoldoutBundle = () =>{
  if ($('.bundle-collection-mode').length > 0) {
    $('.bundle-atc-form').attr('onclick', 'atcBundle(this)');
    $('.jsc-set-incomplete').removeClass('error-bundle-active');
    return;
  }

  let bundlevipvariant = false;
  let isCustomerVip = false;
  $('.bundle-child-swatch').find('.jsc-sold-out').removeClass('soldout-active');
  $('.bundle-child-swatch').find('.jsc-sold-out').parents('.swatch').find('.swatchbundlecol input[type="radio"]:checked + label:not(.all-disabled)').removeClass('swatch-soldout');
  $('.bundle-child-swatch').find('input.soldout:checked').each(function(){
    $(this).parents('.bundle-child-swatch').find('.jsc-sold-out').addClass('soldout-active');
    $(this).parents('.bundle-child-swatch').find('.jsc-sold-out').parents('.swatch').find('.swatchbundlecol input[type="radio"]:checked + label').addClass('swatch-soldout');
    var comingsoon = $(this).attr('coming-soon-bundle');
    if (comingsoon) {
      $(this).parents('.bundle-child-swatch').each(function() {
        if ($(this).find('.label-coming-soon').length === 0) {
          $(this).find('.jsc-sold-out').text('Coming Soon');
          $(this).find('.jsc-sold-out').css('background', '#FF8600');
        }else{
          $(evt).parents('.bundle-child-swatch').find('.jsc-sold-out').parents('.swatch').find('.swatchbundlecol input[type="radio"]:checked + label:not(.all-disabled)').removeClass('swatch-soldout');
          $(evt).parents('.bundle-child-swatch').find('.jsc-sold-out').removeClass('soldout-active');
        }
      })
    }else{
      $(this).parents('.bundle-child-swatch').find('.jsc-sold-out').text('Sold Out');
      $(this).parents('.bundle-child-swatch').find('.jsc-sold-out').css('background','#939393');
    }
  });
  $('.bundle-child-swatch').find(".jsc-var-bundle-label").hide();
  $('.bundle-child-swatch').each(function(){

    var vartitle = '';
    $(this).find('input:checked').each(function () {
      vartitle = vartitle + $(this).attr('data-value') + ' / ';
    });
    vartitle = vartitle.slice(0, -3);

    var childID = '';
    $(this).find('.bundlevarID').each(function () {
      bundlevipvariant = $(this).attr('bundlevipvariant');
      isCustomerVip = $(this).attr('iscustomervip'); 
      if ($(this).attr('data-var-title') == vartitle) {
        childID = $(this).attr('data-var-id');
      }
    });

    $(this).find(".jsc-var-bundle-label").each(function () {
      var labelvarid = $(this).attr('data-label-id');
      //check each of variant that is equal to variant id then show
      if (childID == labelvarid) {
        $(this).show();
      }
    });

  });
  /*
  $('.bundle-child-swatch').find('input:checked').each(function(){
    var datavarid = $(this).attr('data-id');
    $(this).parents('.bundle-child-swatch').find(".jsc-var-bundle-label").each(function () {
      var labelvarid = $(this).attr('data-label-id');
      //check each of variant that is equal to variant id then show
      if (datavarid == labelvarid) {
        $(this).show();
      }
    });
  });
  */
  if ( $('.product-add-to-cart-container .jsc-bundle-cart-holder .coming-soon-dumpling-bundle').length > 0){
    $('.jsc-set-incomplete').addClass('error-bundle-active');
    $('.bundle-atc-form').addClass('disabled');
    $('.bundle-atc-form').addClass('jsc-sold-out-styling')
    $('.bundle-atc-form').text('Coming Soon');
    $('.bundle-atc-form').attr('onclick','');
  }
  else if ( $('.swatch_options.bundle-child-swatch input:not(.soldout):checked').length == $('.swatch_options.bundle-child-swatch input:checked').length ) { 
    $('.jsc-set-incomplete').removeClass('error-bundle-active');
    $('.bundle-atc-form').removeClass('disabled');
    $('.bundle-atc-form').removeClass('jsc-sold-out-styling')
    $('.bundle-atc-form').text('Add To Bag');
    $('.bundle-atc-form').attr('onclick','atcBundle(this)');
  }else{
    $('.jsc-set-incomplete').addClass('error-bundle-active');
    $('.bundle-atc-form').addClass('disabled');
    $('.bundle-atc-form').addClass('jsc-sold-out-styling')
    $('.bundle-atc-form').text('Sold Out');
    $('.bundle-atc-form').attr('onclick','');
  }

  const bundleLaunchDateTime = $('.bundle-atc-form').attr('bundle-launchdatetime');
  
  if (bundlevipvariant == 'true' && isCustomerVip == 'true') {
    $('.bundle-atc-form').removeClass('disabled');
    $('.bundle-atc-form').removeClass('jsc-sold-out-styling')
    $('.bundle-atc-form').text('Add To Bag');
    $('.bundle-atc-form').attr('onclick','atcBundle(this)');
  }else if (bundlevipvariant == 'true' && isCustomerVip == 'false' && bundleLaunchDateTime != "") {
    $('.bundle-atc-form').addClass('disabled');
    $('.bundle-atc-form').addClass('jsc-sold-out-styling')
    $('.bundle-atc-form').text(bundleLaunchDateTime);
    $('.bundle-atc-form').attr('onclick','');
  }else if (bundlevipvariant == 'true' && isCustomerVip == 'false' && bundleLaunchDateTime == "") {
    $('.bundle-atc-form').addClass('disabled');
    $('.bundle-atc-form').addClass('jsc-sold-out-styling')
    $('.bundle-atc-form').text('Coming Soon');
    $('.bundle-atc-form').attr('onclick','');
  }

  if ($('.bundle-select-prod-main').length > 0) {
    $('.bundle-atc-form').attr('onclick', '');
    $('.jsc-set-incomplete').removeClass('error-bundle-active');
    $('.bundle-atc-form').removeClass('disabled');
    $('.bundle-atc-form').removeClass('jsc-sold-out-styling')
    $('.bundle-atc-form').text('Add To Bag');
  }
}
onloadselectcolbundle = () =>{
  var selectcol = $('.selectbundlecol').val();
  $(".bundle-child-swatch").find('.jsc-each-swatch').each(function () {
    var checkcol = $(this).find('input').val();
    if (checkcol == selectcol) {
      $(this).find('label').click()
    }
  });
}
getCollectionBundleSlotPrice = ($slot) => {
  const $swatch = $slot.find('.selected-prod-bundle-var .bundle-child-swatch');
  if ($swatch.length === 0) {
    return 0;
  }

  let vartitle = '';
  $swatch.find('input:checked').each(function () {
    vartitle += $(this).attr('data-value') + ' / ';
  });
  vartitle = vartitle.slice(0, -3);
  if (!vartitle) {
    return 0;
  }

  let slotPrice = 0;
  $swatch.find('.bundlevarID').each(function () {
    const $var = $(this);
    if ($var.attr('data-var-title') === vartitle) {
      slotPrice = parseInt($var.attr('data-var-price'), 10) || 0;
    }
  });
  return slotPrice;
};
getCollectionBundlePriceTotals = ($bundleMain) => {
  let originalCents = 0;
  let saleCents = 0;
  let hasDiscount = false;

  if (!$bundleMain || !$bundleMain.length || $bundleMain.attr('data-bundle-mode') !== 'collection') {
    return { originalCents: 0, saleCents: 0, hasDiscount: false, discountLabel: '' };
  }

  $bundleMain.find('.prod-bundle-select').each(function () {
    const $slot = $(this);
    const slotPrice = getCollectionBundleSlotPrice($slot);
    if (slotPrice <= 0) {
      return;
    }

    const slotDiscount = parseFloat(String($slot.attr('data-discount-percent') || '0').trim(), 10) || 0;
    const discountPercent = Math.min(Math.max(slotDiscount, 0), 100);

    originalCents += slotPrice;
    if (discountPercent > 0) {
      hasDiscount = true;
      saleCents += Math.round(slotPrice * (100 - discountPercent) / 100);
    } else {
      saleCents += slotPrice;
    }
  });

  return {
    originalCents: originalCents,
    saleCents: saleCents,
    hasDiscount: hasDiscount && originalCents > saleCents,
    discountLabel: ''
  };
};
syncCollectionBundlePriceDisplay = () => {
  $('.bundle-select-prod-main[data-bundle-mode="collection"]').each(function () {
    const $main = $(this);
    const $detail = $main.closest('.thb-product-detail');
    updateCollectionBundlePriceDisplay(
      $detail.length ? $detail : $(document),
      getCollectionBundlePriceTotals($main)
    );
  });
};
syncCollectionBundleAtcState = ($productDetail) => {
  const $detail = ($productDetail && $productDetail.length)
    ? $productDetail
    : $('.thb-product-detail').first();
  const $main = $detail.find('.bundle-select-prod-main[data-bundle-mode="collection"]').first();
  if ($main.length === 0) {
    return;
  }

  const $bundleATC = $detail.find('.bundle-atc-form');
  const $setIncomplete = $detail.find('.jsc-set-incomplete');
  // Never show the incomplete error on load / option change — only on Add To Bag click
  $setIncomplete.removeClass('error-bundle-active');

  const $slots = $main.find('.prod-bundle-select');
  let allComplete = true;
  let hasSoldOut = false;
  let hasComingSoonFlag = false;
  let hasComingSoonDumpling = false;
  let bundlevipvariantSelected = false;
  let isCustomerVipSelected = $bundleATC.attr('iscustomervip') || 'false';
  const isVipCustomerGlobal = $('#vipCustomer').length >= 1;

  if (isVipCustomerGlobal) {
    isCustomerVipSelected = 'true';
  }

  $slots.each(function () {
    const $slot = $(this);
    const $varGroup = $slot.find('.bundle-prod-var, .selected-prod-bundle-var .bundle-child-swatch').first();
    if ($varGroup.length === 0) {
      allComplete = false;
      return;
    }
    const $checked = $varGroup.find('input:checked');
    if ($checked.length === 0) {
      allComplete = false;
      return;
    }
    if ($checked.filter('.soldout').length > 0) {
      allComplete = false;
      hasSoldOut = true;
    }
    if ($checked.filter('[coming-soon-bundle="true"]').length > 0 || $varGroup.find('.coming-soon-active').length > 0) {
      hasComingSoonFlag = true;
      allComplete = false;
    }

    let vartitle = '';
    $varGroup.find('input:checked').each(function () {
      vartitle += $(this).attr('data-value') + ' / ';
    });
    vartitle = vartitle.slice(0, -3);

    $varGroup.find('.bundlevarID').each(function () {
      const $var = $(this);
      if ($var.attr('data-var-title') !== vartitle) return;

      // Selected variant combination is out of stock (badge path uses data-available,
      // not the input .soldout class, so check it here too)
      if (
        $var.attr('data-available') === 'false' &&
        $var.attr('coming-soon-bundle') !== 'true' &&
        $var.attr('coming-soon-dumpling-bundle') !== 'true'
      ) {
        hasSoldOut = true;
        allComplete = false;
      }

      if ($var.attr('bundlevipvariant') === 'true') {
        bundlevipvariantSelected = true;
        if (!isVipCustomerGlobal && $var.attr('iscustomervip')) {
          isCustomerVipSelected = $var.attr('iscustomervip');
        }
      }
      if ($var.attr('coming-soon-dumpling-bundle') === 'true') {
        hasComingSoonDumpling = true;
        if (!isVipCustomerGlobal && $var.attr('iscustomervip')) {
          isCustomerVipSelected = $var.attr('iscustomervip');
        }
      }
      if ($var.attr('coming-soon-bundle') === 'true') {
        hasComingSoonFlag = true;
      }
    });
  });

  const bundleLaunchDateTime = $bundleATC.attr('bundle-launchdatetime') || '';
  const bundleDumplingLaunchDateTime = $bundleATC.attr('bundle-dumpling-launchdatetime') || '';

  if (hasComingSoonDumpling && isCustomerVipSelected === 'true') {
    $bundleATC.removeClass('disabled jsc-sold-out-styling')
      .text('Add To Bag')
      .attr('onclick', 'atcBundle(this)')
      .removeAttr('disabled');
  } else if (hasComingSoonDumpling && isCustomerVipSelected === 'false' && bundleDumplingLaunchDateTime !== '') {
    $bundleATC.addClass('disabled jsc-sold-out-styling')
      .text(bundleDumplingLaunchDateTime)
      .attr('onclick', '')
      .removeAttr('disabled');
  } else if (hasComingSoonDumpling && isCustomerVipSelected === 'false') {
    $bundleATC.addClass('disabled jsc-sold-out-styling')
      .text('Coming Soon')
      .attr('onclick', '')
      .removeAttr('disabled');
  } else if (allComplete && !bundlevipvariantSelected) {
    $bundleATC.removeClass('disabled jsc-sold-out-styling')
      .text('Add To Bag')
      .attr('onclick', 'atcBundle(this)');
  } else if (hasComingSoonFlag) {
    $bundleATC.addClass('disabled jsc-sold-out-styling')
      .text('Coming Soon')
      .attr('onclick', '');
  } else if (hasSoldOut) {
    $bundleATC.addClass('disabled jsc-sold-out-styling')
      .text('Sold Out')
      .attr('onclick', '');
  } else {
    // Incomplete — stay clickable; error only appears when Add To Bag is clicked
    $bundleATC.removeClass('disabled jsc-sold-out-styling')
      .text('Add To Bag')
      .attr('onclick', 'atcBundle(this)')
      .removeAttr('disabled');
  }

  if (bundlevipvariantSelected && isCustomerVipSelected === 'true') {
    $bundleATC.removeClass('disabled jsc-sold-out-styling')
      .text('Add To Bag')
      .attr('onclick', 'atcBundle(this)')
      .removeAttr('disabled');
  } else if (bundlevipvariantSelected && isCustomerVipSelected === 'false' && bundleLaunchDateTime !== '') {
    $bundleATC.addClass('disabled jsc-sold-out-styling')
      .text(bundleLaunchDateTime)
      .attr('onclick', '')
      .removeAttr('disabled');
  } else if (bundlevipvariantSelected && isCustomerVipSelected === 'false') {
    $bundleATC.addClass('disabled jsc-sold-out-styling')
      .text('Coming Soon')
      .attr('onclick', '')
      .removeAttr('disabled');
  }

  // Mirror the ATC blocked state onto the collection bundle Personalise button
  const $embBtn = $detail.find('.jsc-collection-bundle-embroidery-btn');
  if ($embBtn.length) {
    if ($bundleATC.hasClass('jsc-sold-out-styling')) {
      $embBtn.addClass('disabled jsc-sold-out-styling').attr('onclick', '');
    } else {
      $embBtn.removeClass('disabled jsc-sold-out-styling').attr('onclick', 'openMaskPersonalizeEmbroidery(this);');
    }
  }
};
updateCollectionBundlePriceDisplay = ($context, totals) => {
  const format = window.theme.settings.money_with_currency_format || window.theme.settings.money_format || '${{amount}}';
  const $root = $context && $context.length ? $context : $('.thb-product-detail');
  const priceTotals = (typeof totals === 'object' && totals !== null && typeof totals.saleCents === 'number')
    ? totals
    : { originalCents: totals || 0, saleCents: totals || 0, hasDiscount: false, discountLabel: '' };

  const originalCents = priceTotals.originalCents || 0;
  const saleCents = priceTotals.saleCents || 0;
  const hasDiscount = priceTotals.hasDiscount === true;

  const $priceWraps = $root.find('.product-price-container, [id^="price-"][id$="--sticky"]');
  if (originalCents <= 0) {
    $priceWraps.addClass('bundle-collection-price-hidden');
    return;
  }
  $priceWraps.removeClass('bundle-collection-price-hidden');

  $root.find('.product-price-container .price, [id$="--sticky"] .price').each(function () {
    const $price = $(this);
    const $original = $price.find('.bundle-collection-original');
    const $amount = $price.find('.amount').not('.del').not('.bundle-collection-original');
    const $discountLabel = $price.find('.bundle-collection-discount-label');

    if (hasDiscount) {
      if ($original.length) {
        $original.removeAttr('hidden').show().empty().append(formatMoney(originalCents, format));
      }
      $amount.first().empty().append(formatMoney(saleCents, format));
    } else {
      if ($original.length) {
        $original.attr('hidden', true).hide().empty();
      }
      $amount.first().empty().append(formatMoney(saleCents, format));
    }
    if ($discountLabel.length) {
      $discountLabel.attr('hidden', true).hide().empty();
    }
  });
};
swapvarBundle = (evt) =>{
  
  const $bundleSwatch = $(evt).parents('.bundle-child-swatch');
  const $swatch = $(evt).parents('.swatch');
  const $eachSwatch = $(evt).parents('.jsc-each-swatch');

  // Reset sold-out/coming-soon states immediately
  $bundleSwatch.find('.jsc-sold-out').removeClass('soldout-active coming-soon-active');
  $bundleSwatch.find('.jsc-sold-out').parents('.swatch').find('.swatchbundlecol input[type="radio"]:checked + label:not(.all-disabled)').removeClass('swatch-soldout');

  // Update selected swatch label
  $swatch.find('.jsc-selected-swatch').text($eachSwatch.find('input').val());

  setTimeout(function () {
    const $soldOutLabel = $bundleSwatch.find('.jsc-sold-out');

    // Reset again to ensure clean state
    $soldOutLabel.removeClass('soldout-active coming-soon-active');
    $soldOutLabel.parents('.swatch').find('.swatchbundlecol input[type="radio"]:checked + label:not(.all-disabled)').removeClass('swatch-soldout');

    // Handle each soldout input
    $bundleSwatch.find('input.soldout:checked').each(function () {
      const $input = $(this);
      const $parentSwatch = $input.parents('.bundle-child-swatch');
      const comingSoon = $input.attr('coming-soon-bundle');

      $parentSwatch.find('.jsc-sold-out').addClass('soldout-active');
      $parentSwatch.find('.jsc-sold-out').parents('.swatch').find('.swatchbundlecol input[type="radio"]:checked + label').addClass('swatch-soldout');

      if (comingSoon) {
        $parentSwatch.each(function () {
          const $this = $(this);
          if ($this.find('.label-coming-soon').length === 0) {
            $this.find('.jsc-sold-out').text('Coming Soon').css('background', '#FF8600');
          } else {
            $this.find('.jsc-sold-out').removeClass('soldout-active');
            $this.find('.jsc-sold-out').parents('.swatch').find('.swatchbundlecol input[type="radio"]:checked + label:not(.all-disabled)').removeClass('swatch-soldout');
          }
        });
      } else {
        $parentSwatch.find('.jsc-sold-out').text('Sold Out').css('background', '#939393');
      }
    });

    // Update variant bundle label visibility
    $bundleSwatch.find(".jsc-var-bundle-label").hide();
    let bundlevipvariant = false;
    $bundleSwatch.each(function () {
      const $this = $(this);
      let vartitle = '';

      $this.find('input:checked').each(function () {
        vartitle += $(this).attr('data-value') + ' / ';
      });

      vartitle = vartitle.slice(0, -3);

      let childID = '';
      $this.find('.bundlevarID').each(function () {
        const $var = $(this);
          if ($var.attr('data-var-title') === vartitle) {
          bundlevipvariant = $var.attr('bundlevipvariant');
          childID = $var.attr('data-var-id');
          const isCustomerVip = $var.attr('iscustomervip');
          const comingSoonDumplingBundle = $var.attr('coming-soon-dumpling-bundle');
          const comingSoon = $var.attr('coming-soon-bundle');

          // VIP / coming-soon-when-in-stock: treat as coming soon for non-VIP even if variant is available
          if (
            (bundlevipvariant === 'true' && isCustomerVip !== 'true') ||
            (comingSoonDumplingBundle === 'true' && isCustomerVip !== 'true')
          ) {
            const $parentSwatch = $var.parents('.bundle-child-swatch');
            $parentSwatch.each(function () {
              const $this = $(this);
              if ($this.find('.label-coming-soon').length === 0) {
                $this.find('.jsc-sold-out')
                  .text('Coming Soon')
                  .css('background', '#FF8600')
                  .addClass('soldout-active coming-soon-active');
                $this.find('.jsc-sold-out').parents('.swatch').find('.swatchbundlecol input[type="radio"]:checked + label').addClass('swatch-soldout');
              } else {
                $this.find('.jsc-sold-out').removeClass('soldout-active coming-soon-active');
                $this.find('.jsc-sold-out').parents('.swatch').find('.swatchbundlecol input[type="radio"]:checked + label:not(.all-disabled)').removeClass('swatch-soldout');
              }
            });
          } else if ($var.attr('data-available') === 'false') {
            const $parentSwatch = $var.parents('.bundle-child-swatch');
            $parentSwatch.find('.jsc-sold-out').addClass('soldout-active');
            $parentSwatch.find('.jsc-sold-out').parents('.swatch').find('.swatchbundlecol input[type="radio"]:checked + label').addClass('swatch-soldout');

            if(comingSoonDumplingBundle == 'true' && isCustomerVip == 'false'){
              $parentSwatch.each(function () {
                const $this = $(this);
                $this.find('.jsc-sold-out').removeClass('soldout-active');
                $this.find('.jsc-sold-out').parents('.swatch').find('.swatchbundlecol input[type="radio"]:checked + label:not(.all-disabled)').removeClass('swatch-soldout');
              });
            }else if (comingSoon) {
              $parentSwatch.each(function () {
                const $this = $(this);
                if ($this.find('.label-coming-soon').length === 0) {
                  $this.find('.jsc-sold-out')
                    .text('Coming Soon')
                    .css('background', '#FF8600')
                    .addClass('coming-soon-active');
                } else {
                  $this.find('.jsc-sold-out').removeClass('soldout-active');
                  $this.find('.jsc-sold-out').parents('.swatch').find('.swatchbundlecol input[type="radio"]:checked + label:not(.all-disabled)').removeClass('swatch-soldout');
                }
              });
            } else {
              $parentSwatch.find('.jsc-sold-out').text('Sold Out').css('background', '#939393');
            }
          }
        }
      });

      // Show the matching label
      $this.find(".jsc-var-bundle-label").each(function () {
        if ($(this).attr('data-label-id') === childID) {
          $(this).show();
        }
      });
    });

    // Calculate total bundle price and update UI
    let totalbundleprice = 0;
    const $bundleSelectMain = $(evt).parents('.bundle-select-prod-main');
    const isCollectionBundleImages = $bundleSelectMain.attr('data-bundle-mode') === 'collection';

    if (isCollectionBundleImages) {
      const bundlePriceTotals = getCollectionBundlePriceTotals($bundleSelectMain);
      $bundleSelectMain.find('.prod-bundle-select').each(function () {
        const $slot = $(this);
        const slotIndex = parseInt($slot.attr('data-slot'), 10) - 1;
        const $swatch = $slot.find('.selected-prod-bundle-var .bundle-child-swatch');
        if ($swatch.length === 0) {
          return;
        }

        let vartitle = '';
        $swatch.find('input:checked').each(function () {
          vartitle += $(this).attr('data-value') + ' / ';
        });
        vartitle = vartitle.slice(0, -3);

        $swatch.find('.bundlevarID').each(function () {
          const $var = $(this);
          if ($var.attr('data-var-title') === vartitle) {
            const featimg = $var.attr('data-feat-img');
            if (!featimg || slotIndex < 0) {
              return;
            }

            const widths = [352, 832, 1200, 1920, 2000];
            const srcset = widths.map(function (w) {
              return featimg + '&width=' + w + ' ' + w + 'w';
            }).join(', ');

            $(evt).parents('.thb-product-detail').find('.product-single__media .bundle-img-list').each(function (index) {
              if (index === slotIndex) {
                $(this).attr('src', featimg + '&width=2000');
                $(this).attr('srcset', srcset);
              }
            });
            $(evt).parents('.thb-product-detail').find('.navCell .bundle-img-list').each(function (index) {
              if (index === slotIndex) {
                $(this).attr('src', featimg);
              }
            });

            $slot.find('.feature-img-bundle img').attr('src', featimg);
            $slot.find('.feature-img-bundle').show();
            $slot.find('.opt-wrap').addClass('opt-wrap-set');
          }
        });
      });
      updateCollectionBundlePriceDisplay($(evt).parents('.thb-product-detail'), bundlePriceTotals);
    } else {
    $bundleSelectMain.find(".bundle-child-swatch").each(function () {
      const $this = $(this);
      let vartitle = '';

      $this.find('input:checked').each(function () {
        vartitle += $(this).attr('data-value') + ' / ';
      });

      vartitle = vartitle.slice(0, -3);

      var indeximg = $(evt).parents('.bundle-select-prod-main').find(".bundle-child-swatch").index(this);

      $this.find('.bundlevarID').each(function () {
        const $var = $(this);
        if ($var.attr('data-var-title') === vartitle) {
          totalbundleprice += parseInt($var.attr('data-var-price'), 10);
          const featimg = $var.attr('data-feat-img');

          // Widths you want in srcset
          var widths = [352, 832, 1200, 1920, 2000];

          // Build srcset by appending `&width=...` to featimg
          var srcset = widths.map(function(w) {
            return featimg + "&width=" + w + " " + w + "w";
          }).join(", ");

          $(evt).parents('.thb-product-detail').find('.product-single__media .bundle-img-list').each(function(index) {
            if (index === indeximg) {
              $(this).attr('src', featimg + "&width=2000"); // Update src to high-res
              $(this).attr('srcset', srcset); // Update srcset with different sizes
            }
          });
          $(evt).parents('.thb-product-detail').find('.navCell .bundle-img-list').each(function(index) {
            if (index === indeximg) {
              $(this).attr('src', featimg); // Update src to high-res
            }
          });

          $this.parents('.prod-bundle-select').find('.feature-img-bundle img').attr('src', featimg);
          $this.parents('.prod-bundle-select').find('.feature-img-bundle').show();
          $this.parents('.prod-bundle-select').find('.opt-wrap').addClass('opt-wrap-set');
        }
      });
    });
    }

    // if (totalbundleprice > 0) {
    //   const format = window.theme.settings.money_with_currency_format || "${{amount}}";
    //   const currencyformattotalprice = formatMoney(totalbundleprice, format);
    //   const $amount = $(evt).parents('.product-information').find('.product-price-container .amount:not(.del)');
    //   $amount.empty().append(currencyformattotalprice);
    // }

    // Calculate total price for candle set items
    if ($('.candle-set-item').length > 0) {
      const $productInfo = $(evt).parents('.product-information');
      let totalCandleSetPrice = 0;
      
      // Scope the search to the current product context
      const $productContext = $productInfo.length > 0 ? $productInfo : $(evt).parents('.thb-product-detail');
      $productContext.find('.jsc-each-swatch').each(function() {
        const $swatch = $(this);
        const $checkedInput = $swatch.find('input[type="radio"]:checked');
        if ($checkedInput.length > 0) {
          // Find the label associated with the checked input (either by 'for' attribute or as sibling)
          const inputId = $checkedInput.attr('id');
          const $label = $swatch.find('label[for="' + inputId + '"]');
          if ($label.length > 0 && $label.attr('data-var-price')) {
            const price = parseInt($label.attr('data-var-price'), 10) || 0;
            totalCandleSetPrice += price;
          }
        }
      });

      if (totalCandleSetPrice > 0) {
        const format = window.theme.settings.money_with_currency_format || "${{amount}}";
        const currencyformattotalprice = formatMoney(totalCandleSetPrice, format);
        const $amount = $productInfo.find('.product-price-container .price .amount:not(.del)');
        if ($amount.length > 0) {
          $amount.empty().append(currencyformattotalprice);
        }
      }
    }

    const $main = $(evt).parents('.thb-product-detail').find('.bundle-select-prod-main');
    const $bundleATC = $(evt).parents('.thb-product-detail').find('.bundle-atc-form');
    const $setIncomplete = $(evt).parents('.thb-product-detail').find('.jsc-set-incomplete');

    if ($main.attr('data-bundle-mode') === 'collection') {
      const $productDetail = $(evt).parents('.thb-product-detail');
      syncCollectionBundleAtcState($productDetail);
      syncCollectionEmbroideryMainVariant($productDetail);
      syncCollectionBundleEmbroideryUI($productDetail);
      return;
    }

    const $context = $main.length > 0 ? $main : $(document);

    const $allInputs = $context.find('.swatch_options.bundle-child-swatch input');
    const $checked = $allInputs.filter(':checked');
    const $checkedNotSoldOut = $checked.not('.soldout');
    const $comingSoon = $checked.filter('[coming-soon-bundle="true"]');

    const totalChecked = $checked.length;
    const totalNotSoldOut = $checkedNotSoldOut.length;

    const allSelectedNotSoldOut = totalChecked === totalNotSoldOut;
    const allSelected = totalChecked === $allInputs.length;

    const isMain = $main.length > 0;
    const mainChildrenMatch = isMain &&
      $main.find('.bundle-child-swatch').length === $main.find('.prod-bundle-select').length;

    const isComplete = isMain ? allSelectedNotSoldOut && mainChildrenMatch : allSelectedNotSoldOut;

    const hasComingSoonFlag = $comingSoon.length > 0 || $(evt).parents('.thb-product-detail').find('.bundle-select-prod-main .coming-soon-active').length > 0;
    const hasSoldOutFlag = $(evt).parents('.thb-product-detail').find('.bundle-select-prod-main .soldout-active').length > 0;

    const $productDetailForMismatch = $(evt).parents('.thb-product-detail');
    const prodMismatch = $productDetailForMismatch.find('.prod-bundle-select').length !== countBundleSlotsWithLoadedVars($productDetailForMismatch);

    const isCustomerVip = $bundleATC.attr('iscustomervip'); 
    const bundleDumplingLaunchDateTime = $bundleATC.attr('bundle-dumpling-launchdatetime');

    if (($('.product-add-to-cart-container .jsc-bundle-cart-holder .coming-soon-dumpling-bundle').length > 0) && isCustomerVip == 'true') {
      $setIncomplete.removeClass('error-bundle-active');
      $bundleATC.removeClass('disabled jsc-sold-out-styling')
        .text('Add To Bag')
        .attr('onclick', 'atcBundle(this)');
      $bundleATC.removeAttr('disabled', '');
    }else if (($('.product-add-to-cart-container .jsc-bundle-cart-holder .coming-soon-dumpling-bundle').length > 0) && isCustomerVip == 'false' && bundleDumplingLaunchDateTime != "") {
      $setIncomplete.addClass('error-bundle-active');
      $bundleATC.addClass('disabled jsc-sold-out-styling')
        .text(bundleDumplingLaunchDateTime)
        .attr('onclick', '');
      $bundleATC.removeAttr('disabled', '');
    }else if (($('.product-add-to-cart-container .jsc-bundle-cart-holder .coming-soon-dumpling-bundle').length > 0) && isCustomerVip == 'false' && bundleDumplingLaunchDateTime == "") {
      $setIncomplete.addClass('error-bundle-active');
      $bundleATC.addClass('disabled jsc-sold-out-styling')
        .text('Coming Soon')
        .attr('onclick', '');
      $bundleATC.removeAttr('disabled', '');
    }else if (isComplete) {
      $setIncomplete.removeClass('error-bundle-active');
      $bundleATC.removeClass('disabled jsc-sold-out-styling')
        .text('Add To Bag')
        .attr('onclick', 'atcBundle(this)');
    } else if (hasComingSoonFlag) {
      $setIncomplete.addClass('error-bundle-active');
      $bundleATC.addClass('disabled jsc-sold-out-styling')
        .text('Coming Soon')
        .attr('onclick', '');
    } else if (hasSoldOutFlag || !allSelectedNotSoldOut) {
      $setIncomplete.addClass('error-bundle-active');
      $bundleATC.addClass('disabled jsc-sold-out-styling')
        .text('Sold Out')
        .attr('onclick', '');
    }

    const bundleLaunchDateTime = $bundleATC.attr('bundle-launchdatetime');

    if (bundlevipvariant == 'true' && isCustomerVip == 'true') {
      $setIncomplete.removeClass('error-bundle-active');
      $bundleATC.removeClass('disabled jsc-sold-out-styling')
        .text('Add To Bag')
        .attr('onclick', 'atcBundle(this)');
      $bundleATC.removeAttr('disabled', '');
    }else if (bundlevipvariant == 'true' && isCustomerVip == 'false' && bundleLaunchDateTime != "") {
      $bundleATC.addClass('disabled jsc-sold-out-styling')
        .text(bundleLaunchDateTime)
        .attr('onclick', '');
      $bundleATC.removeAttr('disabled', '');
    }else if (bundlevipvariant == 'true' && isCustomerVip == 'false' && bundleLaunchDateTime == "") {
      $bundleATC.addClass('disabled jsc-sold-out-styling')
        .text('Coming Soon')
        .attr('onclick', '');
      $bundleATC.removeAttr('disabled', '');
    }

    if (hasSoldOutFlag) {
      $setIncomplete.addClass('error-bundle-active');
      $bundleATC.addClass('disabled jsc-sold-out-styling')
        .text('Sold Out')
        .attr('onclick', '');
    }

    if (prodMismatch) {
      $bundleATC.attr('onclick', '');
    }

    console.log(
      totalNotSoldOut,
      totalChecked,
      $main.find('.bundle-child-swatch').length,
      $main.find('.prod-bundle-select').length
    );

    // Update main input label visibility
    $(evt).parents('.product-information').find('.bundle-child-swatch input:checked').each(function (index) {
      const childCol = $(this).attr('data-value');

      if (index === 0) {
        $('.bundle-main-input').each(function () {
          if ($(this).val() === childCol) {
            const mainid = $(this).attr('data-main-id');
            const $labelContainer = $(evt).parents('.product-information--inner');
            $labelContainer.find(".jsc-var-label").hide();
            $labelContainer.find(".jsc-var-label").each(function () {
              if ($(this).attr('data-label-id') === mainid) {
                $(this).show();
              }
            });
          }
        });
      }
    });

  }, 100);
}
swapColOverlay = () =>{
  setTimeout(function(){
    $(".swatch_options.bundle-child-swatch input:checked").each(function (index) {
      var productIndex = index + 1;
      var srcImg = $(this).attr('data-overlay');
      $(".jsc-img-overlay-list-" + productIndex).each(function () {
        $(this).attr('src', srcImg);
      });
    });
  }, 10);
}
atcBundle = (evt) => {
  var $productDetail = $(evt).closest('.thb-product-detail');
  var isCollectionBundle = $productDetail.find('[data-bundle-mode="collection"]').length > 0
    || $(evt).attr('data-bundle-mode') === 'collection';

  if (isCollectionBundle) {
    var $mainContainer = $productDetail.find('.bundle-select-prod-main');
    var jsonObj = [];
    var allSelected = true;

    $mainContainer.find('.prod-bundle-select').each(function () {
      var $slot = $(this);
      var childID = getCollectionBundleSlotVariantId($slot);

      if (!childID) {
        allSelected = false;
        return;
      }

      jsonObj.push({
        id: childID,
        quantity: 1,
        properties: {}
      });
    });

    if (allSelected && jsonObj.length === $mainContainer.find('.prod-bundle-select').length && jsonObj.length > 0) {
      $productDetail.find('.jsc-set-incomplete').removeClass('error-bundle-active');
      cartJSAddSQuery(jsonObj);
    } else {
      $productDetail.find('.jsc-set-incomplete').addClass('error-bundle-active');
    }
    return;
  }

  var $mainContainer = $productDetail.find('.bundle-select-prod-main');
  var isBundleMain = $mainContainer.length > 0;

  var $targetContainer = isBundleMain ? $mainContainer : $productDetail;
  var $checkedInputs = $targetContainer.find('.swatch_options.bundle-child-swatch input:checked');
  var $checkedNotSoldOut = $checkedInputs.filter(':not(.soldout)');

  var $isDumplingBundle = $(evt).attr('isDumplingBundle');

  if ($checkedInputs.length === $checkedNotSoldOut.length) {
    console.log('enable atc bundle');

    var jsonObj = [];
    var bindID = '';
    var getmainid = '';
    var $bundleMainInputs = $productDetail.find('.bundle-main-input');

    $checkedNotSoldOut.each(function(index) {
      var $input = $(this);
      var childID = $input.data('id');
      var childCol = $input.data('value');
      bindID += `${childID}-${childCol}-`;

      if (!getmainid && childCol) {
        $bundleMainInputs.each(function() {
          if ($(this).val() === childCol) {
            getmainid = $(this).attr('data-main-id');
            return false;
          }
        });
      }
    });

    if (!getmainid) {
      $checkedNotSoldOut.each(function() {
        var childCol = $(this).attr('data-value') || $(this).data('value');
        $bundleMainInputs.each(function() {
          var mainTitle = $(this).val();
          if (mainTitle === childCol || (childCol && mainTitle.indexOf(childCol) !== -1)) {
            getmainid = $(this).attr('data-main-id');
            return false;
          }
        });
        if (getmainid) return false;
      });
    }

    if (!getmainid) {
      if ($productDetail.find('.candle-set-item').length > 0) {
        getmainid = $bundleMainInputs.first().attr('data-main-id');
      }
    }

    if (!getmainid) {
      getmainid = $(evt).attr('data-main') || $productDetail.find('.bundle-atc-form').first().attr('data-main');
    }

    bindID = bindID.slice(0, -1); // remove trailing '-'

    if ($productDetail.find('.normalbundleopt').length > 0 && $isDumplingBundle == 'false') {
      var $bundleVars = isBundleMain
        ? $mainContainer.find('.bundle-prod-var')
        : $productDetail.find('.bundle-prod-var');

      $($bundleVars.get().reverse()).each(function() {
        var $varGroup = $(this);
        var vartitle = $varGroup.find('input:not(.soldout):checked')
          .map(function() {
            return $(this).data('value');
          }).get().join(' / ');

        var childID = '';
        $varGroup.find('.bundlevarID').each(function() {
          if ($(this).data('var-title') === vartitle) {
            childID = $(this).data('var-id');
          }
        });

        jsonObj.push({
          id: childID,
          quantity: 1,
          properties: {}
        });
      });

    }else if ($productDetail.find('.normalbundleopt').length > 0 && $isDumplingBundle == 'true'){
      var $bundleVars = isBundleMain
        ? $mainContainer.find('.bundle-prod-var')
        : $productDetail.find('.bundle-prod-var');

      $($bundleVars.get()).each(function(index) {
        var $varGroup = $(this);
        var vartitle = $varGroup.find('input:not(.soldout):checked')
          .map(function() {
            return $(this).data('value');
          }).get().join(' / ');

        var childID = '';
        $varGroup.find('.bundlevarID').each(function() {
          if ($(this).data('var-title') === vartitle) {
            childID = $(this).data('var-id');
          }
        });

        jsonObj.push({
          id: childID,
          quantity: 1,
          properties: {
            '_Bind ID': bindID,
            '_Dumpling Bundle': index === 0 ? 'Main' : 'Child',
          }
        });
      });
    } 
    else {
      $($checkedNotSoldOut.get().reverse()).each(function() {
        var $input = $(this);
        jsonObj.push({
          id: $input.data('id'),
          quantity: 1,
          properties: {
            '_Bind ID': bindID,
            '_Bundle Product': 'Child',
            _Bundle_Overlay: $input.data('overlay')
          }
        });
      });

      if ($('.candle-set-item').length > 0) {
        $(".candle-variant-item").each(function () {
          var $candleVariantItem = $(this);
          var $candleVariantItemTitle = $candleVariantItem.data('title').toLowerCase();
          var $candleVariantItemId = $candleVariantItem.val();
          $(".swatch_options.bundle-child-swatch input:checked").each(function () {
            var $swatchchildValue = $(this).val().toLowerCase();
            if ($candleVariantItemTitle == $swatchchildValue) {
              jsonObj.push({
                id: parseInt($candleVariantItemId, 10),
                quantity: 1,
                properties: {
                  '_Bind ID': bindID,
                  '_Cart_GWP': 'Free Gift',
                  '_Bundle Product': 'Child'
                }
              });
            }
          });
        });
      }

      if (!getmainid) {
        console.error('atcBundle: could not resolve main bundle variant id');
        return;
      }

      jsonObj.push({
        id: getmainid,
        quantity: 1,
        properties: {
          '_Bind ID': bindID,
          '_Bundle Product': 'Main'
        }
      });
    }
    console.log('jsonObj', jsonObj);
    cartJSAddSQuery(jsonObj);

  } else {
    // $('.jsc-set-incomplete').addClass('error-bundle-active');
    // setTimeout(() => $('.jsc-set-incomplete').removeClass('error-bundle-active'), 2500);
    console.log('disabled atc bundle');
  }
}
removeAllbundle = (keylist, giftWrapPrdBindID) =>{
  var keysplit = keylist.split(",");
  var jsonObj = {};
  for (i=0;i<keysplit.length;i++){
      jsonObj[keysplit[i]] = 0;
  }
  if($('.jsc-cart-item-giftwrap').length > 0 && giftWrapPrdBindID != '') {
    $('.jsc-cart-item-giftwrap').each(function() {
      var giftWrapBindID = $(this).attr('giftwrap-bindid');
      var giftWrapVarID = $(this).attr('data-product-id');

      if (giftWrapBindID == giftWrapPrdBindID) {
        console.log("Exist");
        var selectedGiftWrapVarID = giftWrapVarID;
        jsonObj[selectedGiftWrapVarID] = 0;
        console.log("jsonObj", jsonObj);
        CartJS.updateItemQuantitiesById(jsonObj, {
          "success": function(data, textStatus, jqXHR) {
            console.log('Remove item - bundle', jqXHR);
          },
          "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occurred while updating item quantities:", errorThrown);
          }
        });
      }
    });
  }else{
    CartJS.updateItemQuantitiesById(jsonObj);
  }
}
// End - Bundle Product Page Function
// Start - Laces Popup Function
openMaskPersonalize = (evt) =>{
  if ($(evt).parents('.product-information--inner').find('.popup-variant-img-laces').length > 0) {
    if ($(evt).parents('.product-information--inner').find('.jsc-col-var-wrap.color-active').length <= 0) {
      $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap').first().addClass('color-active');
    }
    var shoescol = $(evt).parents('.product-information--inner').find('.variations .product-form__input--color input[type="radio"]:checked').val().toLowerCase();
    var lacescol = $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap.color-active').find('input').val().toLowerCase();
    var comAlt = shoescol + '-' + lacescol;

    $(evt).parents('.product-information--inner').find('.jsc-imglaces').each(function(){
      var altImg = $(this).attr('data-alt');
      var scrImg = $(this).val();
      if (comAlt == altImg) {
        $(evt).parents('.product-information--inner').find('.popup-variant-img-laces').attr('src', scrImg);
      }
    });

    var selectedSize;
    var dataavai;
    $(evt).parents('.product-information--inner').find(".variant-list-data").each(function () {
      var datavarid = $(this).attr('data-var-id');
      if (datavarid == $(evt).parents('.product-information--inner').find(".variant-selected-form").val()) {
        selectedSize = $(this).attr('data-lacesize');
        dataavai = $(this).attr('data-var-avail');
      }
    });
    var lacescol = $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap.color-active').find('input').val();

    if (selectedSize) {
      $(evt).parents('.product-information--inner').find('.jsc-color-laces').text($('.jsc-col-var-wrap.color-active').find('input').val() + ' ');
      $(evt).parents('.product-information--inner').find('.jsc-varlaces').each(function(){
        var varTitle = $(this).attr('data-vartitle');
        if (varTitle == (lacescol + ' / ' + selectedSize) || varTitle == (selectedSize + ' / ' + lacescol)) {
          var varAvai = $(this).attr('data-avai');
          if (varAvai == 'true' && dataavai == 'true') {
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').removeClass('disabled');
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').removeAttr('disabled');
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').removeClass('jsc-sold-out-styling');
            $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize span').text('Add To Bag');
          }else{
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').addClass('disabled');
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').attr('disabled','disabled');
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').addClass('jsc-sold-out-styling');
            $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
            $(evt).parents('.product-information--inner').find('.jsc-atc-personalize span').text('Sold Out');
          }
        }
      });

      var $getColor = $(evt).parents('.product-information--inner').find('.variations .product-form__input--color input[type="radio"]:checked').val();
      var $getSize = $(evt).parents('.product-information--inner').find('.variations .product-form__input--block input[type="radio"]:checked').val();
      var $productTitlecontainer = $('.jsc-main-variant');
      var $productTitle = $('.product_name').text();

      if ($(window).width() < 1025) {
        $productTitlecontainer.text('');
        $productTitlecontainer.children().remove();
        $productTitlecontainer.text($productTitle);
        $productTitlecontainer.append('<span class="jsc-color-size">'+ $getColor + ' (' + $getSize + ')' +'</span>');
      }else {
        $productTitlecontainer.text('');
        $productTitlecontainer.children().remove();
        $productTitlecontainer.text($productTitle);
        $productTitlecontainer.append('<span class="jsc-color-size">'+ $getColor + ' (' + $getSize + ')' +'</span>');
      }
    }

  }

  $(evt).parents('.product-information--inner').find('.jsc-question-popup-overlay').show();
  $('body').css("overflow", "hidden");
  $(evt).parents('.product-information--inner').find('.jsc-mask-popup').show();
  $('.header-section').addClass('headerindex');
  $('.announcement-bar-section').addClass('headerindex');
  $('.product-add-to-cart-sticky').addClass('headerindex');
  $('#smile-ui-container').addClass('headerindex');
  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
}

closeMaskPersonalize = () =>{
  $('.jsc-question-popup-overlay').hide();
  $('body').css("overflow", "auto");
  $('.jsc-mask-popup').hide();
  $('.header-section').removeClass('headerindex');
  $('.announcement-bar-section').removeClass('headerindex');
  $('.product-add-to-cart-sticky').removeClass('headerindex');
  $('#smile-ui-container').addClass('headerindex');
}

selectvarColLaces = (evt) =>{
  var $this = $(evt);
  var $colorLabel = $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap');
  $colorLabel.removeClass('color-active');
  $this.parent('.jsc-col-var-wrap').addClass('color-active');

  setTimeout(function(){
    $(evt).parents('.product-information--inner').find('.jsc-color-laces').text($(evt).parents('.color-active').find('input').val() + ' ');
    if ($(evt).parents('.product-information--inner').find('.popup-variant-img-laces').length > 0) {
      var shoescol = $(evt).parents('.product-information--inner').find('.variations .product-form__input--color input[type="radio"]:checked').val().toLowerCase();
      var lacescol = $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap.color-active').find('input').val().toLowerCase();
      var comAlt = shoescol + '-' + lacescol;

      $(evt).parents('.product-information--inner').find('.jsc-imglaces').each(function(){
        var altImg = $(this).attr('data-alt');
        var scrImg = $(this).val();
        if (comAlt == altImg) {
          $(evt).parents('.product-information--inner').find('.popup-variant-img-laces').attr('src', scrImg);
        }
      });

      var selectedSize;
      var dataavai;
      $(evt).parents('.product-information--inner').find(".variant-list-data").each(function () {
        var datavarid = $(this).attr('data-var-id');
        if (datavarid == $(evt).parents('.product-information--inner').find(".variant-selected-form").val()) {
          selectedSize = $(this).attr('data-lacesize');
          dataavai = $(this).attr('data-var-avail');
        }
      });
      var lacescol = $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap.color-active').find('input').val();

      if (selectedSize) {
        $(evt).parents('.product-information--inner').find('.jsc-varlaces').each(function(){
          var varTitle = $(this).attr('data-vartitle');
          if (varTitle == (lacescol + ' / ' + selectedSize) || varTitle == (selectedSize + ' / ' + lacescol)) {
            var varAvai = $(this).attr('data-avai');
            if (varAvai == 'true' && dataavai == 'true') {
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').removeClass('disabled');
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').removeAttr('disabled');
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').removeClass('jsc-sold-out-styling');
              $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize span').text('Add To Bag');
            }else{
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').addClass('disabled');
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').attr('disabled','disabled');
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize').addClass('jsc-sold-out-styling');
              $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
              $(evt).parents('.product-information--inner').find('.jsc-atc-personalize span').text('Sold Out');
            }
          }
        });
      }
    }

  }, 10);

}

addtocartlacespersonalize = (evt) =>{
  var selectedSize;
  $(evt).parents('.product-information--inner').find(".variant-list-data").each(function () {
    var datavarid = $(this).attr('data-var-id');
    if (datavarid == $(evt).parents('.product-information--inner').find(".variant-selected-form").val()) {
      selectedSize = $(this).attr('data-lacesize');
      dataavai = $(this).attr('data-var-avail');
    }
  });
  var lacescol = $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap.color-active').find('input').val();

  if (selectedSize) {
    $(evt).parents('.product-information--inner').find('.jsc-varlaces').each(function(){
      var varTitle = $(this).attr('data-vartitle');
      if (varTitle == (lacescol + ' / ' + selectedSize) || varTitle == (selectedSize + ' / ' + lacescol)) {
        var varID = $(this).val();
        var $mainID = $(evt).parents('.product-information--inner').find(".variant-selected-form").val();
        var jsonObj = [];
        var item = {};
        item ["id"] = varID;
        item ["quantity"] = 1;
        item ["properties"] = {};
        jsonObj.push(item);
        var item = {};
        item ["id"] = $mainID;
        item ["quantity"] = 1;
        item ["properties"] = {};
        jsonObj.push(item);
        cartJSAddSQuery(jsonObj);
      }
    });
  }
}
// End - Laces Popup Function

// Start - Embroidery Popup Function
function jscEmbroideryVariantListScope($productInner) {
  if ($productInner.find('.jsc-collection-embroidery-active').val()) {
    return $productInner.find('.jsc-collection-embroidery-variant-data');
  }
  return $productInner;
}
function jscGetEmbroideryMainVariantId($productInner) {
  if ($productInner.find('.jsc-collection-embroidery-active').val()) {
    return $productInner.find('.jsc-collection-embroidery-main-variant').val() || '';
  }
  return $productInner.find('.variant-selected-form').val();
}
function jscGetActiveEmbroideryPopupWrap($productInner) {
  var activeProdId = $productInner.find('.jsc-collection-embroidery-active').val();
  if (activeProdId) {
    return $productInner.find('.jsc-collection-embroidery-popup-wrap[data-embroidery-product-id="' + activeProdId + '"]');
  }
  return $productInner.find('.jsc-mask-popup.jsc-embroidery').first().parent();
}
function getCollectionBundleSlotVariantId($slot) {
  if (!$slot || !$slot.length) {
    return '';
  }
  var $varGroup = $slot.find('.bundle-prod-var');
  if ($varGroup.length === 0) {
    $varGroup = $slot.find('.selected-prod-bundle-var .bundle-child-swatch');
  }
  if ($varGroup.length === 0) {
    return '';
  }
  // Include sold-out / coming-soon checked options so embroidery + cart still track the selection
  var vartitle = '';
  $varGroup.find('input:checked').each(function () {
    vartitle += String($(this).attr('data-value') || $(this).data('value') || '') + ' / ';
  });
  vartitle = vartitle.slice(0, -3);
  if (!vartitle) {
    return '';
  }
  var childID = '';
  $varGroup.find('.bundlevarID').each(function () {
    if ($(this).attr('data-var-title') === vartitle) {
      childID = String($(this).attr('data-var-id') || '');
    }
  });
  return childID;
}
function buildCollectionEmbroideryVariantData($productInner, $swatch) {
  var $host = $productInner.find('.jsc-collection-embroidery-variant-data');
  $host.empty();
  if (!$swatch || !$swatch.length) {
    return;
  }
  var $atc = $productInner.find('.bundle-atc-form');
  var fallbackLaunch =
    $atc.attr('bundle-launchdatetime') ||
    $atc.attr('bundle-dumpling-launchdatetime') ||
    '';
  $swatch.find('.bundlevarID').each(function () {
    var $var = $(this);
    var varId = $var.attr('data-var-id');
    if (!varId) {
      return;
    }
    var available = $var.attr('data-available') === 'true' ? 'true' : 'false';
    var comingSoonBundle = $var.attr('coming-soon-bundle') === 'true';
    var dumplingComingSoon = $var.attr('coming-soon-dumpling-bundle') === 'true';
    var vip = $var.attr('bundlevipvariant') === 'true';
    var launchDate = $var.attr('data-launch-time-date') || fallbackLaunch || '';
    var $row = $('<input>', {
      type: 'hidden',
      class: 'variant-list-data',
      value: varId,
      'data-var-id': varId,
      'data-var-avail': available,
      'data-vip': vip ? 'true' : 'false',
      showComingSoonWhenInStock: dumplingComingSoon ? 'true' : 'false'
    });
    if (comingSoonBundle || dumplingComingSoon) {
      $row.attr('data-label-coming-soon', 'true');
    }
    if (launchDate && (comingSoonBundle || dumplingComingSoon || vip)) {
      $row.attr('data-launch-time-date', launchDate);
    }
    $host.append($row);
  });
}
function ensureCollectionEmbroideryPopup($productInner, productId, handle) {
  var $existing = $productInner.find('.jsc-collection-embroidery-popup-wrap[data-embroidery-product-id="' + productId + '"]');
  if ($existing.length) {
    return Promise.resolve($existing);
  }
  if (!handle) {
    return Promise.resolve($());
  }
  return fetch('/products/' + encodeURIComponent(handle) + '?view=embroidery-popup')
    .then(function (res) {
      if (!res.ok) {
        throw new Error('Failed to load embroidery popup');
      }
      return res.text();
    })
    .then(function (html) {
      var $host = $productInner.find('.bundle-collection-embroidery-popups');
      if ($host.length === 0) {
        $host = $('<div class="bundle-collection-embroidery-popups" aria-hidden="true"></div>');
        $productInner.find('.bundle-collection-wrap').append($host);
      }
      var $wrap = $('<div class="jsc-collection-embroidery-popup-wrap" data-embroidery-product-id="' + productId + '" data-product-handle="' + handle + '" style="display:none;"></div>');
      $wrap.html(html);
      $host.append($wrap);
      return $wrap;
    })
    .catch(function (err) {
      console.warn('ensureCollectionEmbroideryPopup failed', err);
      return $();
    });
}
function syncCollectionEmbroideryMainVariant($productDetail) {
  var $inner = $productDetail.find('.product-information--inner').first();
  var embroiderySlot = $inner.find('.jsc-collection-embroidery-slot').val();
  if (!embroiderySlot) {
    $inner.find('.jsc-collection-embroidery-main-variant').val('');
    return;
  }
  var $slot = $productDetail.find('.prod-bundle-select[data-slot="' + embroiderySlot + '"]');
  var variantId = getCollectionBundleSlotVariantId($slot);
  $inner.find('.jsc-collection-embroidery-main-variant').val(variantId);
  syncCollectionEmbroideryPopupImages($productDetail);
}
function getCollectionEmbroiderySlotContext($detail) {
  var $inner = $detail.find('.product-information--inner').first();
  var slotNo = $inner.find('.jsc-collection-embroidery-slot').val();
  if (!slotNo) {
    return null;
  }
  var $slot = $detail.find('.prod-bundle-select[data-slot="' + slotNo + '"]');
  var $swatch = $slot.find('.selected-prod-bundle-var .bundle-child-swatch');
  var variantId = getCollectionBundleSlotVariantId($slot);
  var vartitle = '';
  var featimg = '';
  var colorValue = '';
  var $colorInput = $swatch.find('.product-form__input--color input[type="radio"]:checked');
  if ($colorInput.length) {
    colorValue = String($colorInput.val() || $colorInput.attr('data-value') || '').toLowerCase().trim();
  } else {
    $swatch.find('input:checked').each(function () {
      colorValue = String($(this).attr('data-value') || $(this).data('value') || '').toLowerCase().trim();
    });
  }
  $swatch.find('.bundlevarID').each(function () {
    if (String($(this).data('var-id')) === String(variantId)) {
      vartitle = $(this).attr('data-var-title') || '';
      featimg = $(this).attr('data-feat-img') || '';
    }
  });
  return {
    $inner: $inner,
    $slot: $slot,
    $swatch: $swatch,
    variantId: variantId,
    vartitle: vartitle,
    featimg: featimg,
    colorValue: colorValue,
    slotNo: slotNo
  };
}
function syncCollectionEmbroideryPopupImages($detail) {
  var ctx = getCollectionEmbroiderySlotContext($detail);
  if (!ctx || !ctx.variantId) {
    return;
  }
  var activeProdId = ctx.$inner.find('.jsc-collection-embroidery-active').val();
  if (!activeProdId) {
    return;
  }
  var $wrap = $detail.find('.jsc-collection-embroidery-popup-wrap[data-embroidery-product-id="' + activeProdId + '"]').first();
  if (!$wrap.length) {
    $wrap = ctx.$inner.find('.jsc-collection-embroidery-popup-wrap[data-embroidery-product-id="' + activeProdId + '"]').first();
  }
  if (!$wrap.length) {
    return;
  }

  var imgSrc = ctx.featimg || '';
  var colorValue = ctx.colorValue || '';
  if (colorValue) {
    var loop1 = true;
    $wrap.find('.jsc-imglaces').each(function () {
      var altImg = String($(this).attr('data-alt') || '').toLowerCase().trim();
      var scrImg = $(this).val();
      if (altImg && scrImg && altImg === colorValue && loop1) {
        imgSrc = scrImg;
        loop1 = false;
      }
    });
    if (loop1 && imgSrc) {
      $wrap.find('.jsc-imglaces').each(function () {
        var altImg = String($(this).attr('data-alt') || '').toLowerCase().trim();
        var scrImg = $(this).val();
        if (!altImg || !scrImg || loop1 === false) {
          return;
        }
        if (colorValue.indexOf(altImg) !== -1 || altImg.indexOf(colorValue) !== -1) {
          imgSrc = scrImg;
          loop1 = false;
        }
      });
    }
  }
  if (imgSrc) {
    var displaySrc = imgSrc;
    if (displaySrc.indexOf('width=') === -1) {
      displaySrc += (displaySrc.indexOf('?') >= 0 ? '&' : '?') + 'width=1800';
    }
    var $baseImgs = $wrap.find('.popup-variant-img-laces');
    if ($wrap.find('.fixed-base-overlay').length) {
      $baseImgs.addClass('hide');
    } else {
      $baseImgs.removeClass('hide').attr('src', displaySrc);
    }
  }
  if (ctx.vartitle) {
    $wrap.find('.jsc-main-variant .jsc-color-size').text(ctx.vartitle);
  }
}
function jscEmbroideryPopupImageScope($context) {
  var $popup = $context.closest('.jsc-mask-popup.jsc-embroidery');
  if ($popup.length) {
    return $popup;
  }
  return $context.closest('.jsc-collection-embroidery-popup-wrap, .product-information--inner');
}
function syncCollectionBundleEmbroideryUI($context) {
  var $detail = ($context && $context.hasClass('thb-product-detail')) ? $context : $context.closest('.thb-product-detail');
  if ($detail.length === 0) {
    $detail = $('.thb-product-detail').first();
  }
  var $inner = $detail.find('.product-information--inner').first();
  var $bundleMain = $detail.find('.bundle-select-prod-main[data-bundle-mode="collection"]').first();
  if ($inner.length === 0 || $bundleMain.length === 0) {
    return;
  }

  var embroideryProdId = '';
  var embroiderySlot = '';
  var embroideryHandle = '';
  var embroideryTitle = 'Personalise your bag';
  var $embSwatch = $();

  $bundleMain.find('.prod-bundle-select').each(function () {
    var $slot = $(this);
    var $activeLi = $slot.find('.opt-bundle-prod li.active-bundle-select');
    var prodId = String($activeLi.attr('data-prod-id') || '');
    if (!prodId || prodId === 'default') {
      return;
    }
    var $swatch = $slot.find('.selected-prod-bundle-var .bundle-child-swatch[data-product-id="' + prodId + '"]');
    if ($swatch.length === 0) {
      $swatch = $slot.find('.bundle-prod-var .bundle-child-swatch[data-product-id="' + prodId + '"]');
    }
    if ($swatch.length === 0) {
      $swatch = $detail.find('.prod-bundle-select .selected-prod-bundle-var .bundle-child-swatch[data-product-id="' + prodId + '"]');
    }
    if ($swatch.attr('data-has-personalisation') === 'true') {
      embroideryProdId = prodId;
      embroiderySlot = String($slot.attr('data-slot') || '');
      embroideryHandle = $swatch.attr('data-prod-handle') || '';
      var customTitle = $swatch.attr('data-embroidery-popup-title');
      if (customTitle) {
        embroideryTitle = customTitle;
      }
      $embSwatch = $swatch;
    }
  });

  var $embBtn = $detail.find('.jsc-collection-bundle-embroidery-btn');
  var $atcBtn = $detail.find('.jsc-collection-bundle-atc');
  var allSlotsSelected = true;
  $bundleMain.find('.prod-bundle-select').each(function () {
    var $slot = $(this);
    var $activeLi = $slot.find('.opt-bundle-prod li.active-bundle-select');
    var prodId = String($activeLi.attr('data-prod-id') || '');
    if (!prodId || prodId === 'default') {
      allSlotsSelected = false;
    }
  });

  if (!embroideryProdId) {
    $inner.find('.jsc-collection-embroidery-active').val('');
    $inner.find('.jsc-collection-embroidery-slot').val('');
    $inner.find('.jsc-collection-embroidery-main-variant').val('');
    $inner.find('.jsc-collection-embroidery-variant-data').empty();
    $inner.find('.jsc-collection-embroidery-popup-wrap').removeClass('active').hide();
    $embBtn.hide();
    if (allSlotsSelected) {
      $atcBtn.show();
    }
    return;
  }

  $inner.find('.jsc-collection-embroidery-active').val(embroideryProdId);
  $inner.find('.jsc-collection-embroidery-slot').val(embroiderySlot);
  buildCollectionEmbroideryVariantData($inner, $embSwatch);
  syncCollectionEmbroideryMainVariant($detail);
  jscUpdateEmbroideryPersonalizeAtc($inner);

  ensureCollectionEmbroideryPopup($inner, embroideryProdId, embroideryHandle).then(function ($wrap) {
    // Button label = custom.embroidery_popup_title only (data-embroidery-popup-title on swatch).
    $embBtn.find('.jsc-collection-bundle-embroidery-btn-text').text(embroideryTitle);
    if (allSlotsSelected) {
      $embBtn.show();
      $atcBtn.show();
    } else {
      $embBtn.hide();
      $atcBtn.show();
    }
    syncCollectionEmbroideryPopupImages($detail);
    jscUpdateEmbroideryPersonalizeAtc($inner);
  });
}
function getCollectionBundleCartItemsExceptSlot($productDetail, skipSlot) {
  var items = [];
  var $mainContainer = $productDetail.find('.bundle-select-prod-main');
  $mainContainer.find('.prod-bundle-select').each(function () {
    var $slot = $(this);
    var slotNo = String($slot.attr('data-slot') || '');
    if (slotNo === String(skipSlot)) {
      return;
    }
    var childID = getCollectionBundleSlotVariantId($slot);
    if (!childID) {
      return;
    }
    items.push({
      id: childID,
      quantity: 1,
      properties: {}
    });
  });
  return items;
}
function jscEmbroideryActiveAddonWrap($productInner) {
  var activeProdId = $productInner.find('.jsc-collection-embroidery-active').val();
  if (activeProdId) {
    var $wrap = $productInner.find('.jsc-collection-embroidery-popup-wrap[data-embroidery-product-id="' + activeProdId + '"]');
    if ($wrap.length) {
      return $wrap.find('.jsc-mask-popup.jsc-embroidery .embroidery-prod-wrap.active');
    }
  }
  return $productInner.find('.jsc-mask-popup.jsc-embroidery .embroidery-prod-wrap.active');
}
function jscEmbroideryPopupAtcDisabled($productInner) {
  var $wrap = jscEmbroideryActiveAddonWrap($productInner);
  return $wrap.attr('data-disabled-popup-atc') === 'true';
}
function jscEmbroideryMainComingSoon($productInner) {
  var vid = jscGetEmbroideryMainVariantId($productInner);
  if (!vid) {
    return { blocked: false, text: '' };
  }
  var $scope = jscEmbroideryVariantListScope($productInner);
  var $row = $scope.find('.variant-list-data[data-var-id="' + vid + '"]');
  if ($row.length === 0) {
    $row = $scope.find('.variant-list-data').filter(function () {
      return String($(this).val()) === String(vid);
    });
  }
  if ($row.length === 0) {
    return { blocked: false, text: '' };
  }
  var $embRoot = jscGetEmbroideryPopupRoot($productInner);
  var isVipCustomer =
    $('#vipCustomer').length >= 1 ||
    ($embRoot.attr('data-customer-vip') || 'false') === 'true';
  var launchText = function () {
    var lt = $row.attr('data-launch-time-date');
    return (lt && lt !== '') ? lt : 'Coming Soon';
  };
  if ($row.attr('data-label-coming-soon') === 'true') {
    var isVipVariant = $row.attr('data-vip') === 'true';
    // Coming soon + VIP variant: only block non-VIP customers.
    if (!(isVipVariant && isVipCustomer)) {
      return { blocked: true, text: launchText() };
    }
  }
  if ($row.attr('showComingSoonWhenInStock') === 'true' && !isVipCustomer) {
    return { blocked: true, text: launchText() };
  }
  if ($row.attr('data-vip') === 'true' && !isVipCustomer) {
    return { blocked: true, text: launchText() };
  }
  return { blocked: false, text: '' };
}
function jscEmbroideryMainLaunchDateFromVariants($productInner) {
  var launchDate = '';
  jscEmbroideryVariantListScope($productInner).find('.variant-list-data').each(function () {
    var lt = $(this).attr('data-launch-time-date');
    if (lt && lt !== '') {
      launchDate = lt;
      return false;
    }
  });
  return launchDate;
}
function jscGetEmbroideryPopupRoot($productInner) {
  var $wrap = jscGetActiveEmbroideryPopupWrap($productInner);
  var $root = $wrap.find('.jsc-mask-popup.jsc-embroidery').first();
  if ($root.length) {
    return $root;
  }
  return $productInner.find('.jsc-mask-popup.jsc-embroidery').first();
}
function jscEmbroideryAddonVipBlocked($productInner, isCustomerVip) {
  if (isCustomerVip) {
    return false;
  }
  var blocked = false;
  jscEmbroideryActiveAddonWrap($productInner).find('.jsc-col-var-wrap.color-active').each(function () {
    if ($(this).attr('data-vip') === 'true') {
      blocked = true;
    }
  });
  return blocked;
}
function jscEmbroideryPersonalizeBlocked($productInner) {
  if (jscEmbroideryPopupAtcDisabled($productInner)) {
    return true;
  }
  if (jscEmbroideryMainComingSoon($productInner).blocked) {
    return true;
  }
  var $embRoot = jscGetEmbroideryPopupRoot($productInner);
  var isCustomerVip =
    $('#vipCustomer').length >= 1 ||
    ($embRoot.attr('data-customer-vip') || 'false') === 'true';
  if (jscEmbroideryAddonVipBlocked($productInner, isCustomerVip)) {
    return true;
  }
  if (!jscEmbroideryInitialsFullySelected($productInner)) {
    return true;
  }
  return false;
}
function jscEmbroideryPersonalizeBlockedText($productInner) {
  if (jscEmbroideryPopupAtcDisabled($productInner)) {
    return 'Coming Soon';
  }
  var mainComingSoon = jscEmbroideryMainComingSoon($productInner);
  if (mainComingSoon.blocked) {
    return mainComingSoon.text;
  }
  var $embRoot = jscGetEmbroideryPopupRoot($productInner);
  var isCustomerVip =
    $('#vipCustomer').length >= 1 ||
    ($embRoot.attr('data-customer-vip') || 'false') === 'true';
  if (jscEmbroideryAddonVipBlocked($productInner, isCustomerVip)) {
    var vipLaunchDate = jscEmbroideryMainLaunchDateFromVariants($productInner);
    return vipLaunchDate !== '' ? vipLaunchDate : 'Coming Soon';
  }
  return '';
}
// Collection bundle: check whether any OTHER slot's selected variant is sold out,
// since the popup ATC adds every slot to the cart, not just the personalised product.
function jscCollectionOtherSlotsSoldOut($productInner) {
  var activeProdId = $productInner.find('.jsc-collection-embroidery-active').val();
  if (!activeProdId) {
    return false;
  }
  var skipSlot = String($productInner.find('.jsc-collection-embroidery-slot').val() || '');
  var $detail = $productInner.closest('.thb-product-detail');
  if ($detail.length === 0) {
    $detail = $('.thb-product-detail').first();
  }
  var soldOut = false;
  $detail.find('.bundle-select-prod-main[data-bundle-mode="collection"] .prod-bundle-select').each(function () {
    var $slot = $(this);
    if (String($slot.attr('data-slot') || '') === skipSlot) {
      return;
    }
    var $swatch = $slot.find('.selected-prod-bundle-var .bundle-child-swatch');
    if ($swatch.length === 0) {
      return;
    }
    var vartitle = '';
    $swatch.find('input:checked').each(function () {
      vartitle += $(this).attr('data-value') + ' / ';
    });
    vartitle = vartitle.slice(0, -3);
    if (!vartitle) {
      return;
    }
    $swatch.find('.bundlevarID').each(function () {
      if ($(this).attr('data-var-title') === vartitle && $(this).attr('data-available') === 'false') {
        soldOut = true;
      }
    });
  });
  return soldOut;
}
function jscEmbroideryActiveSelectionLimit($productInner, $wrap) {
  var $activeWrap = $wrap && $wrap.length ? $wrap : jscEmbroideryActiveAddonWrap($productInner);
  var fromWrap = parseInt(($activeWrap.attr('data-selection-limit') || '').toString(), 10);
  if (!isNaN(fromWrap) && fromWrap >= 1) {
    return Math.min(fromWrap, 3);
  }
  var $embRoot = jscGetEmbroideryPopupRoot($productInner);
  var fallback = parseInt(($embRoot.attr('data-embroidery-initials-count') || '2').toString(), 10);
  if (isNaN(fallback) || fallback < 1) {
    fallback = 2;
  }
  return Math.min(fallback, 3);
}
function jscEmbroideryParseOffsetList(raw, fallbacks) {
  var list = [];
  if (raw && raw !== 'null' && raw !== 'undefined') {
    try {
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        list = parsed.map(function (v) {
          return (v == null ? '' : String(v)).trim();
        });
      }
    } catch (e) {
      list = [];
    }
  }
  if (!list.length && fallbacks && fallbacks.length) {
    return fallbacks.slice();
  }
  return list;
}
function jscEmbroideryOffsetAt(list, index, fallback) {
  if (list && index >= 0 && index < list.length && list[index] !== '') {
    return list[index];
  }
  return fallback;
}
function jscEmbroideryApplyActiveOffsets($embRoot, $imgScope, $wrap, isInitials) {
  var start = parseInt(($wrap.attr('data-offset-start') || '0').toString(), 10);
  if (isNaN(start) || start < 0) {
    start = 0;
  }
  var deskFallbacks = [
    ($embRoot.attr('data-embroidery-left-first') || (isInitials ? '-4px' : '0px')).trim(),
    ($embRoot.attr('data-embroidery-left-sec') || '4px').trim(),
    ($embRoot.attr('data-embroidery-left-third') || '0px').trim()
  ];
  var mobFallbacks = [
    ($embRoot.attr('data-embroidery-left-first-mobile') || deskFallbacks[0]).trim(),
    ($embRoot.attr('data-embroidery-left-sec-mobile') || deskFallbacks[1]).trim(),
    ($embRoot.attr('data-embroidery-left-third-mobile') || deskFallbacks[2]).trim()
  ];
  var deskOffsets = jscEmbroideryParseOffsetList($embRoot.attr('data-embroidery-left-offsets'), deskFallbacks);
  var mobOffsets = jscEmbroideryParseOffsetList($embRoot.attr('data-embroidery-left-offsets-mobile'), mobFallbacks);
  if (!mobOffsets.length) {
    mobOffsets = deskOffsets.slice();
  }
  var left0 = jscEmbroideryOffsetAt(deskOffsets, start, deskFallbacks[0]);
  var left1 = jscEmbroideryOffsetAt(deskOffsets, start + 1, deskFallbacks[1]);
  var left2 = jscEmbroideryOffsetAt(deskOffsets, start + 2, deskFallbacks[2]);
  var left0Mob = jscEmbroideryOffsetAt(mobOffsets, start, left0);
  var left1Mob = jscEmbroideryOffsetAt(mobOffsets, start + 1, left1);
  var left2Mob = jscEmbroideryOffsetAt(mobOffsets, start + 2, left2);

  $imgScope.find('.jsc-img-personalize-wrap .popup-variant-img-overlay').css('--left', left0);
  $imgScope.find('.jsc-img-personalize-wrap .popup-variant-img-overlay-sec').css('--left', left1);
  $imgScope.find('.jsc-img-personalize-wrap .popup-variant-img-overlay-third').css('--left', left2);
  $imgScope.find('.jsc-img-personalize-wrap-mob .popup-variant-img-overlay').css('--left', left0Mob);
  $imgScope.find('.jsc-img-personalize-wrap-mob .popup-variant-img-overlay-sec').css('--left', left1Mob);
  $imgScope.find('.jsc-img-personalize-wrap-mob .popup-variant-img-overlay-third').css('--left', left2Mob);

  if (isInitials) {
    $imgScope.find('.jsc-img-personalize-wrap .popup-variant-img-overlay').addClass('initialsimg');
    $imgScope.find('.jsc-img-personalize-wrap-mob .popup-variant-img-overlay').addClass('initialsimg');
  } else {
    $imgScope.find('.jsc-img-personalize-wrap .popup-variant-img-overlay').removeClass('initialsimg');
    $imgScope.find('.jsc-img-personalize-wrap-mob .popup-variant-img-overlay').removeClass('initialsimg');
  }
}
function jscEmbroiderySelectionLimitHintText(limit) {
  if (limit >= 3) {
    return 'Select all initials to continue.';
  }
  if (limit === 1) {
    return 'Select an initial to continue.';
  }
  return 'Select both initials to continue.';
}
function jscEmbroideryInitialsFullySelected($productInner) {
  var $wrap = jscEmbroideryActiveAddonWrap($productInner);
  if (!$wrap.hasClass('initials-swatch')) {
    return true;
  }
  var initialsCount = jscEmbroideryActiveSelectionLimit($productInner, $wrap);
  var segments = [];
  if (initialsCount >= 1) {
    segments.push('.jsc-first-color');
  }
  if (initialsCount >= 2) {
    segments.push('.jsc-sec-color');
  }
  if (initialsCount >= 3) {
    segments.push('.jsc-third-color');
  }
  for (var i = 0; i < segments.length; i++) {
    if ($wrap.find(segments[i] + ' .jsc-col-var-wrap.color-active').length === 0) {
      return false;
    }
  }
  return true;
}
function jscUpdateEmbroideryInitialStatuses($scope) {
  var $root = $scope && $scope.length
    ? ($scope.hasClass('jsc-mask-popup') ? $scope : $scope.find('.jsc-mask-popup.jsc-embroidery').addBack('.jsc-mask-popup.jsc-embroidery').first())
    : $('.jsc-mask-popup.jsc-embroidery:visible').first();
  if (!$root.length) {
    $root = $scope.find('.jsc-mask-popup.jsc-embroidery').first();
  }
  if (!$root.length) {
    return;
  }
  $root.find('.embroidery-prod-wrap.initials-swatch.active .embroidery-initial-block').each(function () {
    var $block = $(this);
    var seg = $block.attr('data-initial-seg');
    var $active = $block.find('.jsc-col-var-wrap.color-active label');
    var $status = $block.find('.embroidery-initial-status[data-status-for="' + seg + '"]');
    if ($active.length) {
      $status.text(($active.attr('data-tooltip') || '').toString());
    } else {
      $status.text('Not selected');
    }
  });
}
function jscPreselectEmbroideryInitials($scope) {
  var $root = $scope.find('.jsc-mask-popup.jsc-embroidery');
  if (!$root.length && $scope.hasClass('jsc-mask-popup')) {
    $root = $scope;
  }
  if (!$root.length) {
    return;
  }
  var $wrap = $root.find('.embroidery-prod-wrap.initials-swatch.active');
  if (!$wrap.length) {
    $wrap = $root.find('.embroidery-prod-wrap.initials-swatch').first();
  }
  $wrap.find('.jsc-first-color, .jsc-sec-color, .jsc-third-color').each(function () {
    var $col = $(this);
    var $pick = $col.find('.jsc-col-var-wrap').not('.personalise-disabled').first();
    if (!$pick.length) {
      $pick = $col.find('.jsc-col-var-wrap').first();
    }
    if ($pick.length) {
      $pick.find('label').first().trigger('click');
    }
  });
  jscUpdateEmbroideryInitialStatuses($root);
}
function jscUpdateEmbroideryPersonalizeAtc($productInner) {
  var dataavai;
  var datapersonalizeavai = true;
  var mainVariantId = jscGetEmbroideryMainVariantId($productInner);
  jscEmbroideryVariantListScope($productInner).find('.variant-list-data').each(function () {
    var datavarid = $(this).attr('data-var-id');
    if (datavarid == mainVariantId) {
      dataavai = $(this).attr('data-var-avail');
    }
  });
  var activeProdId = $productInner.find('.jsc-collection-embroidery-active').val();
  var $addonScope = activeProdId
    ? $productInner.find('.jsc-collection-embroidery-popup-wrap[data-embroidery-product-id="' + activeProdId + '"]')
    : $productInner;
  var $activeWrap = jscEmbroideryActiveAddonWrap($productInner);
  var isInitials = $activeWrap.hasClass('initials-swatch');
  var initialsReady = jscEmbroideryInitialsFullySelected($productInner);
  jscUpdateEmbroideryInitialStatuses($addonScope);
  $addonScope.find('.embroidery-prod-wrap.active .jsc-col-var-wrap.color-active').each(function(){
    if ($(this).attr('data-avai') == 'false') {
      datapersonalizeavai = false;
    }
  });
  var $btn = activeProdId
    ? $addonScope.find('.jsc-atc-personalize').first()
    : $productInner.find('.jsc-atc-personalize');
  var $hint = activeProdId
    ? $addonScope.find('.embroidery-select-hint').first()
    : $productInner.find('.embroidery-select-hint');
  var blockedText = jscEmbroideryPersonalizeBlockedText($productInner);
  if (blockedText !== '') {
    $btn.addClass('disabled');
    $btn.attr('disabled','disabled');
    $btn.addClass('jsc-sold-out-styling');
    $btn.removeAttr('onclick');
    $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
    $btn.find('span').text(blockedText);
    $hint.addClass('is-hidden');
    return;
  }
  if (isInitials && !initialsReady) {
    $btn.addClass('disabled embroidery-atc-needs-selection');
    $btn.attr('disabled','disabled');
    $btn.removeClass('jsc-sold-out-styling');
    $btn.removeAttr('onclick');
    $btn.find('span').text('Add To Bag');
    $hint.text(jscEmbroiderySelectionLimitHintText(jscEmbroideryActiveSelectionLimit($productInner, $activeWrap)));
    $hint.removeClass('is-hidden');
    return;
  }
  if (dataavai == 'true' && datapersonalizeavai == true && !jscCollectionOtherSlotsSoldOut($productInner)) {
    $btn.removeClass('disabled embroidery-atc-needs-selection');
    $btn.removeAttr('disabled');
    $btn.removeClass('jsc-sold-out-styling');
    $btn.attr('onclick', 'addtocartEmbroideryPersonalize(this);');
    $('.product-add-to-cart-container').removeClass('jsc-hide-payment-button');
    $btn.find('span').text('Add To Bag');
    $hint.addClass('is-hidden');
  }else{
    $btn.addClass('disabled');
    $btn.attr('disabled','disabled');
    $btn.addClass('jsc-sold-out-styling');
    $btn.removeAttr('onclick');
    $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
    $btn.find('span').text('Sold Out');
    $hint.addClass('is-hidden');
  }
}
openMaskPersonalizeEmbroidery = (evt) =>{
  var $inner = $(evt).parents('.product-information--inner');
  var activeProdId = $inner.find('.jsc-collection-embroidery-active').val();

  if (activeProdId) {
    syncCollectionEmbroideryMainVariant($inner.closest('.thb-product-detail'));
    $inner.find('.jsc-collection-embroidery-popup-wrap').removeClass('active').hide()
      .find('.jsc-question-popup-overlay.jsc-embroidery, .jsc-mask-popup.jsc-embroidery').hide();
    var $wrap = $inner.find('.jsc-collection-embroidery-popup-wrap[data-embroidery-product-id="' + activeProdId + '"]');
    $wrap.addClass('active').show();
    syncCollectionEmbroideryPopupImages($inner.closest('.thb-product-detail'));
    $wrap.find('.jsc-mask-popup.jsc-embroidery .embroidery-select').first().click();
    jscPreselectEmbroideryInitials($wrap);
    jscUpdateEmbroideryPersonalizeAtc($inner);
    $wrap.find('.jsc-question-popup-overlay.jsc-embroidery').show();
    $wrap.find('.jsc-mask-popup.jsc-embroidery').show();
    $('body').css('overflow', 'hidden');
    $('.header-section').addClass('headerindex');
    $('.announcement-bar-section').addClass('headerindex');
    $('.product-add-to-cart-sticky').addClass('headerindex');
    $('#smile-ui-container').addClass('headerindex');
    document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
    return;
  }

  if ($inner.find('.popup-variant-img-laces').length > 0) {
    if ($(evt).parents('.product-information--inner').find('.jsc-col-var-wrap.color-active').length <= 0) {
      $(evt).parents('.product-information--inner').find('.jsc-col-var-wrap').first().addClass('color-active');
    }
    var shoescol = $(evt).parents('.product-information--inner').find('.variations .product-form__input--color input[type="radio"]:checked').val().toLowerCase();
    var comAlt = shoescol;
    var loop1 = true;

    $(evt).parents('.product-information--inner').find('.jsc-imglaces').each(function(){
      var altImg = $(this).attr('data-alt');
      var scrImg = $(this).val();
      if (comAlt == altImg && loop1 == true) {
        $(evt).parents('.product-information--inner').find('.popup-variant-img-laces').attr('src', scrImg);
        loop1 = false;
      }
    });

  }

  $(evt).parents('.product-information--inner').find('.jsc-mask-popup.jsc-embroidery .embroidery-select').first().click();
  jscPreselectEmbroideryInitials($inner);
  jscUpdateEmbroideryPersonalizeAtc($(evt).parents('.product-information--inner'));
  $(evt).parents('.product-information--inner').find('.jsc-question-popup-overlay.jsc-embroidery').show();
  $('body').css("overflow", "hidden");
  $(evt).parents('.product-information--inner').find('.jsc-mask-popup.jsc-embroidery ').show();
  $('.header-section').addClass('headerindex');
  $('.announcement-bar-section').addClass('headerindex');
  $('.product-add-to-cart-sticky').addClass('headerindex');
  $('#smile-ui-container').addClass('headerindex');
  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
}

closeMaskPersonalizeEmbroidery = () =>{
  $('.jsc-collection-embroidery-popup-wrap.active').removeClass('active').hide()
    .find('.jsc-question-popup-overlay.jsc-embroidery, .jsc-mask-popup.jsc-embroidery').hide();
  $('.jsc-question-popup-overlay.jsc-embroidery').hide();
  $('body').css("overflow", "auto");
  $('.jsc-mask-popup.jsc-embroidery ').hide();
  $('.header-section').removeClass('headerindex');
  $('.announcement-bar-section').removeClass('headerindex');
  $('.product-add-to-cart-sticky').removeClass('headerindex');
  $('#smile-ui-container').removeClass('headerindex');
}

swapembroidery = (evt,showopt,prodid) =>{
  $(evt).parents('.embroidery-select-wrap').find('.active').removeClass('active');
  $(evt).addClass('active');
  $(evt).parents('.jsc-left-content').find('.embroidery-prod-wrap').removeClass('active');
  $(evt).parents('.jsc-left-content').find('.embroidery-prod-wrap[data-product="'+ prodid +'"]').addClass('active');
  var $imgScope = jscEmbroideryPopupImageScope($(evt));
  var $activeProd = $(evt).parents('.jsc-left-content').find('.embroidery-prod-wrap[data-product="'+ prodid +'"]');
  var selectionLimit = jscEmbroideryActiveSelectionLimit($(evt).parents('.product-information--inner'), $activeProd);
  if (showopt) {
    $(evt).parents('.jsc-left-content').find('.swatch-initials').show();
    if (selectionLimit >= 2) {
      $imgScope.find('.popup-variant-img-overlay-sec').show();
    } else {
      $imgScope.find('.popup-variant-img-overlay-sec').hide().attr('src', '');
    }
    if (selectionLimit >= 3) {
      $imgScope.find('.popup-variant-img-overlay-third').show();
    } else {
      $imgScope.find('.popup-variant-img-overlay-third').hide().attr('src', '');
    }
    $activeProd.find('.jsc-first-color, .jsc-sec-color, .jsc-third-color').addClass('active');
    $activeProd.find('.jsc-col-var').each(function () {
      var $col = $(this);
      var $pick = $col.find('.jsc-col-var-wrap').not('.personalise-disabled').first();
      if (!$pick.length) {
        $pick = $col.find('.jsc-col-var-wrap').first();
      }
      if ($pick.length) {
        $pick.find('label').first().trigger('click');
      }
    });
  }else{
    $(evt).parents('.jsc-left-content').find('.swatch-initials').hide();
    $imgScope.find('.popup-variant-img-overlay-sec').hide().attr('src', '');
    $imgScope.find('.popup-variant-img-overlay-third').hide().attr('src', '');
    $activeProd.find('.jsc-col-var').each(function () {
      $(this).find('.jsc-col-var-wrap').first().find('label').click();
    });
  }
  jscUpdateEmbroideryPersonalizeAtc($(evt).parents('.product-information--inner'));
}

swapinitials = (evt,initials) =>{
  $(evt).parents('.jsc-color-header').find('.active').removeClass('active');
  $(evt).addClass('active');
  var $initialsWrap = $(evt).parents('.jsc-left-content').find('.embroidery-prod-wrap.initials-swatch');
  // Keep all initial grids visible in the redesigned UI.
  $initialsWrap.find('.jsc-first-color, .jsc-sec-color, .jsc-third-color').addClass('active');
}

selectvarColEmbroidery = (evt,initials) =>{
  var $colorLabel = $(evt).parents('.jsc-col-var').find('.jsc-col-var-wrap');
  $colorLabel.removeClass('color-active');
  $(evt).parent('.jsc-col-var-wrap').addClass('color-active');
  $(evt).siblings('input.initials-color-radio').prop('checked', true);
  var $colVar = $(evt).parents('.jsc-col-var');
  var secoverlay = $colVar.hasClass('jsc-sec-color');
  var thirdoverlay = $colVar.hasClass('jsc-third-color');
  var dataimg = $(evt).attr('data-swatch-img-overlay');
  var $imgScope = jscEmbroideryPopupImageScope($(evt));
  if (thirdoverlay) {
    $imgScope.find('.popup-variant-img-overlay-third').attr('src', dataimg);
  } else if (secoverlay) {
    $imgScope.find('.popup-variant-img-overlay-sec').attr('src', dataimg);
  }else{
    $imgScope.find('.popup-variant-img-overlay').attr('src', dataimg);
  }
  var $embRoot = $(evt).closest('.jsc-mask-popup.jsc-embroidery');
  var $activeWrap = $(evt).closest('.embroidery-prod-wrap');
  jscEmbroideryApplyActiveOffsets($embRoot, $imgScope, $activeWrap, initials == 'selectinitials');
  jscUpdateEmbroideryPersonalizeAtc($(evt).parents('.product-information--inner'));
}

addtocartEmbroideryPersonalize = (evt) =>{
  var $embAddInner = $(evt).parents('.product-information--inner');
  if (jscEmbroideryPersonalizeBlocked($embAddInner)) {
    return;
  }
  var activeProdId = $embAddInner.find('.jsc-collection-embroidery-active').val();
  var $addonScope = activeProdId
    ? $embAddInner.find('.jsc-collection-embroidery-popup-wrap[data-embroidery-product-id="' + activeProdId + '"]')
    : $embAddInner;
  var mainVariantId = jscGetEmbroideryMainVariantId($embAddInner);
  if (!mainVariantId) {
    return;
  }
  var bindID = 'personalize-';
  var $activeAddonWrap = $addonScope.find('.embroidery-prod-wrap.active');
  var selectionLimit = jscEmbroideryActiveSelectionLimit($embAddInner, $activeAddonWrap);
  var selectedCount = 0;
  $activeAddonWrap.find('.jsc-col-var-wrap.color-active input').each(function(){
    if (selectedCount >= selectionLimit) {
      return;
    }
    var varID = $(this).val();
    bindID = bindID + varID + '-';
    selectedCount += 1;
  });
  bindID = bindID + mainVariantId + '-';
  bindID = bindID.substring(0,bindID.length - 1);
  var jsonObj = [];
  selectedCount = 0;
  $activeAddonWrap.find('.jsc-col-var-wrap.color-active input').each(function(){
    if (selectedCount >= selectionLimit) {
      return;
    }
    var varID = $(this).val();
    var item = {};
    item ["id"] = varID;
    item ["quantity"] = 1;
    var $obj = {};
    $obj['_Bind ID'] = bindID;
    $obj['_Bundle Product'] = 'Child';
    item ["properties"] = $obj;
    jsonObj.push(item);
    selectedCount += 1;
  });

  var item = {};
  item ["id"] = mainVariantId;
  item ["quantity"] = 1;
  var $obj = {};
  $obj['_Bind ID'] = bindID;
  $obj['_Bundle Product'] = 'Main';
  $addonScope.find('.embroidery-prod-wrap.initials-swatch.active .jsc-first-color .jsc-col-var-wrap.color-active input').each(function(){
    $obj['First Initial'] = $(this).next().attr('data-tooltip');
  });
  $addonScope.find('.embroidery-prod-wrap.initials-swatch.active .jsc-sec-color .jsc-col-var-wrap.color-active input').each(function(){
    $obj['Second Initial'] = $(this).next().attr('data-tooltip');
  });
  $addonScope.find('.embroidery-prod-wrap.initials-swatch.active .jsc-third-color .jsc-col-var-wrap.color-active input').each(function(){
    $obj['Third Initial'] = $(this).next().attr('data-tooltip');
  });
  item ["properties"] = $obj;
  jsonObj.push(item);

  if (activeProdId) {
    var embroiderySlot = $embAddInner.find('.jsc-collection-embroidery-slot').val();
    var $detail = $embAddInner.closest('.thb-product-detail');
    var otherItems = getCollectionBundleCartItemsExceptSlot($detail, embroiderySlot);
    jsonObj = jsonObj.concat(otherItems);
  }

  console.log(jsonObj);
  cartJSAddSQuery(jsonObj);
  closeMaskPersonalizeEmbroidery();
}
// End - Embroidery Popup Function

// Start - Popup Section Function

showPopupSection = () => {
  var userOrderCount = $('.jsc-user-data').attr("data-order-count");
  var isShowBefore = sessionStorage.getItem("jsc-popup-section");
  if((userOrderCount == 0 || userOrderCount == '0') && (!isShowBefore)){
    setTimeout(() => {
      $('.jsc-popup-section').show(); 
      $('.jsc-popup-button').show();
    }, 3000);
  }

}

closePopupSection = () =>{
  $('.jsc-popup-section').hide();
  $('.jsc-popup-button').hide();
  sessionStorage.setItem("jsc-popup-section", "yes");
}
// End - Popup Section Function

getUserIPInfo = () => {
  var storeSG = false;
  var storeJP = false;
  var storePH = false;

  if (location.href.includes('.com')) {
    storeSG = true;
  } else if(location.href.includes('.jp')){
    storeJP = true;
  }else if(location.href.includes('.ph')){
    storePH = true;
  }

  var shippingLineTextElement = $('.free-shipping--text .jsc-shipping-line');
  var shippingSpendTextElement = $('.free-shipping--text .jsc-spend-shipping-line');
  var frontShippingTextLocal = 'FREE shipping will be applied at checkout.';
  var backShippingTextLocal = $('#jsc-back-shipping-text-local').val() ? $('#jsc-back-shipping-text-local').val().trim() : '';
  var frontShippingTextInt = 'FREE shipping will be applied at checkout.';
  var backShippingTextInt = $('#jsc-back-shipping-text-int').val() ? $('#jsc-back-shipping-text-int').val().trim() : '';
  
  updateShippingText = (element, text) => {
    if (element.length && text) {
      element.text(text);
    }
  }

  // Use URL-based detection for local countries (bypasses IP API rate limit)
  var isLocalCountry = storeSG || storeJP || storePH;
  
  if (isLocalCountry) {
    // Local country - set text immediately, no API call needed
    updateShippingText(shippingLineTextElement, frontShippingTextLocal);
    updateShippingText(shippingSpendTextElement, backShippingTextLocal);
  } else {
    // International - use cached IP info or fetch once
    var cachedIPInfo = sessionStorage.getItem('jsc_ipinfo_country');
    
    if (cachedIPInfo) {
      // Use cached country
      var userIPCountry = cachedIPInfo;
      // For international, always use international text
      updateShippingText(shippingLineTextElement, frontShippingTextInt);
      updateShippingText(shippingSpendTextElement, backShippingTextInt);
      if (typeof hideFindInStoreForInternational === 'function') {
        hideFindInStoreForInternational();
      }
    } else {
      // Fetch IP info only once per session
      $.get("https://ipinfo.io/json", function (response) {
        var userIPCountry = response.country;
        // Cache for this session
        sessionStorage.setItem('jsc_ipinfo_country', userIPCountry);
        
        // For international, always use international text
        updateShippingText(shippingLineTextElement, frontShippingTextInt);
        updateShippingText(shippingSpendTextElement, backShippingTextInt);
        if (typeof hideFindInStoreForInternational === 'function') {
          hideFindInStoreForInternational();
        }
      }, "jsonp").fail(function() {
        // If API fails, use international text as default
        updateShippingText(shippingLineTextElement, frontShippingTextInt);
        updateShippingText(shippingSpendTextElement, backShippingTextInt);
      });
    }
  }
}

changeToDatePicker = () => {
  $('#birthdayInput').prop('type', 'date');
  $('#birthdayInput').off('click touchstart', changeToDatePicker);
}

// Event listener to change input type back to text if value is empty
changeToText = () => {
  var $input = $('#birthdayInput');
  if (!$input.val()) {
    $input.prop('type', 'text');
    $input.on('click touchstart', changeToDatePicker);
  }
}

datePickerListener = () => {
  $('#birthdayInput').on('click touchstart', changeToDatePicker);
  $('#birthdayInput').on('blur', changeToText);
}

clickFaqButton = (button, linkLabel) => {
  $('.text-button').removeClass('faq-active');
  $(button).addClass('faq-active');
  
  $('.is-selected').removeClass('is-selected');
  $(button).parent().addClass('is-selected');

  var targetId = '#' + linkLabel.replace(/[,&\s-]+/g, "_");

  var $targetElement = $(targetId);
  var offset = $targetElement.offset().top;

  var additionalOffset = -303; 
  offset += additionalOffset;

  $('html, body').animate({
    scrollTop: offset
  }, 500);
}

updateFaqID = () => {
  if ($('.collapsible-content').length > 0) {
    $('.collapsible-content').each(function() {
      var currentId = $(this).attr('id');
      var newId = currentId.replace(/[,&\s-]+/g, "_");
      $(this).attr('id', newId);
    });
  }
}

initflickityCarouselPage = () =>{
  var timesRun = 0;
  var timer = setInterval(function() {
      if ($('.jsccarouselpage .shg-row').length > 0) {
        $('.jsccarouselpage .shg-row').flickity({
          // options
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          autoPlay: 2000,
          wrapAround: true,
          groupCells: false
        });
        clearInterval(timer);
        $('.jsccarouselpage .shg-row').flickity('destroy');
        $('.jsccarouselpage .shg-row').flickity({
          // options
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          autoPlay: 2000,
          wrapAround: true,
          groupCells: false
        });
      }

      timesRun += 1;
      if(timesRun === 100){
          clearInterval(timer);
      }

    }, 1);
}

initflickityCarouselstorePageonclick = () =>{
  $(".jsc-accordion-stores .shogun-accordion-heading").click(function(){
    var timesRun = 0;
    var timer = setInterval(function() {
      $('.jsc-stores-carousel .shg-row').flickity();
      $('.jsc-stores-carousel .shg-row').flickity('destroy');
      var screenWidth = $(window).width();
      if (screenWidth <= 767) {
        $('.jsc-stores-carousel .shg-row').flickity({
          // options
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          wrapAround: true,
          groupCells: false,
          prevNextButtons: false
        });
        $('.jsc-stores-carousel .shg-row').flickity('destroy');
        $('.jsc-stores-carousel .shg-row').flickity({
          // options
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          wrapAround: true,
          groupCells: false,
          prevNextButtons: false
        });
      } else {
        $('.jsc-stores-carousel .shg-row').flickity({
          // options
          cellAlign: 'center',
          contain: true,
          pageDots: true,
          wrapAround: true,
          groupCells: false,
          prevNextButtons: false
        });
        $('.jsc-stores-carousel .shg-row').flickity('destroy');
        $('.jsc-stores-carousel .shg-row').flickity({
          // options
          cellAlign: 'center',
          contain: true,
          pageDots: true,
          wrapAround: true,
          groupCells: false,
          prevNextButtons: false
        });
      }

      $('.jsc-stores-carousel .flickity-page-dots').each(function() {
        var dotsize = $(this).find('.flickity-page-dot').length;
        var dotwidth = 100/dotsize;
        $(this).find('.flickity-page-dot').css("width", dotwidth + "%");
      });

      timesRun += 1;
      if(timesRun === 1){
          clearInterval(timer);
      }

    }, 1500);
  });
}

initFaqSlider = () => {
  if ($('.jsc-carousel').length > 0) {
    var flkty = new Flickity( '.jsc-carousel' , {
      // options
      cellAlign: 'center',
      contain: true,
      pageDots: false,
      groupCells: false,
      wrapAround: false,
      draggable: true,
      prevNextButtons: false,
      autoPlay: false,
    });
  }
}

// PWP general row (PDP + quick-view). cellSelector skips stray <script>/<style> after cards in Liquid.
var jscPwpGeneralFlickityOptions = {
  cellAlign: 'left',
  contain: true,
  pageDots: false,
  groupCells: false,
  wrapAround: false,
  draggable: true,
  autoPlay: false,
  prevNextButtons: true,
  cellSelector: '.pwp-product-card'
};

refreshProductDrawerPwpGeneralFlickity = function () {
  $('#Product-Drawer .flickity-complementary--pwp-general').each(function () {
    var $el = $(this);
    if ($el.find('.pwp-product-card').length && !$el.hasClass('flickity-enabled')) {
      $el.flickity(jscPwpGeneralFlickityOptions);
    }
    var flkty = $el.data('flickity');
    if (flkty) {
      flkty.resize();
    }
  });
};

zeroJscPwpDrawerPwpGeneralScrollStrips = function () {
  $(
    '#jsc-pwp-pdp-section-general .jsc-pwp-general-scrollstrip, #Product-Drawer .jsc-pwp-general-scrollstrip, .side-panel.product-drawer .jsc-pwp-general-scrollstrip'
  ).each(function () {
    var el = this;
    if (typeof el.scrollTo === 'function') {
      try {
        el.scrollTo({ left: 0, top: 0, behavior: 'instant' });
      } catch (e) {
        el.scrollLeft = 0;
      }
    } else {
      el.scrollLeft = 0;
    }
  });
};

jscInstantScrollStripLeftToZero = function (strip) {
  if (!strip) return;
  if (typeof strip.scrollTo === 'function') {
    try {
      strip.scrollTo({ left: 0, top: 0, behavior: 'instant' });
    } catch (e) {
      strip.scrollLeft = 0;
    }
  } else {
    strip.scrollLeft = 0;
  }
};

/** Lock + snap to first slide (runs while hidden + after reveal; no DOM class toggles). */
jscClampPwpScrollstripToFirstCell = function (strip, $wrap) {
  if ((!$wrap || !$wrap.length) && strip) $wrap = $(strip).closest('.jsc-pwp-general-scrollstrip-wrap');
  if (!strip || !strip.isConnected) return;
  lockJscPwpGeneralScrollstripCellWidths(strip);
  strip.scrollLeft = 0;
  jscInstantScrollStripLeftToZero(strip);
  strip.scrollLeft = 0;
  updateJscPwpGeneralScrollstripNav($wrap);
};

jscClampAllPwpGeneralScrollstripsFirstCell = function () {
  $('.jsc-pwp-general-scrollstrip-wrap').each(function () {
    var $w = $(this);
    var strip = $w.find('.jsc-pwp-general-scrollstrip')[0];
    if (!strip) return;
    jscClampPwpScrollstripToFirstCell(strip, $w);
  });
};

/** Product drawer transforms break subpixel flex rounding — re-lock + clamp after open / transition. */
jscIsPwpScrollstripInDrawer = function (strip) {
  if (!strip || typeof strip.closest !== 'function') return false;
  return !!(strip.closest('#Product-Drawer') || strip.closest('.side-panel.product-drawer'));
};

jscRefinePwpDrawerGeneralScrollstrips = function () {
  $('#Product-Drawer .jsc-pwp-general-scrollstrip, .side-panel.product-drawer .jsc-pwp-general-scrollstrip').each(function () {
    var strip = this;
    var $w = $(strip).closest('.jsc-pwp-general-scrollstrip-wrap');
    lockJscPwpGeneralScrollstripCellWidths(strip);
    jscClampPwpScrollstripToFirstCell(strip, $w);
  });
};

/** PDP + quick-view: hide until widths + first cell snapped (reveal after paint so reflow doesn't leave wrong scrollLeft). */
finalizeJscPwpScrollstripWrap = function ($wrap) {
  if (!$wrap || !$wrap.length || !$wrap.hasClass('jsc-pwp-strip-awaiting')) return false;
  var strip = $wrap.find('.jsc-pwp-general-scrollstrip')[0];
  if (!strip) return false;
  if (Math.round(strip.clientWidth) < 1) return false;
  if (strip._jscPwpRevealArmed) return true;
  strip._jscPwpRevealArmed = true;
  jscClampPwpScrollstripToFirstCell(strip, $wrap);
  requestAnimationFrame(function () {
    if (!$wrap.hasClass('jsc-pwp-strip-awaiting')) {
      delete strip._jscPwpRevealArmed;
      return;
    }
    jscClampPwpScrollstripToFirstCell(strip, $wrap);
    requestAnimationFrame(function () {
      if (!$wrap.hasClass('jsc-pwp-strip-awaiting')) {
        delete strip._jscPwpRevealArmed;
        return;
      }
      jscClampPwpScrollstripToFirstCell(strip, $wrap);
      updateJscPwpGeneralScrollstripNav($wrap);
      delete strip._jscPwpRevealArmed;
      $wrap.removeClass('jsc-pwp-strip-awaiting').addClass('is-jsc-pwp-strip-stable');
    });
  });
  return true;
};

finalizeAllAwaitingPwpScrollstrips = function () {
  $('.jsc-pwp-general-scrollstrip-wrap.jsc-pwp-strip-awaiting').each(function () {
    finalizeJscPwpScrollstripWrap($(this));
  });
};

scheduleJscPwpScrollstripReveal = function () {
  finalizeAllAwaitingPwpScrollstrips();
  window.setTimeout(finalizeAllAwaitingPwpScrollstrips, 0);
  requestAnimationFrame(function () {
    finalizeAllAwaitingPwpScrollstrips();
    requestAnimationFrame(function () {
      finalizeAllAwaitingPwpScrollstrips();
      jscClampAllPwpGeneralScrollstripsFirstCell();
    });
  });
  window.setTimeout(jscClampAllPwpGeneralScrollstripsFirstCell, 100);
  window.setTimeout(jscClampAllPwpGeneralScrollstripsFirstCell, 280);
};

lockJscPwpGeneralScrollstripCellWidths = function (strip) {
  if (!strip || !strip.isConnected) return;
  var inDrawer = jscIsPwpScrollstripInDrawer(strip);
  var rectW = strip.getBoundingClientRect().width || 0;
  var cw = strip.clientWidth || 0;
  var w = 0;
  if (inDrawer) {
    var base =
      rectW > 0 && cw > 0 ? Math.min(rectW, cw) : Math.max(rectW, cw);
    if (!(base > 0)) return;
    /** Ceil avoids flex rounding under CSS transform so slides are not narrower than viewport (next cell peek). */
    w = Math.max(1, Math.ceil(base - 1e-4));
  } else {
    w = Math.max(1, Math.round(cw > 0 ? cw : rectW || 0));
  }
  if (w < 1) return;
  strip.style.setProperty('--jsc-pwp-strip-page-px', w + 'px');
  var cards = getJscPwpGeneralStripCardEls(strip);
  for (var i = 0; i < cards.length; i++) {
    var card = cards[i];
    card.style.flexBasis = w + 'px';
    card.style.flexShrink = '0';
    card.style.flexGrow = '0';
    card.style.width = w + 'px';
    card.style.minWidth = w + 'px';
    card.style.maxWidth = w + 'px';
  }
};

unbindJscPwpStripResizeObserver = function (strip) {
  if (strip && strip._jscPwpStripResizeObs) {
    strip._jscPwpStripResizeObs.disconnect();
    strip._jscPwpStripResizeObs = null;
  }
};

bindJscPwpStripResizeObserver = function (strip) {
  if (!strip || typeof ResizeObserver === 'undefined') return;
  unbindJscPwpStripResizeObserver(strip);
  var debounceTimer = null;
  strip._jscPwpStripResizeObs = new ResizeObserver(function () {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      var $wrap = $(strip).closest('.jsc-pwp-general-scrollstrip-wrap');
      lockJscPwpGeneralScrollstripCellWidths(strip);
      if ($wrap.length && $wrap.hasClass('jsc-pwp-strip-awaiting')) {
        finalizeJscPwpScrollstripWrap($wrap);
      } else {
        try {
          strip.scrollTo({ left: strip.scrollLeft, top: 0, behavior: 'instant' });
        } catch (e) {
          /* keep */
        }
        if ($wrap.length) {
          var sl = strip.scrollLeft;
          var firstOff = (function () {
            var cc = getJscPwpGeneralStripCardEls(strip);
            return cc.length ? Math.round(cc[0].offsetLeft) : 0;
          })();
          if (sl <= 12 && Math.abs(sl - firstOff) > 3 && sl < strip.clientWidth * 0.5) {
            jscClampPwpScrollstripToFirstCell(strip, $wrap);
          }
          updateJscPwpGeneralScrollstripNav($wrap);
        }
      }
    }, 32);
  });
  strip._jscPwpStripResizeObs.observe(strip);
};

getJscPwpGeneralStripCardEls = function (strip) {
  if (!strip || !strip.querySelectorAll) return [];
  return [].slice.call(strip.querySelectorAll(':scope > .pwp-product-card'));
};

getJscPwpGeneralStripActiveIndex = function (strip) {
  var cards = getJscPwpGeneralStripCardEls(strip);
  if (!cards.length) return 0;
  var probe = strip.scrollLeft + Math.min(64, strip.clientWidth * 0.2);
  for (var i = 0; i < cards.length; i++) {
    var right = i + 1 < cards.length ? cards[i + 1].offsetLeft : strip.scrollWidth;
    if (probe < right) return i;
  }
  return cards.length - 1;
};

scrollJscPwpGeneralStripToIndex = function (strip, index) {
  var cards = getJscPwpGeneralStripCardEls(strip);
  if (index < 0 || index >= cards.length) return;
  var maxScroll = Math.max(0, strip.scrollWidth - strip.clientWidth);
  var left =
    index === cards.length - 1
      ? maxScroll
      : Math.round(cards[index].offsetLeft);
  strip.scrollTo({ left: left, behavior: 'smooth' });
};

updateJscPwpGeneralScrollstripNav = function ($wrap) {
  if (!$wrap || !$wrap.length) return;
  var strip = $wrap.find('.jsc-pwp-general-scrollstrip')[0];
  if (!strip) return;
  var cards = getJscPwpGeneralStripCardEls(strip);
  if (!cards.length) return;
  var idx = getJscPwpGeneralStripActiveIndex(strip);
  var maxScroll = Math.max(0, strip.scrollWidth - strip.clientWidth);
  var sl = strip.scrollLeft;
  var tol = 8;
  var atStart = cards.length <= 1 || idx <= 0 || sl <= tol;
  var atEnd =
    cards.length <= 1 ||
    idx >= cards.length - 1 ||
    (maxScroll > 0 && sl >= maxScroll - tol);
  $wrap.find('.jsc-pwp-general-scrollstrip-nav--prev').prop('disabled', atStart).toggleClass('is-disabled', atStart);
  $wrap.find('.jsc-pwp-general-scrollstrip-nav--next').prop('disabled', atEnd).toggleClass('is-disabled', atEnd);
};

initJscPwpGeneralScrollstripNav = function () {
  $('.jsc-pwp-general-scrollstrip-wrap').each(function () {
    var $wrap = $(this);
    if (!$wrap.hasClass('is-jsc-pwp-strip-stable')) {
      $wrap.addClass('jsc-pwp-strip-awaiting');
    }
    var strip = $wrap.find('.jsc-pwp-general-scrollstrip')[0];
    if (strip) {
      lockJscPwpGeneralScrollstripCellWidths(strip);
      bindJscPwpStripResizeObserver(strip);
    }
    updateJscPwpGeneralScrollstripNav($wrap);
    finalizeJscPwpScrollstripWrap($wrap);
  });
};

/**
 * Cart GWP/PWP combined offers slider (prev/next). Re-bind after main-cart AJAX re-render
 * because inline scripts outside .jsc-pwp-pdp-section do not re-run via runPwpSectionScripts.
 */
initJscCartOffersSlider = function () {
  var section = document.getElementById('jsc-tier-gwp-cart-section');
  if (!section) return;
  var track = section.querySelector('[data-tier-gwp-track]');
  var slides = track ? track.querySelectorAll('.jsc-tier-gwp-slide') : [];
  var prev = section.querySelector('.jsc-tier-gwp-prev');
  var next = section.querySelector('.jsc-tier-gwp-next');
  var titleEl = section.querySelector('.jsc-tier-gwp-dynamic-title');
  if (!track || slides.length < 2 || !prev || !next) return;

  // Fresh nodes after AJAX; clone buttons to drop any leftover listeners if init runs twice.
  var prevClone = prev.cloneNode(true);
  var nextClone = next.cloneNode(true);
  prev.parentNode.replaceChild(prevClone, prev);
  next.parentNode.replaceChild(nextClone, next);
  prev = prevClone;
  next = nextClone;

  var index = 0;
  var maxIndex = slides.length - 1;
  var setState = function () {
    track.style.transform = 'translateX(' + (index * -100) + '%)';
    prev.disabled = index <= 0;
    next.disabled = index >= maxIndex;
    if (titleEl && slides[index]) {
      titleEl.textContent = slides[index].getAttribute('data-title') || titleEl.textContent;
    }
  };

  prev.addEventListener('click', function () {
    if (index > 0) {
      index -= 1;
      setState();
    }
  });
  next.addEventListener('click', function () {
    if (index < maxIndex) {
      index += 1;
      setState();
    }
  });

  setState();
};

/**
 * True while a complementary slider still has cells but Flickity is not attached (drawer PWP general is handled elsewhere).
 */
complementaryFlickityNeedsInit = function () {
  var pending = false;
  $('.flickity-complementary').not('.flickity-complementary--pwp-general').each(function () {
    var $el = $(this);
    if ($el.find('.product-card').length && !$el.hasClass('flickity-enabled')) pending = true;
  });
  $('.flickity-complementary--pwp-general').each(function () {
    var $el = $(this);
    if ($el.closest('#Product-Drawer').length) return;
    if ($el.find('.pwp-product-card').length && !$el.hasClass('flickity-enabled')) pending = true;
  });
  return pending;
};

/**
 * @param { { initOnly?: boolean } } [opts] Pass initOnly:true from the poll loop to avoid resize() every tick; omit for layout fixes after load/cart.
 */
applyComplementaryFlickity = function (opts) {
  var initOnly = opts && opts.initOnly;
  $('.flickity-complementary').not('.flickity-complementary--pwp-general').each(function () {
    var $el = $(this);
    if ($el.find('.product-card').length && !$el.hasClass('flickity-enabled')) {
      $el.flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        groupCells: false,
        wrapAround: false,
        draggable: true,
        autoPlay: 2000,
        prevNextButtons: false
      });
    } else if (!initOnly && $el.hasClass('flickity-enabled')) {
      var flktyClassic = $el.data('flickity');
      if (flktyClassic) {
        try {
          flktyClassic.resize();
        } catch (e) {
          /* noop */
        }
      }
    }
  });
  $('.flickity-complementary--pwp-general').each(function () {
    var $el = $(this);
    if ($el.closest('#Product-Drawer').length) return;
    if ($el.find('.pwp-product-card').length && !$el.hasClass('flickity-enabled')) {
      $el.flickity(jscPwpGeneralFlickityOptions);
    } else if (!initOnly && $el.hasClass('flickity-enabled')) {
      var flktyPwp = $el.data('flickity');
      if (flktyPwp) {
        try {
          flktyPwp.resize();
        } catch (e) {
          /* noop */
        }
      }
    }
  });
};

initComplementary = () => {
  var ticks = 0;
  var maxTicks = 300;
  var timer = setInterval(function () {
    ticks += 1;
    var waitingRecommendations =
      $('product-recommendations:not(.product-recommendations--loaded)').length > 0;
    applyComplementaryFlickity({ initOnly: true });
    var needsInit = complementaryFlickityNeedsInit();
    if ((!needsInit && !waitingRecommendations) || ticks >= maxTicks) {
      clearInterval(timer);
      applyComplementaryFlickity();
    }
  }, 100);
};

initCartDrawerYMLSlider = () => {
  const intervalId = setInterval(() => {
    if ($('.cart-drawer--recommendations--products').length > 0) {
      var flkty = new Flickity('.jsc-yml-carousel', {
        // options
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        wrapAround: true,
        draggable: true,
        prevNextButtons: false,
        autoPlay: false,
        adaptiveHeight: false,
        groupCells: true,
      });

      clearInterval(intervalId);
    }
  }, 100);
  
  setTimeout(() => {
    clearInterval(intervalId);
  }, 10000);
}

destroyFAQSlider = () =>{
    $('.jsc-carousel').flickity();
    $('.jsc-carousel').flickity('destroy');
}

destroyCarouselstore = () =>{
  $('.jsc-stores-carousel .shg-row').flickity();
  $('.jsc-stores-carousel .shg-row').flickity('destroy');
  var screenWidth = $(window).width();
  if (screenWidth <= 767) {
    $('.jsc-stores-carousel .shg-row').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      wrapAround: true,
      groupCells: false,
      prevNextButtons: false
    });
    $('.jsc-stores-carousel .shg-row').flickity('destroy');
    $('.jsc-stores-carousel .shg-row').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      wrapAround: true,
      groupCells: false,
      prevNextButtons: false
    });
  } else {
    $('.jsc-stores-carousel .shg-row').flickity({
      // options
      cellAlign: 'center',
      contain: true,
      pageDots: true,
      wrapAround: true,
      groupCells: false,
      prevNextButtons: false
    });
    $('.jsc-stores-carousel .shg-row').flickity('destroy');
    $('.jsc-stores-carousel .shg-row').flickity({
      // options
      cellAlign: 'center',
      contain: true,
      pageDots: true,
      wrapAround: true,
      groupCells: false,
      prevNextButtons: false
    });
  }
  $('.jsc-stores-carousel .flickity-page-dots').each(function() {
    var dotsize = $(this).find('.flickity-page-dot').length;
    var dotwidth = 100/dotsize;
    $(this).find('.flickity-page-dot').css("width", dotwidth + "%");
  });
}

destroyYMLSlider = () =>{
  $('.jsc-yml-carousel').flickity();
  $('.jsc-yml-carousel').flickity('destroy');
}

var prevWidth = window.innerWidth;
$( window ).resize(function() {
  var width = window.innerWidth;
  if (width !== prevWidth) {
  destroyFAQSlider();
  initFaqSlider();
  destroyYMLSlider();
  initCartDrawerYMLSlider();
  destroyFeaturedCollectionSlider();
  initFeaturedCollectionSlider();
  destroyCarouselstore();
}
});

editAddressForm = (evt) => {
  var addressID = $(evt).attr('data-address-id');
  console.log("addressID", addressID);

  var matchingElement = $('#EditAddress_' + addressID + '.jsc-edit-address-form');
  var addressRow = $('.jsc-address-view[data-address-id="' + addressID + '"]');

  if (matchingElement.attr('open')) {
    matchingElement.removeAttr('open');
    matchingElement.hide();
    addressRow.show();
  } else {
    $('.jsc-edit-address-form[open]').removeAttr('open').hide();
    $('.jsc-address-view').show();

    // Open the clicked form
    matchingElement.attr('open', '');
    matchingElement.show();
    addressRow.hide();
  }
}
addAddressForm = (evt) => {

  if ($('.jsc-add-address-form').attr('open')) {
    $('.jsc-add-address-form').removeAttr('open');
    $('.jsc-add-address-form').hide();
    $('.jsc-add-new-address-button').show();
  } else {
    $('.jsc-add-address-form').attr('open', '');
    $('.jsc-add-address-form').show();
    $('.jsc-add-new-address-button').hide();
  }
}

toggleDropDownIcon = (select) => {
  var isFirstClick = true;
  var parentElement = $(select).parent();
  var selectArrow = parentElement.find('.select-arrow');
  selectArrow.data('rotation', 0);

  $(select).on('click blur', function(event) {
      if (event.type === 'click') {
          if (isFirstClick) {
              selectArrow.css('transform', 'translateY(-50%) rotate(-180deg)');
              isFirstClick = false;
          } else {
              var currentRotation = selectArrow.data('rotation') || 0;
              var newRotation = currentRotation == 0 ? -180 : 0;
              selectArrow.css('transform', 'translateY(-50%) rotate(' + newRotation + 'deg)');
              selectArrow.data('rotation', newRotation);
          }
      } else if (event.type === 'blur') {
          selectArrow.css('transform', 'translateY(-50%) rotate(0deg)');
          selectArrow.data('rotation', 0);
      }
  });
}

applyToSelectInput = () => {
  $('.jsc-select_input').each(function() {
    toggleDropDownIcon(this);
  });
}

//set User birthday
setCustomerbirthday = (element) =>{
  var $targetElement = $(element);
  var $ancestor = $targetElement.closest('.shopify-section');
  var selectedSectionID = $ancestor.attr('id').replace('shopify-section-','').replace(' ','');
  var selectedSectionIDpath = "?sections=" + $ancestor.attr('id').replace('shopify-section-','').replace(' ','');

  var $return = {};
  $return['mail'] = $('#email-address').val();

  var cusDay = parseInt($('#birthday_date_day').val());
  var cusMonth = parseInt($('#birthday_date_month').val());
  var cusYear = parseInt($('#birthday_date_year').val());

  var $fulldate =   refulldate = cusDay + '/' + cusMonth  + '/' + cusYear ; 

  if ((!isNaN(cusDay) && cusDay != "") && (!isNaN(cusMonth) && cusMonth != "") && (!isNaN(cusYear) && cusYear != "")) {

    console.log(cusDay,cusMonth,cusYear);
    $return['day'] = cusDay;
    $return['month'] = cusMonth;
    $return['year'] = cusYear;

    console.log($return,$fulldate);

    var settings = {
        "url": "https://webhooks.mechanic.dev/c4848e00-ebb7-4264-9d57-fe44fd8f5ea7",
        "method": "POST",
        "headers": {
            "Content-Type": "application/json"
        },
        "data" : JSON.stringify($return)
    };
    $.ajax(settings).done(function(r){
        console.log('success webhook');
        var retryCount = 0;
        var maxRetries = 20;

        fetchAndUpdateContent = () => {
          fetch(window.location.pathname + selectedSectionIDpath)
          .then(res => res.json())
          .then((restext) => {
            // Extract new content from fetched data
            var newContent = restext[selectedSectionID];
            var $tempElement = $('<div>').html(newContent);
            var content = $tempElement.find('.jsc_info_account_title.jsc-main-account-info').text();
            
            if (content.trim() !== "") {
            clearInterval(intervalID); 
            $ancestor.children().remove();
            $ancestor.html(newContent);
            } else if (retryCount >= maxRetries) {
            clearInterval(intervalID); 
            location.reload();
            }
          })
          .catch((error) => {
            console.error('Error fetching content:', error);
            retryCount++;
          });
  
          retryCount++;
        };
      var intervalID = setInterval(fetchAndUpdateContent, 500);
    }).fail(function(response) {
      console.log("error");
      console.log(response);
      // Happens when something goes wrong
    });
  }else{
    
    $('.birthday_input_error').show();
    setTimeout(function(){
      $('.birthday_input_error').hide();
    }, 2000);
  }
}

//set User name
setCustomerName = () =>{
  var $return = {};
  $return['mail'] = $('#email-address').val();
  $return['firstName'] = $('#userFirstName').val();
  $return['lastName'] = $('#userLastName').val();

  console.log($return);

  if (($return['mail'] != "") && ($return['firstName'] != "") && ($return['lastName'] != "")) {

    var settings = {
        "url": "https://webhooks.mechanic.dev/edd2d8cb-7fa2-4b3e-8b0c-73a341c4bdf2",
        "method": "POST",
        "headers": {
            "Content-Type": "application/json"
        },
        "data" : JSON.stringify($return)
    };
    $.ajax(settings).done(function(r){
        console.log('success webhook');
        setTimeout(function(){
          location.reload();
        }, 2000);
    }).fail(function(response) {
        console.log("error");
        console.log(response);
        // Happens when something goes wrong
    });
  }else{
    $('.name_input_error').show();
    setTimeout(function(){
      $('.name_input_error').hide();
    }, 2000);
  }
}

showEditNameForm = () => {
  $('.jsc-account-details-data').hide();
  $('.jsc-edit-name-button').hide();
  $('#jsc-edit-name-form').show();
}

cancelNameForm = () => {
  $('.jsc-account-details-data').show();
  $('.jsc-edit-name-button').show();
  $('#jsc-edit-name-form').hide();
}
updateGridHeightblog = () => {
  var $maxHeight = 0;
  $('.blog-post-list').each(function(){
    var $ConTentHeight = $(this).outerHeight();
    if ($maxHeight < $ConTentHeight) {
      $maxHeight = $ConTentHeight;
    }

  });
  $('.blog-post-list').css("height", $maxHeight + "px");

  var prevWidth = window.innerWidth;
  $( window ).resize(function() {
    var width = window.innerWidth;
    if (width !== prevWidth) {
    $('.blog-post-list').removeAttr("style");

    setTimeout(function(){
      var $maxHeight = 0;
      $('.blog-post-list').each(function(){
        var $ConTentHeight = $(this).outerHeight();
        if ($maxHeight < $ConTentHeight) {
          $maxHeight = $ConTentHeight;
        }

      });
      $('.blog-post-list').css("height", $maxHeight + "px");
    },1000);
  }

  });
}

checkScreenSizeForOrderPagination = () => {
  var screenWidth = $(window).width();
  if (screenWidth <= 480) {
      $('.jsc-order-desktop-view').hide();
      $('.jsc-order-mobile-view').show();
  } else {
      $('.jsc-order-desktop-view').show();
      $('.jsc-order-mobile-view').hide();
  }
}

var interReturnGoButton;
returnPortalAdjustMargin = () => {
  var totalElements = $('.ReturnGO_UploadImages-module_uploadedImageWrapper').length;
  var screenWidth = $(window).width();
  console.log("totalElements", totalElements);
  if ((totalElements == 0)  && screenWidth <= 480) {
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('no-margin-bottom');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '0px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-270px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('padding-top', '0px');

  }else if ((totalElements == 0)  && screenWidth <= 390) {
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('no-margin-bottom');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '0px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-270px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-230px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-180px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('padding-top', '0px');

  }else if ((totalElements == 1 || totalElements == 2) && screenWidth <= 480) {
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('no-margin-bottom');
    $('#returnGoAssistant .ReturnGO_UploadImages-module_uploadImages .ReturnGO_UploadImages-module_upload').css('bottom', '-50px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '50px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-270px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-230px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-180px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('padding-top', '0px');

  }else if (totalElements == 3 && screenWidth > 390 && screenWidth <= 480) {
    $('.ReturnGO_UploadImages-module_uploadImages').css('margin-bottom', '140px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('no-margin-bottom');
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('height-270px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '0px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('padding-top', '7px');
    $('#returnGoAssistant .ReturnGO_UploadImages-module_uploadImages .ReturnGO_UploadImages-module_upload').css('bottom', '-150px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-120px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-180px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-230px');

  }
  else if (totalElements == 3 && screenWidth <= 390) {
    $('.ReturnGO_UploadImages-module_uploadImages').css('margin-bottom', '140px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('no-margin-bottom');
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('height-230px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '0px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('padding-top', '7px');
    $('#returnGoAssistant .ReturnGO_UploadImages-module_uploadImages .ReturnGO_UploadImages-module_upload').css('bottom', '-150px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-120px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-270px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-180px');

  }else if (totalElements == 4 && screenWidth > 390 && screenWidth <= 480){
    $('.ReturnGO_UploadImages-module_uploadImages').css('margin-bottom', '100px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('no-margin-bottom');
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('height-180px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '90px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-120px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-270px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-230px');

  }else if (totalElements == 4 && screenWidth <= 390){
    $('.ReturnGO_UploadImages-module_uploadImages').css('margin-bottom', '100px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('no-margin-bottom');
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('height-180px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '50px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-120px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-270px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-230px');

  }else if (screenWidth > 480){
    $('.ReturnGO_UploadImages-module_uploadImages').addClass('no-margin-bottom');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('margin-top', '0px');
    $('#returnGoAssistant #returnGoWrapper .ReturnGO_Footer-module_footer').css('padding-top', '0px');
    $('#returnGoAssistant .ReturnGO_UploadImages-module_uploadImages .ReturnGO_UploadImages-module_upload').css('bottom', '0px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-270px');
    $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-230px');
    if(totalElements <= 3){
      $('.ReturnGO_UploadImages-module_uploadImages').addClass('height-180px');
      $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-120px');
    }else{
      $('.ReturnGO_UploadImages-module_uploadImages').addClass('height-120px');
      $('.ReturnGO_UploadImages-module_uploadImages').removeClass('height-180px');
    }

  }
}

handleUploadButtonClick = () => {
  console.log("Next button clicked!");
  var selectedElements = $('.ReturnGO_UploadImages-module_uploadImages').length;
  if (selectedElements == 1){
    var intervalId = setInterval(returnPortalAdjustMargin, 1000); // Adjust the interval time as needed
  }
  interReturnGoButton = setInterval(checkAndUpdateReturnGoButtonText, 1000); // Adjust the interval time as needed
}

// preventSearchBarToScroll = () => {
//   $('.search-field').on('keypress', function(event) {
//       event.preventDefault();

//       $(this).val($(this).val() + event.key);
//       console.log("Log", event.key);
//   });
// }

preventSearchBarToScroll = () => {
  var allowedCharacters = /^[a-zA-Z0-9\s\.\,\!\@\#\$\%\^\&\*\(\)\-\_\=\+\[\]\{\}\\\|\;\'\:\"\,\.\/\<\>\?`~]*$/;
  var keysToBlock = ['Tab','F1','F2','F3','F4','F5','F6','F7','F8','F9','F10','F11','F12','Escape','ScrollLock',
                    'Insert','Pause','Home','PageUp','Delete','End','PageDown','NumLock','ContextMenu','CapsLock'];

  $('.search-field').on('keydown', function(event) {
    var oldScroll = $(window).scrollTop();

    $( window ).one('scroll', function() {
        $(window).scrollTop( oldScroll ); //disable scroll just once
    });
  });
}


//Start - Marquee function
newBlogMarquee = () =>{
  var promoNum = parseInt($('#scroll_textblog').length);
  if (promoNum >= 1) {
    // $('#scroll_textblog').addClass('p-b-23');
    $('#scroll_textblog').marquee({

    //If you wish to always animate using jQuery
    allowCss3Support: true,

    //works when allowCss3Support is set to true - for full list see http://www.w3.org/TR/2013/WD-css3-transitions-20131119/#transition-timing-function
    css3easing: 'linear',

    //requires jQuery easing plugin. Default is 'linear'
    easing: 'linear',

    //pause time before the next animation turn in milliseconds
    delayBeforeStart: 1000,
    //'left', 'right', 'up' or 'down'
    direction: 'left',

    //true or false - should the marquee be duplicated to show an effect of continues flow
    duplicated: true,

    //speed in milliseconds of the marquee in milliseconds
    duration: 45000,

    //gap in pixels between the tickers
    gap: 20,

    //on cycle pause the marquee
    pauseOnCycle: false,

    //on hover pause the marquee - using jQuery plugin https://github.com/tobia/Pause
    pauseOnHover: false,

    //the marquee is visible initially positioned next to the border towards it will be moving
    startVisible: false

    });
  }

}

newMarquee = () =>{
  var promoNum = parseInt($('#numOfPromo').val());
  if (promoNum > 1) {
    // $('#scroll_text').addClass('p-b-23');
    $('#scroll_text, #scroll_text_desktop').marquee({

    //If you wish to always animate using jQuery
    allowCss3Support: true,

    //works when allowCss3Support is set to true - for full list see http://www.w3.org/TR/2013/WD-css3-transitions-20131119/#transition-timing-function
    css3easing: 'linear',

    //requires jQuery easing plugin. Default is 'linear'
    easing: 'linear',

    //pause time before the next animation turn in milliseconds
    delayBeforeStart: 1000,
    //'left', 'right', 'up' or 'down'
    direction: 'left',

    //true or false - should the marquee be duplicated to show an effect of continues flow
    duplicated: true,

    //speed in milliseconds of the marquee in milliseconds
    duration: 21000,

    //gap in pixels between the tickers
    gap: 20,

    //on cycle pause the marquee
    pauseOnCycle: false,

    //on hover pause the marquee - using jQuery plugin https://github.com/tobia/Pause
    pauseOnHover: false,

    //the marquee is visible initially positioned next to the border towards it will be moving
    startVisible: false

    });
  }

}
//End - Marquee function
//Start - Toggle Size
togglesizenew = (evt) => {
  var ischecked= $(evt).find('input').is(':checked');
  if (ischecked == true) {
    $(evt).parents('.prod-measurement-accordion').find(".cmdescription").each(function () {
      $(this).removeClass("activetogglesize");
    });
    $(evt).parents('.prod-measurement-accordion').find(".inchdescription").each(function () {
      $(this).addClass("activetogglesize");
    });
  }else{
    $(evt).parents('.prod-measurement-accordion').find(".cmdescription").each(function () {
      $(this).addClass("activetogglesize");
    });
    $(evt).parents('.prod-measurement-accordion').find(".inchdescription").each(function () {
      $(this).removeClass("activetogglesize");
    });
  }
}
togglesize = (evt) => {
  var ischecked= $(evt).find('input').is(':checked');
  var iscmadded= $(evt).attr("data-cm-added");
  if (!iscmadded) {
    $(evt).parents('.product-information--inner').find(".size_chart_table td:not(.size_table_color)").each(function () {
      var datacm = $(this).text();
      $(this).attr("data-cm",datacm);
    });
  }
  $(evt).attr("data-cm-added", 'true');
  if (ischecked == true) {
    $(evt).parents('.product-information--inner').find(".size_chart_table td:not(.size_table_color)").each(function () {
      if ($(this).attr("data-cm").includes('-')) {
        var cmarray = $(this).attr("data-cm").split("-");
        var datacmconvert1 = parseInt(cmarray[0]);
        var datainconvert1 = datacmconvert1/2.54;
        datainconvert1 = parseFloat(datainconvert1.toFixed(2));
        var datacmconvert2 = parseInt(cmarray[1]);
        var datainconvert2 = datacmconvert2/2.54;
        datainconvert2 = parseFloat(datainconvert2.toFixed(2));
        $(this).text(datainconvert1 + '-' + datainconvert2)
      }else{
      var datacmconvert = parseInt($(this).attr("data-cm"));
      var datainconvert = datacmconvert/2.54;
      datainconvert = parseFloat(datainconvert.toFixed(2));
      $(this).text(datainconvert)
      }
    });
  }else{
    $(evt).parents('.product-information--inner').find(".size_chart_table td:not(.size_table_color)").each(function () {
      var datacmconvert = $(this).attr("data-cm");
      $(this).text(datacmconvert)
    });
  }
}
togglesizepopupnew = (evt) => {
  var ischecked = $(evt).find('input').is(':checked');
  if (ischecked == true) {
    $(evt).parents('.sizepopup').find(".switch input").prop('checked',true);
    var selectedtab = $(evt).parents('.sizepopup').find(".sizepopupcm").find(".js-active").attr("href");
    $(evt).parents('.sizepopup').find(".sizepopupinch").find(".tabs a").each(function () {
      if ($(this).attr("href") == selectedtab) {
        $(this).click();
      }
    });
    $(evt).parents('.sizepopup').find(".sizepopupcm").each(function () {
      $(this).removeClass("activesizepopupcont");
    });
    $(evt).parents('.sizepopup').find(".sizepopupinch").each(function () {
      $(this).addClass("activesizepopupcont");
    });
  }else{
    $(evt).parents('.sizepopup').find(".switch input").prop('checked',false);
    var selectedtab = $(evt).parents('.sizepopup').find(".sizepopupinch").find(".js-active").attr("href");
    $(evt).parents('.sizepopup').find(".sizepopupcm").find(".tabs a").each(function () {
      if ($(this).attr("href") == selectedtab) {
        $(this).click();
      }
    });
    $(evt).parents('.sizepopup').find(".sizepopupcm").each(function () {
      $(this).addClass("activesizepopupcont");
    });
    $(evt).parents('.sizepopup').find(".sizepopupinch").each(function () {
      $(this).removeClass("activesizepopupcont");
    });
  }
}
togglesizepopup = (evt) => {
  var ischecked= $(evt).find('input').is(':checked');
  var iscmadded= $(evt).attr("data-cm-added");
  if (!iscmadded) {
    $(evt).parents('.sizepopup').find(".size_chart_table td:not(.size_table_color)").each(function () {
      var datacm = $(this).text();
      $(this).attr("data-cm",datacm);
    });
  }
  $(evt).attr("data-cm-added", 'true');
  if (ischecked == true) {
    $(evt).parents('.sizepopup').find(".size_chart_table td:not(.size_table_color)").each(function () {
      if ($(this).attr("data-cm").includes('-')) {
        var cmarray = $(this).attr("data-cm").split("-");
        var datacmconvert1 = parseInt(cmarray[0]);
        var datainconvert1 = datacmconvert1/2.54;
        datainconvert1 = parseFloat(datainconvert1.toFixed(2));
        var datacmconvert2 = parseInt(cmarray[1]);
        var datainconvert2 = datacmconvert2/2.54;
        datainconvert2 = parseFloat(datainconvert2.toFixed(2));
        $(this).text(datainconvert1 + '-' + datainconvert2)
      }else{
      var datacmconvert = parseInt($(this).attr("data-cm"));
      var datainconvert = datacmconvert/2.54;
      datainconvert = parseFloat(datainconvert.toFixed(2));
      $(this).text(datainconvert)
      }
    });
  }else{
    $(evt).parents('.sizepopup').find(".size_chart_table td:not(.size_table_color)").each(function () {
      var datacmconvert = $(this).attr("data-cm");
      $(this).text(datacmconvert)
    });
  }
}
appendtogglesize = () => {
  $(".sizepopup .tabs-content li table:first-child tr:not(.size_table_color) th").each(function () {
    $(this).append('<div class="togglesize"><span>CM</span><label onclick="togglesizepopupnew(this);" class="switch"><input type="checkbox"><span class="slider round"></span></label><span>IN</span></div>');
  });
  if ($(".sizepopup .tabs-content li table:first-child tr:not(.size_table_color) th").length <= 0) {
    $(".sizepopup .tabs-content").each(function () {
      $('<div class="togglesize"><span>CM</span><label onclick="togglesizepopupnew(this);" class="switch"><input type="checkbox"><span class="slider round"></span></label><span>IN</span></div>').insertBefore(this);
    });
  }
}
closesizepopup = () =>{
  $('.sizepopupoverlay').hide();
  $('.sizepopup').hide();
  $("body").css('overflow', 'auto');
}
//End - Toggle Size

// start: update quick view overlay
updateOverlay = () => {
  $('#wrapper .click-capture').css('z-index', '52');
}
// end: update quick view overlay

checkAndUpdateReturnGoButtonText = () => {
  var backButton = $(".ReturnGO_Button-module_secondary");
  var backButtonSpan = backButton.find("span");
  if (backButtonSpan.text().trim() === "Go Back") {
    backButtonSpan.text("Back");
  }
}

shopLookHover = () => {

  $('.shop-the-look').each(function() {
    $(this).on('mouseenter', function(event) {
      $(this).find('.thb-hotspot-content').addClass('ishover');
    });

    $(this).on('mouseleave', function(event) {
      $('.thb-hotspot-content').removeClass('ishover');
    });
    // For mobile & ipad device (if needed)
    // $(this).on('touchstart click', function(event) {
    //   event.stopPropagation();
    //   $('.thb-hotspot-content').removeClass('ishover');
    //   $(this).find('.thb-hotspot-content').addClass('ishover');
    // });

    // $(document).on('touchstart click', function() {
    //   $('.thb-hotspot-content').removeClass('ishover');
    //   console.log($(document));
    // });
  });
}

featureCollectionAutoTitleSwitcher = () => {
  if ($('.jsc-fc-slider-carousel').length == 0) {
    var $fcTitle = $('.featured-collection-list--inner--content .featured-collection-list--button');
    var $fcImage = $('.featured-collection-list--bg .jsc-feat-coll-image');
    var setIntervalTime = parseInt($('#setTitleSwithcherIntervalTime').val());
    var totalNumberFCTitle = $fcTitle.length;

    var currentIndex = 0;
    var switchInterval;

    switchToNextButton = () => {
      $fcTitle.removeClass('active');
      $fcImage.find('.featured-collection-list--img').removeClass('active');

      currentIndex = (currentIndex + 1) % totalNumberFCTitle;
      $fcTitle.eq(currentIndex).addClass('active');
      $fcImage.eq(currentIndex).find('.featured-collection-list--img').addClass('active');
    }

    startSwitching = () => {
      switchInterval = setInterval(switchToNextButton, setIntervalTime);
    }

    stopSwitching = () => {
      clearInterval(switchInterval);
    }

    $fcTitle.eq(currentIndex).addClass('active');
    $fcImage.eq(currentIndex).find('.featured-collection-list--img').addClass('active');

    startSwitching();

    $fcTitle.hover(
      function() {
        // When hover starts, stop the auto switch
        stopSwitching();
        // Update the currentIndex to the hovered button index
        currentIndex = $fcTitle.index(this);
      },
      function() {
        // When hover ends, resume the auto switch
        startSwitching();
      }
    );
  }
}

updateProductAddToCartSticky = () => {
  var contentElement = $(".product-add-to-cart-sticky--content");
  var plusElement = $(".product-add-to-cart-sticky--inner .plus");
  var minusElement = $(".product-add-to-cart-sticky--inner .minus");
  var back_to_top = $(".back-to-top");

  if (contentElement.hasClass("active")) {
    plusElement.hide();
    minusElement.show();
    back_to_top.css("z-index", 1);
  } else {
    plusElement.show();
    minusElement.hide();
    back_to_top.css("z-index", 30);
  }
}

removeQuantitySelectorOverlay = () => {
  $('.minus').removeAttr('disabled');
  $('.minus.jsc-quantity-selector-overlay').removeClass('jsc-quantity-selector-overlay');
  // Keep Liquid-locked preorder + unclickable (do not clear aria-disabled / locked flag)
  $('.plus').not('[data-preorder-plus-locked="true"]').removeAttr('disabled');
  $('.plus.jsc-quantity-selector-overlay').not('[data-preorder-plus-locked="true"]').removeClass('jsc-quantity-selector-overlay');
  $('.plus[data-preorder-plus-locked="true"]').addClass('disabled').attr('aria-disabled', 'true').removeAttr('disabled');
}

headerbgchange = () => {
  setTimeout(function() {
    $('#header').css("background","var(--hamburger-active-color)");
    $('#mobile-menu').css("background","var(--hamburger-active-color)");
    $('.jsc-account-menu').css("background","var(--hamburger-active-color)");
    $('#header').addClass('jsc-second-level-active');
    var isLoggedIn = $('.jsc-second-level-logged-in-icon').attr('data-logged-in');
    if(isLoggedIn){
      $('.jsc-second-level-logged-in-icon').show();
      $('.jsc-logged-in-icon').hide();
    }
  }, 280);
}

headerbgclose = () => {
  setTimeout(function() {
    $('#header').removeAttr("style");
    $('#mobile-menu').removeAttr("style");
    $('.jsc-account-menu').removeAttr("style");
    $('#header').css("background","var(--hamburger-active-color)");
    $('#mobile-menu').css("background","var(--hamburger-active-color)");
    $('.jsc-account-menu').css("background", "var(--hamburger-active-color)");
    $('#header').removeClass('jsc-second-level-active');
    var isLoggedIn = $('.jsc-second-level-logged-in-icon').attr('data-logged-in');
    if(isLoggedIn){
      $('.jsc-second-level-logged-in-icon').hide();
      $('.jsc-logged-in-icon').show();
    }
  }, 300);
}

let isToggled = false;

cartNotesToggle = () => {
  $(".cart-notes-title").click(function(event) {
    event.preventDefault();

    if (isToggled) {
      $("#CartSpecialInstructions").css({'min-height': '', 'max-height': ''});
      $(this).find(".cart-notes-collapse-plus-icon").show();
      $(this).find(".cart-notes-collapse-minus-icon").hide();
    } else {
      $("#CartSpecialInstructions").css({'min-height': '100px', 'max-height': 'unset'});
      $(this).find(".cart-notes-collapse-plus-icon").hide();
      $(this).find(".cart-notes-collapse-minus-icon").show();

    }
    isToggled = !isToggled;
  });

  $('#CartSpecialInstructions').on('keydown', function(event) {
    if (!isToggled) {
      $(this).css({'min-height': '100px', 'max-height': 'unset'});
      $(".cart-notes-title").find(".cart-notes-collapse-plus-icon").hide();
      $(".cart-notes-title").find(".cart-notes-collapse-minus-icon").show();
      isToggled = true;
    }
  });
}

initWrapperCloseButton = () => {
  var initialBackgroundColor = $('#header').css('background-color');
  var initialHexColor = rgbaToHex(initialBackgroundColor);
  var wrapperOpen = false;
  var $headerSearchWrap = $('.header-search-wrap.header-search-mob-icon');
  var $searchInnerIcon = $('.search-icon .cls-1.jsc-colour-page');
  var $searchIconColor = $('.header-search-wrap.header-search-mobile .search-icon .jsc-colour-page');
  var $headerSearchMobile = $('.header-search-mobile');
  var $whiteIcon = $('.header-search-wrap.header-search-mob-icon .jsc-close-white');
  var $greenIcon = $('.header-search-wrap.header-search-mob-icon .jsc-close-green');
  var $greenIconpath = $('.header-search-wrap.header-search-mob-icon .jsc-close-green path');

  $(document).on('click', '.mobile-toggle-wrapper summary.mobile-toggle', function() {
    setTimeout(function(){
    $('#header').removeAttr("style");
    $('#mobile-menu').removeAttr("style");
    $('.jsc-account-menu').removeAttr("style");
    $('#header').removeClass('jsc-second-level-active');
    $('.jsc-second-level-logged-in-icon').hide();
    $('.jsc-logged-in-icon').show();
    
    if(wrapperOpen){//close
      // $('#header').css("background", "#ffffff");
      $('#mobile-menu').css("background", "var(--hamburger-active-color)");
      $('.jsc-account-menu').css("background", "var(--hamburger-active-color)");
      $('#header').removeClass('jsc-show-secondary-icons');
      $('.mobile-toggle span').css("background", "#000000");
      $('.jsc-account-menu a').css("color", "#000000");
      if ($headerSearchWrap.attr('color-page-active') == 'true') {
        console.log("Wrapper close -1");
        $searchIconColor.css("fill", "#ffffff");
        $searchInnerIcon.css('fill', '#ffffff');
        $greenIconpath.css('stroke', '#ffffff');
        $('.header-search-wrap .searchform.text-white-color fieldset input').css({"border-color": "#ffffff","color": "#ffffff"});
        $('.header-search-wrap .searchform.text-white-color fieldset input').removeClass('jsc-alternate-placeholder-color');
        $('.header-search-wrap .searchform.text-white-color fieldset input::placeholder').css({"color": "#ffffff"});
      }
      wrapperOpen = false;
      console.log('close hamburger menu');
    }else{//open
      console.log('open hamburger menu');
      $('#header').css("background", "var(--hamburger-active-color)");
      $('#mobile-menu').css("background", "var(--hamburger-active-color)");
      $('.jsc-account-menu').css("background", "var(--hamburger-active-color)");
      $('#header').addClass('jsc-show-secondary-icons');
      $('.mobile-toggle span').css("background", "var(--first-level-text-color)");
      $('.jsc-account-menu a').css("color", "var(--first-level-text-color)");
      // $('#mobile-menu .buckscc-select').css("color", "var(--first-level-text-color)");
      $('#mobile-menu .buckscc-select').css({
        "--hxoSelect-color": "var(--first-level-text-color)"
      });
      $('#mobile-menu .buckscc-select .buckscc-select-options').css({
        "--hxoSelect-color": "#000"
      });
      if ($headerSearchWrap.attr('color-page-active') == 'true') {
        console.log("Wrapper open -2");
        // $searchIconColor.css({"fill": "var(--search-color)"});
        // $searchInnerIcon.css({"fill": "var(--search-color)"});
        // $greenIconpath.css('stroke', 'var(--search-color)');
        // $('.header-search-wrap .searchform.text-white-color fieldset input').css({"border-color": "var(--search-color)","color": "var(--search-color)"});
        // $('.header-search-wrap .searchform.text-white-color fieldset input').addClass('jsc-alternate-placeholder-color');
        // $('.header-search-wrap .searchform.text-white-color fieldset input::placeholder').css({"color": "var(--search-color)"});
      }
      wrapperOpen = true;
    }
    }, 250);
  });
}

rgbaToHex = (rgba) => {
  var result = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.?\d*))?\)$/.exec(rgba);
  return result ? "#" +
    ("0" + parseInt(result[1], 10).toString(16)).slice(-2) +
    ("0" + parseInt(result[2], 10).toString(16)).slice(-2) +
    ("0" + parseInt(result[3], 10).toString(16)).slice(-2) +
    (result[4] ? (parseFloat(result[4]) * 255).toString(16).slice(0, 2) : '') : rgba;
}

saveNotesthencheckout = async () => {
  if (document.querySelector('.proceed-to-checkout.jsc-preorder-checkout-disabled') ||
      document.querySelector('.fake-checkout-button.jsc-preorder-checkout-disabled')) {
    return;
  }
  const specialInstructions = document.getElementById('CartSpecialInstructions');
  const checkoutButton = document.querySelector('.thb-cart-form--cart-collaterals .real-checkout-button');
  const cartForm = document.querySelector('.jsc-cart-form');
  
  // Show loading overlay
  if (typeof $ !== 'undefined' && $('.jsc-page-loading').length) {
    $('.jsc-page-loading').show();
  }
  
  // If there's a note, save it first and wait for completion
  // Don't trim yet - we'll trim when saving, but we need to check the raw value first
  if (specialInstructions && specialInstructions.value) {
    // Clear any pending updateNote timeout
    if (window.updateNoteTimeout) {
      clearTimeout(window.updateNoteTimeout);
      window.updateNoteTimeout = null;
    }
    
    // Wait for any pending saves to complete first
    const cartInstance = typeof Cart !== 'undefined' && Cart.getInstance ? Cart.getInstance() : null;
    if (cartInstance && cartInstance.pendingNoteSave) {
      try {
        await cartInstance.pendingNoteSave;
      } catch (error) {
        console.log("Error waiting for pending save:", error);
      }
    }
    
    // Read the note value multiple times to ensure we get the full value
    // Sometimes textarea.value can be incomplete on mobile or during composition
    // Try multiple methods to get the complete value
    let noteValue = specialInstructions.value || '';
    
    // Also try getting value via jQuery if available (sometimes more reliable)
    if (typeof $ !== 'undefined' && $('#CartSpecialInstructions').length) {
      const jqValue = $('#CartSpecialInstructions').val() || '';
      if (jqValue.length > noteValue.length) {
        noteValue = jqValue;
        console.log("jQuery value was longer, using it");
      }
    }
    
    // Use requestAnimationFrame to ensure DOM is fully updated
    await new Promise(resolve => requestAnimationFrame(resolve));
    
    // Re-read value after animation frame - try all methods again
    const directValue = specialInstructions.value || '';
    const jqValue2 = (typeof $ !== 'undefined' && $('#CartSpecialInstructions').length) ? $('#CartSpecialInstructions').val() || '' : '';
    
    // Use the longest value to ensure we get everything
    if (directValue.length > noteValue.length) {
      noteValue = directValue;
    }
    if (jqValue2.length > noteValue.length) {
      noteValue = jqValue2;
    }
    
    // Log the value being saved for debugging
    console.log("Saving note (length:", noteValue.length, "chars):", noteValue.substring(0, 100) + (noteValue.length > 100 ? '...' : ''));
    
    // Save the note and wait for it to complete
    try {
      const response = await fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': noteValue.trim() // Trim only when saving to API
        })
      });
      
      if (response.ok) {
        const responseData = await response.json();
        const savedNote = responseData.note || '';
        const trimmedNote = noteValue.trim();
        console.log("Note saved before checkout. Sent length:", trimmedNote.length, "chars, Server saved length:", savedNote.length, "chars");
        
        // Verify the saved note matches what we sent
        if (savedNote !== trimmedNote) {
          console.warn("⚠️ Note mismatch detected!");
          console.warn("Sent:", trimmedNote.substring(0, 150));
          console.warn("Saved:", savedNote.substring(0, 150));
          console.warn("Sent length:", trimmedNote.length, "chars");
          console.warn("Saved length:", savedNote.length, "chars");
          
          // If server saved less, try saving again with the full value
          if (savedNote.length < trimmedNote.length) {
            console.warn("Retrying save with full note value...");
            try {
              const retryResponse = await fetch(`${theme.routes.cart_update_url}.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': `application/json`
                },
                body: JSON.stringify({
                  'note': trimmedNote
                })
              });
              if (retryResponse.ok) {
                const retryData = await retryResponse.json();
                console.log("Retry save successful. New length:", retryData.note ? retryData.note.length : 0);
              }
            } catch (retryError) {
              console.log("Retry save failed:", retryError);
            }
          }
        } else {
          console.log("✓ Note saved successfully and verified");
        }
      } else {
        console.log("Note save failed with status:", response.status);
        const errorText = await response.text();
        console.log("Error response:", errorText);
      }
    } catch (error) {
      console.log("Error saving notes before checkout:", error);
      // Continue to checkout even if save fails
    }
    
    // Clear form's note field to prevent it from submitting its own value
    // The note is already saved via API, so we don't want the form to send a duplicate/incomplete value
    if (cartForm) {
      const formNoteField = cartForm.querySelector('textarea[name="note"]');
      if (formNoteField) {
        // Store the saved value temporarily, then clear it
        // This prevents form from submitting an incomplete value
        formNoteField.setAttribute('data-saved-note', noteValue);
        formNoteField.value = '';
        console.log("Cleared form note field - note already saved via API");
      }
    }
    
    // Small delay to ensure server has fully processed the note
    await new Promise(resolve => setTimeout(resolve, 200));
  }
  
  // No need to hide overlay - page will redirect to checkout anyway
  // Now trigger checkout by clicking the original button
  if (checkoutButton) {
    checkoutButton.click();
  }
}

// Timeout variables for clearing any pending note saves (used by saveNotesthencheckout)
var updateNoteTimeout = null;
window.updateNoteTimeout = null;
var lastInputTime = 0;
var isComposingNote = false; // Track composition state for mobile keyboards

// Track composition events for mobile keyboards (autocorrect, suggestions)
// Track composition state (no longer saving automatically - only save on checkout click)
$(document).on('compositionstart', '#CartSpecialInstructions', function() {
  isComposingNote = true;
});

$(document).on('compositionend', '#CartSpecialInstructions', function() {
  isComposingNote = false;
  lastInputTime = Date.now();
});

bannerLinkInit = (event, bannerLink) => {
  console.log("init banner link");
  var $clickedElement = $(event.target);

  if (!$clickedElement.is('span.h1-large')) {
    window.location.href = bannerLink;
  }
}

initFeaturedCollectionSlider = () => {
  const intervalId = setInterval(() => {
    if ($('.jsc-fc-slider-carousel').length > 0) {
      var flkty = new Flickity('.jsc-fc-slider-carousel', {
        // options
        cellAlign: 'center',
        contain: true,
        pageDots: true,
        wrapAround: true,
        draggable: true,
        prevNextButtons: false,
        autoPlay: false,
        adaptiveHeight: false,
        // Must stay false: title switcher / dots use one index per block (.jsc-feat-coll-image).
        // groupCells: true creates fewer "slides" than cells on wider viewports (incl. some phones
        // in landscape or with zoom), so highlights and autoplay desync from the visible slide.
        groupCells: false,
      });
      var currentHeight = $('.featured-collection-list--bg.jsc-fc-slider-carousel .flickity-viewport').height();
      // console.log("currentHeight", currentHeight);
      $('.featured-collection-list').css('height', currentHeight + 'px');
      // $('.jsc-fc-slider-carousel .flickity-viewport').css('max-height', currentHeight + 'px');
      // $('.jsc-fc-slider-carousel .flickity-viewport').css('height', currentHeight + 'px');
      // $('.jsc-fc-collection-list-slider .featured-collection-list--bg img').css('height', currentHeight + 'px');

      clearInterval(intervalId);
    }
  }, 100);
  
  setTimeout(() => {
    clearInterval(intervalId);
  }, 10000);
}

destroyFeaturedCollectionSlider = () =>{
  $('.jsc-fc-slider-carousel').flickity();
  $('.jsc-fc-slider-carousel').flickity('destroy');
}

featureCollectionAutoTitleSwitcherSlider = () => {
  if ($('.jsc-fc-slider-carousel').length > 0) {
    var $enableTitleSwitcher = $('.jsc-fc-slider-carousel').attr('data-title-switcher');
    var $fcTitle = $('.jsc-fc-collection-list-slider .featured-collection-list--inner--content .featured-collection-list--button');
    var $fcImage = $('.jsc-fc-collection-list-slider .featured-collection-list--bg .jsc-feat-coll-image');
    
    if ($enableTitleSwitcher == "true"){
      var setIntervalTime = parseInt($('#setTitleSwithcherIntervalTime').val());
      var totalNumberFCTitle = $fcTitle.length;
  
      var currentIndex = 0;
      var switchInterval = null;
  
      switchToNextButton = () => {
        $fcTitle.removeClass('active');
        $fcImage.find('.featured-collection-list--img').removeClass('active');
        $fcImage.removeClass('is-selected');
        
        currentIndex = (currentIndex + 1) % totalNumberFCTitle;
  
        $fcTitle.eq(currentIndex).addClass('active');
        $fcImage.eq(currentIndex).find('.featured-collection-list--img').addClass('active');
        $fcImage.eq(currentIndex).addClass('is-selected');
  
        renderFeatCollTextColor();
        
        $('.flickity-page-dot').eq(currentIndex).click();
      }
  
      startSwitching = () => {
        renderFeatCollTextColor();
        if (switchInterval !== null) {
          clearInterval(switchInterval);
        }
        switchInterval = setInterval(switchToNextButton, setIntervalTime);
      }
  
      stopSwitching = () => {
        renderFeatCollTextColor();
        if (switchInterval !== null) {
          clearInterval(switchInterval);
          switchInterval = null;
        }
      }

      var attemptCount = 0;
      var maxAttempts = 30;
      
      checkAndAttachEvent = () => {
        var $elements = $('.buckscc-select-styled');
        if ($elements.length > 0) { 
          $elements.each(function() {
              var $this = $(this);
              if (!$this.data('hasClickListener')) {
                $this.on('click', function() {
                  checkCurrencyVisible($this);
                }).data('hasClickListener', true);
              }
            });
            clearInterval(checkInterval);
        } else if (++attemptCount >= maxAttempts) {
          clearInterval(checkInterval);
        }
      }
      var checkInterval = setInterval(checkAndAttachEvent, 1000);

      $fcTitle.eq(currentIndex).addClass('active');
      $fcImage.eq(currentIndex).find('.featured-collection-list--img').addClass('active');
      $fcImage.eq(currentIndex).addClass('is-selected');

      let isHovered = false;
  
      startSwitching();
      if (window.innerWidth > 1024) {
        $fcTitle.hover(
          function() {
            isHovered = true;
            stopSwitching();
            currentIndex = $fcTitle.index(this);
          },
          function() {
            isHovered = false;
            startSwitching();
          }
        );
      }
  
    $('.jsc-fc-slider-carousel .flickity-page-dots .flickity-page-dot').on('click', function() {

      if (!isHovered) {
        stopSwitching();

        $fcTitle.removeClass('active');
        $fcImage.find('.featured-collection-list--img').removeClass('active');
        $fcImage.removeClass('is-selected');
        
        currentIndex = $('.jsc-fc-slider-carousel .flickity-page-dot').index(this);
        
        $fcTitle.eq(currentIndex).addClass('active');
        $fcImage.eq(currentIndex).find('.featured-collection-list--img').addClass('active');
        $fcImage.eq(currentIndex).addClass('is-selected');
        startSwitching();
      } else {
        stopSwitching();
      }
    });

    $('.jsc-fc-slider-carousel').on('select.flickity', function(event, index) {
      currentIndex = index;
      if (!isHovered) {
        stopSwitching();
        $fcTitle.removeClass('active');
        $fcImage.find('.featured-collection-list--img').removeClass('active');
        $fcImage.removeClass('is-selected');
        $fcTitle.eq(index).addClass('active');
        $fcImage.eq(index).find('.featured-collection-list--img').addClass('active');
        $fcImage.eq(index).addClass('is-selected');
        renderFeatCollTextColor();
        startSwitching();
      } else {
        stopSwitching();
      }
    });
    }else{
      $('.jsc-fc-slider-carousel').on('select.flickity', function(event, index) {
        currentIndex = index;
        $fcTitle.removeClass('active');
        $fcTitle.eq(index).addClass('active');
        renderFeatCollTextColor();
      });
    }

    $(document).on('click', function(event) {
      var $target = $(event.target);
      if ($target.closest('.buckscc-select-styled').length > 0) {
      } else {
        if ($('.buckscc-select-styled').hasClass('active') && $('.buckscc-select-styled').hasClass('deactive')) {
          startSwitching();
        }
      }
    });

    checkCurrencyVisible = (element) => {
      if ($(element).hasClass('active') && $(element).hasClass('deactive')) {
        startSwitching();
      } else if ($(element).hasClass('active')) {
        stopSwitching();
      }
    }
  }
}
renderFeatCollTextColor = () => {
  if($('.jsc-fc-collection-list-slider .featured-collection-list--button').length > 0){
    $('.featured-collection-list--button').each(function() {
      if ($(this).hasClass('active')) {
        var inactiveTextColor = $(this).data('inactive-text');
        $('.featured-collection-list--button').not('.active').css('--color-inactive-text', inactiveTextColor);
        $('.featured-collection-list--button').not('.active').find('span').css('--color-inactive-text', inactiveTextColor);
      }
    });
  }
}
blockBannerLinkInit = (event) => {
  var activeButton = $('.featured-collection-list--button.active');
  if (activeButton.length) {
    activeButton[0].click();
  }
}

earlyaccesslimit = () =>{ 
  setTimeout(function () {
    $('.product-grid-container .product-information--inner').each(function () {
      var thisprodInfo = $(this);            
      $('.var-limit-list').each(function(){
        var varID = $(this).val();
        if (varID == thisprodInfo.find(".variant-selected-form").val()) {
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
          $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").text('You’ve Hit The Max!');
          //For add to cart sticky
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").text('You’ve Hit The Max!');
          //Add to bag and direct to cart page button
          thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
          thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
        }
      });
      $('.var-limit-product-list').each(function(){
        var varID = $(this).val();
        if (varID == thisprodInfo.find(".variant-selected-form").attr('data-prod-id')) {
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
          $('.product-add-to-cart-container').addClass('jsc-hide-payment-button');
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
          thisprodInfo.find(".single-add-to-cart-button:not(.bundle-atc)").text('You’ve Hit The Max!');
          //For add to cart sticky
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").attr('disabled', 'disabled');
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc) .single-add-to-cart-button--text").text('You’ve Hit The Max!');
          $('.product-add-to-cart-sticky--content').find(".single-add-to-cart-button:not(.bundle-atc)").text('You’ve Hit The Max!');
          //Add to bag and direct to cart page button
          thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").addClass('jsc-sold-out-styling');
          thisprodInfo.find(".jsc-buy-it-now-button:not(.bundle-atc)").attr('disabled', 'disabled');
        }
      });
    });
  }, 100);
}

removeItemcart = (varid) =>{
  var jsonObj = {};
  jsonObj[varid] = 0;
  var promise = CartJS.updateItemQuantitiesById(jsonObj);
  // Ensure cart/drawer refresh after remove so PWP limit state (e.g. .jsc-pwp-limit-new) is re-rendered and add-back works
  if (promise && typeof promise.then === 'function') {
    promise.then(function() {
      document.dispatchEvent(new CustomEvent('customcart:refresh'));
      document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
    });
  }
}
quickatcgrid = (varid,evt) =>{
  // Check if limit is reached for PWP products BEFORE executing
  var $element = $(evt);
  var isPwpGeneralCart = $element.attr('data-pwp-general') === 'true';
  // Prevent double add for PWP: ignore if this button is already adding (separate flag from pwpAddToCart)
  if (evt && $element.hasClass('jsc-pwp-cart-button') && $element.attr('data-quickatc-adding') === 'true') {
    return;
  }
  if (!isPwpGeneralCart && $element.hasClass('jsc-pwp-cart-button') && $('.jsc-pwp-limit-new').length > 0) {
    // Find and show the limit-reach message
    var $limitReach = $element.closest('.product-information--inner, .product-card, .product-add-to-cart-container').find('.limit-reach');
    if ($limitReach.length === 0) {
      $limitReach = $element.siblings('.limit-reach');
    }
    if ($limitReach.length === 0) {
      $limitReach = $element.closest('.product-card--add-to-cart-button, .single-add-to-cart-button').siblings('.limit-reach');
    }
    if ($limitReach.length === 0) {
      $limitReach = $('.limit-reach');
    }
    $limitReach.show();
    
    // Hide the limit-reach message after 2.5 seconds
    setTimeout(function() {
      $limitReach.hide();
    }, 2500);
    
    // Prevent further execution
    return false;
  }
  // Check if minimum quantity is not met for PWP products BEFORE executing
  if (!isPwpGeneralCart && $element.hasClass('jsc-pwp-cart-button') && $('.jsc-pwp-min-qty-not-met').length > 0) {
    // Find and show the min-reach-not-met message
    var $minReachNotMet = $element.closest('.product-information--inner, .product-card, .product-add-to-cart-container').find('.min-reach-not-met');
    if ($minReachNotMet.length === 0) {
      $minReachNotMet = $element.siblings('.min-reach-not-met');
    }
    if ($minReachNotMet.length === 0) {
      $minReachNotMet = $element.closest('.product-card--add-to-cart-button, .single-add-to-cart-button').siblings('.min-reach-not-met');
    }
    if ($minReachNotMet.length === 0) {
      $minReachNotMet = $('.min-reach-not-met');
    }
    $minReachNotMet.show();
    
    // Hide the min-reach-not-met message after 2.5 seconds
    setTimeout(function() {
      $minReachNotMet.hide();
    }, 2500);
    
    // Prevent further execution
    return false;
  }
  // this is to be uncommented later on 
  
  // var datasalevar = $(evt).attr('data-sale-var');
  // if (datasalevar) {
  //   if ($('#tvccustomer').length > 0) {
  //     console.log('tvccustomer');
  //   }else{
  //     console.log($(evt).parents('.column').find('.prod-error-grid'));
  //     $(evt).parents('.column').find('.prod-error-grid').removeClass('hide');
  //     setTimeout(function() {
  //       $(evt).parents('.column').find('.prod-error-grid').addClass('hide');
  //     }, 1000);
  //     return
  //   }
  // }
  // For PWP buttons, set guard to prevent double add (e.g. from same click firing twice)
  if (evt && $element.hasClass('jsc-pwp-cart-button')) {
    $element.attr('data-quickatc-adding', 'true');
    setTimeout(function() {
      $element.removeAttr('data-quickatc-adding');
    }, 1500);
  }
  var jsonObj = [];
  var item = {};
  var giftProp = $element.attr('data-prop');
  var giftTier = $element.attr('data-tier');
  var propObj = {};
  if (giftProp) {
    propObj['_Cart_GWP'] = 'Free Gift';
    if (giftProp == 'singletier') {
      propObj['_Cart_GWP_SingleTier'] = giftTier || '1';
    } else if (giftProp == 'multitier') {
      propObj['_Cart_GWP_MultiTier'] = giftTier || '1';
    } else if (giftProp == 'multigwp') {
      propObj['_Cart_GWP_Multi'] = 'True';
    } else if (giftProp == 'packet') {
      propObj['_Cart_GWP_packet'] = 'True';
    } else if (giftProp == 'packet2') {
      propObj['_Cart_GWP_packet2'] = 'True';
    } else if (giftProp == 'collab') {
      propObj['_Cart_GWP_Collab'] = $element.attr('data-colab') || '1';
    }
  }
  item ["id"] = varid;
  item ["quantity"] = 1;
  if (!isPwpGeneralCart) {
    item ["properties"] = propObj;
  }
  jsonObj.push(item);
  cartJSAddSQuery(jsonObj,true);
}

initswatchflickity = () => {
  var attempts = 0;
  var attemptLimit = 50;
  var timer = setInterval(function() {
    attempts += 1;
    if (initFlickity) {
      if ($('.product-card-swatches:not(.flickity-enabled)').length > 0) {
        $('.product-card-swatches:not(.flickity-enabled)').flickity({
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          groupCells: false,
          wrapAround: false,
          draggable: true,
          prevNextButtons: false
        });
      }
      clearInterval(timer);
    } else if (attempts >= attemptLimit) {
      clearInterval(timer);
    }
  }, 10);
}

hoveraddclassprodcard = (evt) =>{
  $(evt).addClass('hovergrid');
}
hoverremoveclassprodcard = (evt) =>{
  $(evt).removeClass('hovergrid');
}

handleGiftwrapOptionChange = (element) => {
  console.log("handleGiftwrapOptionChange");
  CartJS.setAttribute(' I would like my gift wrapped.', element.checked ? 'Yes' : 'No');
}

handleGwpCartDetailsChange = (element) => {
  console.log("handleGwpCartDetailsChange");
  gwpPopupATC(element);
}

intervalshowfestivegif = () =>{
  setTimeout(function(){
    $('.col-gif-festive').show();
    var show = true;
    var timescount = 0;
    var timesRunhide = 0;
    var timesRun = 0;
    var timesRunhidediff = 6;
    if ($(window).width() < 481) {
      timesRunhidediff = 4;
      var timer = setInterval(function() {
        timescount += 1;
        //console.log(timescount);
        timesRunhide += 1;
        timesRun += 1;
        if(timesRunhide === 45 && show){
          //console.log('hide',timesRunhide,timesRun);
          timesRunhide = 0;
          timesRun = 0;
          timescount = 0;
          $('.col-gif-festive').hide();
          show = false;
        }
        if(timesRun === 90 && show == false){
          //console.log('show',timesRunhide,timesRun);
          timesRunhide = 0;
          timesRun = 0;
          timescount = 0;
          $('.col-gif-festive').show();
          show = true;
        }
  
      }, 100);
    }else{
    var timer = setInterval(function() {
      timescount += 1;
      //console.log(timescount);
      timesRunhide += 1;
      timesRun += 1;
      if(timesRunhide === timesRunhidediff && show){
        //console.log('hide',timesRunhide,timesRun);
        timesRunhide = 0;
        timesRun = 0;
        timescount = 0;
        $('.col-gif-festive').hide();
        show = false;
      }
      if(timesRun === 9 && show == false){
        //console.log('show',timesRunhide,timesRun);
        timesRunhide = 0;
        timesRun = 0;
        timescount = 0;
        $('.col-gif-festive').show();
        show = true;
      }

    }, 1000);
    }
  },3000);
}

updateFeatCollContainerHeight = () => {
  var maxWidth = 1024;
  var windowWidth = $(window).width();

  if (windowWidth <= maxWidth) {
    var $featCollImage = $('.jsc-normal-feat-collection .jsc-feat-coll-image.jsc-fix-coll-img');
    if ($featCollImage.length) {
      var $img = $featCollImage.find('img');
      // console.log("img", $img);
      var naturalHeight = $img[0].naturalHeight;
      $('.featured-collection-list.jsc-normal-feat-collection').css('height', naturalHeight + 'px');
      // console.log("Image width set to:", naturalHeight);
    }
  }else{
    $('.featured-collection-list.jsc-normal-feat-collection').css('height', '');
  }
}

changeProductNoteToSentenceCase = () => {
  $('.jsc-product-note').each(function() {
    $(this).text(function(_, text) {
      return text.toLowerCase().replace(/(^\s*\w|[\.\!\?]\s*\w)/g, char => char.toUpperCase());
    });
  });
}

// Shopify Cart API Utility Functions
const ShopifyCartAPI = {
  // Show/hide loading indicator
  showLoading: () => {
    $('.jsc-page-loading').show();
  },
  
  hideLoading: () => {
    $('.jsc-page-loading').hide();
  },
  
  // Dispatch refresh events
  dispatchRefreshEvents: () => {
    if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
      document.dispatchEvent(new CustomEvent('customcart:refresh'));
    }
    
    if ($('.main-cart-section').length > 0) {
      document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
    }
    
    // Dispatch general cart update event for any cart-related updates
    document.dispatchEvent(new CustomEvent('cart:updated'));
  },
  
  // Handle API response errors
  handleError: (error, customMessage) => {
    const message = error.description || error.message || customMessage || 'Cart operation failed';
    console.log("Error occurred:", message);
    return Promise.reject(new Error(message));
  },
  
  // GET /cart.js - Fetch cart data
  getCart: () => {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => {
        if (!response.ok) {
          return response.json().then(error => {
            throw new Error(error.description || error.message || 'Failed to fetch cart');
          });
        }
        return response.json();
      });
  },
  
  // POST /cart/add.js - Add items to cart
  addItems: (items, options = {}) => {
    const showLoading = options.showLoading !== false;
    const hideLoading = options.hideLoading !== false;
    const dispatchRefresh = options.dispatchRefresh !== false;
    
    if (showLoading) ShopifyCartAPI.showLoading();
    
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(error => {
          throw new Error(error.description || error.message || 'Cart add failed');
        });
      }
      return response.json();
    })
    .then(data => {
      if (hideLoading) ShopifyCartAPI.hideLoading();
      if (dispatchRefresh) ShopifyCartAPI.dispatchRefreshEvents();
      return data;
    })
    .catch(error => {
      if (hideLoading) ShopifyCartAPI.hideLoading();
      console.log("Error occurred while adding items:", error);
      throw error;
    });
  },
  
  // POST /cart/update.js - Update multiple items by line item key
  updateItems: (updates, options = {}) => {
    const showLoading = options.showLoading !== false;
    const hideLoading = options.hideLoading !== false;
    const dispatchRefresh = options.dispatchRefresh !== false;
    
    if (showLoading) ShopifyCartAPI.showLoading();
    
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(error => {
          throw new Error(error.description || error.message || 'Cart update failed');
        });
      }
      return response.json();
    })
    .then(data => {
      if (hideLoading) ShopifyCartAPI.hideLoading();
      if (dispatchRefresh) ShopifyCartAPI.dispatchRefreshEvents();
      return data;
    })
    .catch(error => {
      if (hideLoading) ShopifyCartAPI.hideLoading();
      console.log("Error occurred while updating cart:", error);
      throw error;
    });
  },
  
  // POST /cart/change.js - Change a single item by line item key
  changeItem: (id, quantity, properties = {}, options = {}) => {
    const showLoading = options.showLoading !== false;
    const hideLoading = options.hideLoading !== false;
    const dispatchRefresh = options.dispatchRefresh !== false;
    
    if (showLoading) ShopifyCartAPI.showLoading();
    
    const body = { id: id };
    if (quantity !== undefined) body.quantity = quantity;
    // Always send properties object (even if empty) to update/remove properties
    // According to Shopify API: properties not included will be removed
    body.properties = properties || {};
    
    console.log('changeItem API call - Request body:', JSON.stringify(body));
    
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(error => {
          throw new Error(error.description || error.message || 'Cart change failed');
        });
      }
      return response.json();
    })
    .then(data => {
      if (hideLoading) ShopifyCartAPI.hideLoading();
      if (dispatchRefresh) ShopifyCartAPI.dispatchRefreshEvents();
      return data;
    })
    .catch(error => {
      if (hideLoading) ShopifyCartAPI.hideLoading();
      console.log("Error occurred while changing cart item:", error);
      throw error;
    });
  },
  
  // Chain multiple cart operations
  chain: (...operations) => {
    return operations.reduce((promise, operation) => {
      return promise.then(() => operation());
    }, Promise.resolve());
  }
};

window.jscRemoveOverLimitPreorderCartItems = function() {
  if (window._jscPreorderLimitRemoving) return;
  var keys = [];
  document.querySelectorAll('[data-preorder-over-limit="true"][data-product-id]').forEach(function(el) {
    var key = el.getAttribute('data-product-id');
    if (key && keys.indexOf(key) === -1) keys.push(key);
  });
  if (!keys.length) return;
  if (typeof ShopifyCartAPI === 'undefined' || !ShopifyCartAPI.changeItem) return;

  window._jscPreorderLimitRemoving = true;
  var chain = Promise.resolve();
  keys.forEach(function(key) {
    chain = chain.then(function() {
      return ShopifyCartAPI.changeItem(key, 0, {}, { dispatchRefresh: false, showLoading: true, hideLoading: false });
    });
  });
  chain
    .then(function() {
      try {
        sessionStorage.setItem('jsc_preorder_limit_removed', '1');
      } catch (e) {}
      if (typeof ShopifyCartAPI.dispatchRefreshEvents === 'function') {
        ShopifyCartAPI.dispatchRefreshEvents();
      } else {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
      // Section HTML is replaced async; retry until notice nodes exist.
      var tries = 0;
      var showTimer = setInterval(function() {
        tries += 1;
        var hasNotice = document.querySelectorAll('.jsc-preorder-limit-cart-notice').length > 0;
        if (hasNotice || tries >= 25) {
          clearInterval(showTimer);
          if (typeof window.jscShowPreorderLimitCartNotice === 'function') {
            window.jscShowPreorderLimitCartNotice();
          }
        }
      }, 120);
    })
    .catch(function(err) {
      console.log('Preorder over-limit cart remove failed:', err);
    })
    .finally(function() {
      window._jscPreorderLimitRemoving = false;
      if (typeof ShopifyCartAPI.hideLoading === 'function') ShopifyCartAPI.hideLoading();
    });
};

window.jscShowPreorderLimitCartNotice = function() {
  try {
    if (sessionStorage.getItem('jsc_preorder_limit_removed') !== '1') return;
    sessionStorage.removeItem('jsc_preorder_limit_removed');
  } catch (e) {
    return;
  }
  var notices = document.querySelectorAll('.jsc-preorder-limit-cart-notice');
  notices.forEach(function(notice) {
    notice.style.display = '';
  });
};

(function() {
  function runPreorderLimitCartCleanup() {
    if (typeof window.jscShowPreorderLimitCartNotice === 'function') {
      window.jscShowPreorderLimitCartNotice();
    }
    if (typeof window.jscRemoveOverLimitPreorderCartItems === 'function') {
      window.jscRemoveOverLimitPreorderCartItems();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runPreorderLimitCartCleanup);
  } else {
    runPreorderLimitCartCleanup();
  }
})();

handleGiftWrapChange = () => {
  $(document).on('change', '.main-cart-section .jsc-cartitem-giftwrap-checkbox', function() {
    var checkbox = $(this);
    console.log("checkbox", checkbox);
    var productQuantity = parseInt(checkbox.closest('.product-quantity').find('input').first().val());
    var itemId = checkbox.attr('cart-item-id');
    var itemkey = checkbox.attr('cart-item-key');
    var giftWrapItemId = checkbox.attr('gift-wrap-item-id');
    var giftWrapItemTitle = checkbox.attr('gift-wrap-item-title');
    var checkBoxGiftWrapBindID = checkbox.attr('giftwrap-bind-id');
    var giftWrapItemCurrentProperties = checkbox.attr('gift-wrap-item-old-current-properties');
    console.log("giftWrapItemCurrentProperties", giftWrapItemCurrentProperties);
    var now = new Date();
    var formattedDateTime = now.getFullYear().toString() +
        (now.getMonth() + 1).toString().padStart(2, '0') +
        now.getDate().toString().padStart(2, '0') + "-" +
        now.getHours().toString().padStart(2, '0') +
        now.getMinutes().toString().padStart(2, '0') +
        now.getSeconds().toString().padStart(2, '0');
    var bindID = itemId + "-" + giftWrapItemId + "-" + formattedDateTime;
    var giftWrapValue = giftWrapItemTitle;

    var $prodObj = {};
    if(giftWrapItemCurrentProperties != "") {
      var pairs = giftWrapItemCurrentProperties.split(', ');

      pairs.forEach(pair => {
        const [key, value] = pair.split(':');
        $prodObj[key.trim()] = value.trim();
      });
    }

    if (checkbox.prop('checked')) {
      console.log("RUN this 1");
      var jsonObj = [];
      var item = {};
      var $obj = {};
      $obj['_giftWrap bindID'] = bindID;
      $obj['_giftWrap Product'] = 'giftWrap';
      $prodObj['Gift wrap'] = giftWrapValue;
      $prodObj['giftWrap bindID'] = bindID;
      item["id"] = giftWrapItemId;
      item["quantity"] = productQuantity;
      item["properties"] = $obj;
      jsonObj.push(item);
      
      // Add gift wrap item, then update main item properties
      ShopifyCartAPI.addItems(jsonObj, { dispatchRefresh: false })
        .then(data => {
          console.log('Success in adding items', data);
          return ShopifyCartAPI.changeItem(itemkey, productQuantity, $prodObj);
        })
        .then(data => {
          console.log('Success in updating item properties', data);
        })
        .catch(error => {
          console.log("Error occurred:", error);
        });

    } else {
      console.log("RUN this 2");
      $('.main-cart-section .jsc-cart-item-giftwrap').each(function() {
        var giftWrapBindID = $(this).attr('giftwrap-bindid');
        var giftWrapVarID = $(this).attr('data-product-id');
        
        if (giftWrapBindID == checkBoxGiftWrapBindID) {
          console.log("RUN this 3");
          var selectedGiftWrapVarID = giftWrapVarID;
          var jsonObj = {};
          jsonObj[selectedGiftWrapVarID] = 0;
          jsonObj[itemkey] = 0;
          if(giftWrapItemCurrentProperties != "") {
            $.each(["Gift wrap", "giftWrap bindID"], function(index, key) {
              delete $prodObj[key];
            });
          }
          
          // Remove items, then add item back with updated properties
          ShopifyCartAPI.updateItems(jsonObj, { dispatchRefresh: false })
            .then(data => {
              console.log('Remove item - updateItemQuantitiesById-variant-id', data);
              return ShopifyCartAPI.addItems([{
                id: itemId,
                quantity: productQuantity,
                properties: $prodObj
              }]);
            })
            .then(data => {
              console.log('Success in adding items', data);
            })
            .catch(error => {
              console.log("Error occurred:", error);
            });
        }
      });

    }
  });
}

handleGiftWrapChangeCartDrawer = () => {
  $(document).on('change', '.cart-drawer .jsc-cartitem-giftwrap-checkbox', function() {
    var checkbox = $(this);
    var productQuantity = parseInt(checkbox.closest('.product-cart-item-info').find('input').first().val());
    var itemId = checkbox.attr('cart-item-id');
    var itemkey = checkbox.attr('cart-item-key');
    var giftWrapItemId = checkbox.attr('gift-wrap-item-id');
    var giftWrapItemTitle = checkbox.attr('gift-wrap-item-title');
    var checkBoxGiftWrapBindID = checkbox.attr('giftwrap-bind-id');
    var giftWrapItemCurrentProperties = checkbox.attr('gift-wrap-item-old-current-properties');
    var now = new Date();
    var formattedDateTime = now.getFullYear().toString() +
        (now.getMonth() + 1).toString().padStart(2, '0') +
        now.getDate().toString().padStart(2, '0') + "-" +
        now.getHours().toString().padStart(2, '0') +
        now.getMinutes().toString().padStart(2, '0') +
        now.getSeconds().toString().padStart(2, '0');
    var bindID = itemId + "-" + giftWrapItemId + "-" + formattedDateTime;
    var giftWrapValue = giftWrapItemTitle;

    var $prodObj = {};
    if(giftWrapItemCurrentProperties != "") {
      var pairs = giftWrapItemCurrentProperties.split(', ');

      pairs.forEach(pair => {
        const [key, value] = pair.split(':');
        $prodObj[key.trim()] = value.trim();
      });
    }

    if (checkbox.prop('checked')) {
      console.log("RUN this 1");
      var jsonObj = [];
      var item = {};
      var $obj = {};
      $obj['_giftWrap bindID'] = bindID;
      $obj['_giftWrap Product'] = 'giftWrap';
      $prodObj['Gift wrap'] = giftWrapValue;
      $prodObj['giftWrap bindID'] = bindID;
      item["id"] = giftWrapItemId;
      item["quantity"] = parseInt(productQuantity);
      item["properties"] = $obj;
      jsonObj.push(item);
      
      // Add gift wrap item, then update main item properties
      ShopifyCartAPI.addItems(jsonObj, { dispatchRefresh: false })
        .then(data => {
          console.log('Success in adding items', data);
          return ShopifyCartAPI.changeItem(itemkey, productQuantity, $prodObj);
        })
        .then(data => {
          console.log('Success in updating item properties', data);
        })
        .catch(error => {
          console.log("Error occurred:", error);
        });

    } else {
      console.log("RUN this 2");
      $('.cart-drawer .jsc-cart-item-giftwrap').each(function() {
        var giftWrapBindID = $(this).attr('giftwrap-bindid');
        var giftWrapVarID = $(this).attr('data-product-id');
        
        console.log("giftWrapBindID-giftWrapBindID", giftWrapBindID+'-'+bindID);
        if (giftWrapBindID == checkBoxGiftWrapBindID) {
          console.log("RUN this 3");
          var selectedGiftWrapVarID = giftWrapVarID;
          var jsonObj = {};
          jsonObj[selectedGiftWrapVarID] = 0;
          jsonObj[itemkey] = 0;
          if(giftWrapItemCurrentProperties != "") {
            $.each(["Gift wrap", "giftWrap bindID"], function(index, key) {
              delete $prodObj[key];
            });
          }
          
          // Remove items, then add item back with updated properties
          ShopifyCartAPI.updateItems(jsonObj, { dispatchRefresh: false })
            .then(data => {
              console.log('Remove item - updateItemQuantitiesById-variant-id', data);
              return ShopifyCartAPI.addItems([{
                id: itemId,
                quantity: productQuantity,
                properties: $prodObj
              }]);
            })
            .then(data => {
              console.log('Success in adding items', data);
            })
            .catch(error => {
              console.log("Error occurred:", error);
            });
        }
      });

    }
  });
}

handleGiftWrapChangeQTYSelector = (currentElement, currentQuantity) => {

  var $currentElement = $(currentElement);
  var $currentCheckBox = $currentElement.closest('.product-quantity').find('.jsc-checkbox-container .jsc-cartitem-giftwrap-checkbox');
  var itemId = $currentCheckBox.attr('cart-item-id');
  var giftWrapItemId = $currentCheckBox.attr('gift-wrap-item-id');
  var checkBoxGiftWrapBindID = $currentCheckBox.attr('giftwrap-bind-id');
  var now = new Date();
  var formattedDateTime = now.getFullYear().toString() +
    (now.getMonth() + 1).toString().padStart(2, '0') +
    now.getDate().toString().padStart(2, '0') + "-" +
    now.getHours().toString().padStart(2, '0') +
    now.getMinutes().toString().padStart(2, '0') +
    now.getSeconds().toString().padStart(2, '0');
  var bindID = itemId + "-" + giftWrapItemId + "-" + formattedDateTime;
  var totalQuantity = 0;

  console.log("currentCheckBox", $currentCheckBox);
  console.log("currentQuantity", currentQuantity);
  
  if ($currentCheckBox.is(':checked')) {
    if($('.main-cart-section .jsc-cart-item-giftwrap').length > 0 ) {
      $('.main-cart-section .jsc-cart-item-giftwrap').each(function() {
        totalQuantity = totalQuantity + parseInt($(this).find('quantity-selector input').val());
      });
      $('.main-cart-section .jsc-cart-item-giftwrap').each(function() {
        var giftWrapBindID = $(this).attr('giftwrap-bindid');
        var giftWrapVarID = $(this).attr('data-product-id');
        var giftWrapVariantID = $(this).attr('data-product-variant-id');
        
        console.log("giftWrapBindID-giftWrapBindID", giftWrapBindID+'-'+bindID);
        if (giftWrapBindID == checkBoxGiftWrapBindID && ($('.jsc-limit-giftwrap').length <= 0)) {
          var selectedGiftWrapVarID = giftWrapVarID; 

          var jsonObj = {};
          var currentGiftWrapQty = parseInt($(this).find('quantity-selector input').val());
          var maxQtyToBeAdd = 10 - totalQuantity;
          var currentQTYAdded = currentQuantity - currentGiftWrapQty;
          
          if(currentQTYAdded < maxQtyToBeAdd){
            var actualQtyAdded = currentGiftWrapQty + currentQTYAdded;
          }else{
            var actualQtyAdded = currentGiftWrapQty + maxQtyToBeAdd;
          }
          jsonObj[selectedGiftWrapVarID] = actualQtyAdded;

          // Using Shopify Cart API instead of CartJS
          ShopifyCartAPI.updateItems(jsonObj)
            .then(data => {
              console.log('Remove item - updateItemQuantitiesById-key-id', data);
            })
            .catch(error => {
              console.log("Error occurred while updating item quantities:", error);
            });
          
        }
      });
    }
  }
}

handleGiftWrapChangeQTYSelectorCartDrawer = (currentElement, currentQuantity) => {

  var $currentElement = $(currentElement);
  var $currentCheckBox = $currentElement.closest('.product-cart-item.jsc-cart-drawer').find('.jsc-checkbox-container .jsc-cartitem-giftwrap-checkbox');;
  var itemId = $currentCheckBox.attr('cart-item-id');
  var giftWrapItemId = $currentCheckBox.attr('gift-wrap-item-id');
  var checkBoxGiftWrapBindID = $currentCheckBox.attr('giftwrap-bind-id');
  var now = new Date();
  var formattedDateTime = now.getFullYear().toString() +
    (now.getMonth() + 1).toString().padStart(2, '0') +
    now.getDate().toString().padStart(2, '0') + "-" +
    now.getHours().toString().padStart(2, '0') +
    now.getMinutes().toString().padStart(2, '0') +
    now.getSeconds().toString().padStart(2, '0');
  var bindID = itemId + "-" + giftWrapItemId + "-" + formattedDateTime;
  var totalQuantity = 0;

  if ($currentCheckBox.is(':checked')) {
    if($('.cart-drawer .jsc-cart-item-giftwrap').length > 0 ) {
      $('.cart-drawer .jsc-cart-item-giftwrap').each(function() {
        totalQuantity = totalQuantity + parseInt($(this).find('quantity-selector input').val());
      });
      $('.cart-drawer .jsc-cart-item-giftwrap').each(function() {
        var giftWrapBindID = $(this).attr('giftwrap-bindid');
        var giftWrapVarID = $(this).attr('data-product-id');
        var giftWrapVariantID = $(this).attr('data-product-variant-id');
        
        console.log("giftWrapBindID-giftWrapBindID", giftWrapBindID+'-'+bindID);
        if (giftWrapBindID == checkBoxGiftWrapBindID && ($('.jsc-limit-giftwrap').length <= 0)) {
          var selectedGiftWrapVarID = giftWrapVarID; 
          console.log("selectedGiftWrapVarID", selectedGiftWrapVarID);

          var jsonObj = {};
          var currentGiftWrapQty = parseInt($(this).find('quantity-selector input').val()); // 8 | 1
          var maxQtyToBeAdd = 10 - totalQuantity; // 9 = 1
          var currentQTYAdded = currentQuantity - currentGiftWrapQty; // 11 - 8 = 3
          
          if(currentQTYAdded < maxQtyToBeAdd){
            var actualQtyAdded = currentGiftWrapQty + currentQTYAdded;
          }else{
            var actualQtyAdded = currentGiftWrapQty + maxQtyToBeAdd;
          }
          jsonObj[selectedGiftWrapVarID] = actualQtyAdded;

          // Using Shopify Cart API instead of CartJS
          ShopifyCartAPI.updateItems(jsonObj)
            .then(data => {
              console.log('Remove item - updateItemQuantitiesById-key-id', data);
            })
            .catch(error => {
              console.log("Error occurred while updating item quantities:", error);
            });
          
        }
      });
    }
  }
}

removeEmbroideryAndClearMain = () => {
  if ($('.jsc-remove-embroidery-and-clear-main').length === 0) return;
  if (typeof ShopifyCartAPI === 'undefined' || !ShopifyCartAPI.getCart || !ShopifyCartAPI.changeItem || !ShopifyCartAPI.addItems) return;
  if (window._removeEmbroideryAndClearMainInProgress) return;
  window._removeEmbroideryAndClearMainInProgress = true;

  $('.checkout-button').attr('disabled', true);
  $('.jsc-page-loading').show();

  var jobs = [];
  $('.jsc-remove-embroidery-and-clear-main').each(function() {
    jobs.push({
      mainItemKey: $(this).attr('main-item-key'),
      mainItemQty: parseInt($(this).attr('main-item-qty'), 10) || 1,
      childKeys: (($(this).attr('child-keys') || '').split(',').filter(Boolean))
    });
  });
  // Drop markers immediately so cart:updated re-entry cannot re-run the same jobs
  $('.jsc-remove-embroidery-and-clear-main').remove();

  var totalItems = jobs.length;
  var processedItems = 0;

  var finishOne = function() {
    processedItems++;
    if (processedItems < totalItems) return;
    window._removeEmbroideryAndClearMainInProgress = false;
    $('.jsc-page-loading').hide();
    if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
      document.dispatchEvent(new CustomEvent('customcart:refresh'));
    }
    if ($('.main-cart-section').length > 0) {
      document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
    }
    document.dispatchEvent(new CustomEvent('cart:updated'));
  };

  jobs.forEach(function(job) {
    var mainItemKey = job.mainItemKey;
    var mainItemQty = job.mainItemQty;
    var childKeys = job.childKeys;

    var itemVariantId = null;
    var itemQuantity = mainItemQty;
    var keptProperties = {};

    // Keep non-embroidery properties (e.g. gift wrap) when re-adding the main line
    var stripEmbroideryProps = function(props) {
      var next = {};
      var skip = {
        '_Bind ID': true,
        '_Bundle Product': true,
        'First Initial': true,
        'Second Initial': true,
        'Third Initial': true
      };
      if (!props) return next;
      Object.keys(props).forEach(function(k) {
        if (!skip[k] && props[k] != null && props[k] !== '') {
          next[k] = props[k];
        }
      });
      return next;
    };

    var removeChildren = Promise.resolve();
    if (childKeys.length > 0) {
      removeChildren = Promise.all(
        childKeys.map(function(k) {
          return ShopifyCartAPI.changeItem(k, 0, {}, {
            showLoading: false,
            hideLoading: false,
            dispatchRefresh: false
          });
        })
      );
    }

    removeChildren
      .then(function() {
        return ShopifyCartAPI.getCart();
      })
      .then(function(cart) {
        var currentItem = null;
        if (cart && cart.items && Array.isArray(cart.items)) {
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === mainItemKey) {
              currentItem = cart.items[i];
              break;
            }
          }
        }
        if (!currentItem) {
          return Promise.reject('Embroidery main item not found');
        }
        itemVariantId = currentItem.variant_id || currentItem.id;
        itemQuantity = currentItem.quantity || mainItemQty;
        keptProperties = stripEmbroideryProps(currentItem.properties);
        if (!itemVariantId) {
          return Promise.reject('Embroidery main variant ID not found');
        }
        return ShopifyCartAPI.changeItem(mainItemKey, 0, {}, {
          showLoading: false,
          hideLoading: false,
          dispatchRefresh: false
        });
      })
      .then(function() {
        var itemToAdd = {
          id: itemVariantId,
          quantity: itemQuantity
        };
        if (Object.keys(keptProperties).length > 0) {
          itemToAdd.properties = keptProperties;
        }
        return ShopifyCartAPI.addItems([itemToAdd], {
          showLoading: false,
          hideLoading: false,
          dispatchRefresh: false
        });
      })
      .then(function() {
        finishOne();
      })
      .catch(function(error) {
        console.log('Error clearing embroidery bind properties:', error);
        finishOne();
      });
  });
};

removeGiftAndMainItemLineItemProperties = () => {
  var checkCount = 0;
  var maxChecks = 10;
  var intervalTime = 1000;
  var intervalId = setInterval(() => {
    checkCount++;
    if ($('.jsc-remove-gift-and-line-item-properties').length > 0) {
      $('.checkout-button').attr('disabled', true);
      $('.jsc-page-loading').show();

      var totalItems = $('.jsc-remove-gift-and-line-item-properties').length;
      var processedItems = 0;

      $('.jsc-remove-gift-and-line-item-properties').each(function() {
        var main_item_key = $(this).attr('main-item-key');
        var main_item_qty = parseInt($(this).attr('main-item-qty'));
        var giftwrap_item_key = $(this).attr('giftwrap-item-key');
        console.log("Processing:", main_item_key, main_item_qty, giftwrap_item_key);

        // Store main item details for re-adding
        var itemVariantId = null;
        var itemQuantity = main_item_qty;

        // Step 1: Get main item details, remove it, then re-add without properties
        ShopifyCartAPI.getCart()
          .then(cart => {
            // Find main item
            var currentItem = null;
            if (cart && cart.items && Array.isArray(cart.items)) {
              for (var i = 0; i < cart.items.length; i++) {
                if (cart.items[i].key === main_item_key) {
                  currentItem = cart.items[i];
                  break;
                }
              }
            }
            
            if (!currentItem) {
              console.log('Main item not found in cart');
              return Promise.reject('Main item not found');
            }

            // Store item details for re-adding
            itemVariantId = currentItem.variant_id || currentItem.id;
            itemQuantity = currentItem.quantity || main_item_qty;
            
            console.log('Main item - Variant ID:', itemVariantId, '| Quantity:', itemQuantity);
            
            if (!itemVariantId) {
              console.log('Main item variant ID not found');
              return Promise.reject('Main item variant ID not found');
            }

            // Step 2: Remove main item (set quantity to 0)
            console.log('Step 1: Removing main item...');
            return ShopifyCartAPI.changeItem(main_item_key, 0, {}, {
              showLoading: false,
              hideLoading: false,
              dispatchRefresh: false
            });
          })
          .then(data => {
            console.log('Step 1 complete: Main item removed');
            
            // Step 3: Re-add main item without properties
            console.log('Step 2: Re-adding main item without properties...');
            var itemToAdd = {
              id: itemVariantId,
              quantity: itemQuantity
              // No properties - will add without any properties
            };
            
            return ShopifyCartAPI.addItems([itemToAdd], {
              showLoading: false,
              hideLoading: false,
              dispatchRefresh: false
            });
          })
          .then(data => {
            console.log('Step 2 complete: Main item re-added without properties');
            
            // Step 4: Remove gift wrap item directly (set quantity to 0)
            console.log('Step 3: Removing gift wrap item...');
            return ShopifyCartAPI.changeItem(giftwrap_item_key, 0, {}, {
              showLoading: false,
              hideLoading: false,
              dispatchRefresh: false
            });
          })
          .then(data => {
            console.log('Step 3 complete: Gift wrap item removed');
            processedItems++;
            if (processedItems === totalItems) {
              $('.jsc-page-loading').hide();
              if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
                document.dispatchEvent(new CustomEvent('customcart:refresh'));
              }
              if ($('.main-cart-section').length > 0) {
                document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
              }
              document.dispatchEvent(new CustomEvent('cart:updated'));
              clearInterval(intervalId);
            }
          })
          .catch(error => {
            console.log("Error occurred:", error);
            processedItems++;
            if (processedItems === totalItems) {
              $('.jsc-page-loading').hide();
              if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
                document.dispatchEvent(new CustomEvent('customcart:refresh'));
              }
              if ($('.main-cart-section').length > 0) {
                document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
              }
              document.dispatchEvent(new CustomEvent('cart:updated'));
              clearInterval(intervalId);
            }
          });
      });
    }

    if (checkCount >= maxChecks) {
      $('.jsc-page-loading').hide();
      clearInterval(intervalId);
    }
  }, intervalTime);
}

updateGiftWrap = () =>{
  // Prevent infinite loops - if already running, skip
  if (window.updateGiftWrapRunning) {
    return;
  }
  
  if ($('.jsc-update-giftwrap').length > 0) {
    window.updateGiftWrapRunning = true;
    console.log('updateGiftWrap: Found', $('.jsc-update-giftwrap').length, 'elements to update');
    
    // Show loading indicator
    $('.jsc-page-loading').show();
    
    var updatePromises = [];
    $('.jsc-update-giftwrap').each(function(){
      var varID = $(this).val();
      var QTY = parseInt($(this).attr('data-quantity'));
      var jsonObj = {};
      jsonObj[varID] = QTY;
      
      console.log('updateGiftWrap: Updating variant', varID, 'to quantity', QTY);
      
      // Using Shopify Cart API
      var promise = ShopifyCartAPI.updateItems(jsonObj, { showLoading: false, hideLoading: false, dispatchRefresh: false })
        .then(data => {
          console.log('updateGiftWrap: Success updating item', varID, data);
          return data;
        })
        .catch(error => {
          console.log("updateGiftWrap: Error occurred while updating item quantities:", error);
          throw error;
        });
      
      updatePromises.push(promise);
    });
    
    // Wait for all updates to complete, then refresh cart
    Promise.all(updatePromises)
      .then(results => {
        console.log('updateGiftWrap: All updates completed, refreshing cart');
        // Remove the hidden inputs after successful update
        $('.jsc-update-giftwrap').remove();
        window.updateGiftWrapRunning = false;
        // Hide loading indicator
        $('.jsc-page-loading').hide();
        // Refresh cart after updates complete
        if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
          document.dispatchEvent(new CustomEvent('customcart:refresh'));
        }
        if ($('.main-cart-section').length > 0) {
          document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(error => {
        console.log("updateGiftWrap: Some updates failed", error);
        window.updateGiftWrapRunning = false;
        // Hide loading indicator even on error
        $('.jsc-page-loading').hide();
        // Still refresh cart even if some failed
        if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
          document.dispatchEvent(new CustomEvent('customcart:refresh'));
        }
        if ($('.main-cart-section').length > 0) {
          document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
  }
}

removeMainProdLineItemProperties = () => {
  if ($('.jsc-remove-main-prod-line-item-properties').length > 0) {
    $('.checkout-button').attr('disabled', true);
    $('.jsc-page-loading').show();
    
    $('.jsc-remove-main-prod-line-item-properties').each(function(){
      var main_item_key = $(this).attr('main-item-key');
      var main_item_qty = parseInt($(this).attr('main-item-qty'));

      // To remove ALL properties, we need to remove the line item and add it back
      // Shopify doesn't allow setting properties to empty object once properties exist
      var itemVariantId = null;
      var itemQuantity = main_item_qty;
      
      // Step 1: Get current item details (variant_id, quantity)
      ShopifyCartAPI.getCart()
        .then(cart => {
          // Find current item
          var currentItem = null;
          if (cart && cart.items && Array.isArray(cart.items)) {
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].key === main_item_key) {
                currentItem = cart.items[i];
                break;
              }
            }
          }
          
          if (!currentItem) {
            console.log('Item not found in cart');
            return Promise.reject('Item not found');
          }
          
          // Store item details for re-adding
          itemVariantId = currentItem.variant_id || currentItem.id;
          itemQuantity = currentItem.quantity || main_item_qty;
          
          console.log('Original item:', currentItem);
          console.log('Original properties:', currentItem.properties);
          console.log('Variant ID:', itemVariantId, '| Quantity:', itemQuantity);
          
          if (!itemVariantId) {
            console.log('Variant ID not found');
            return Promise.reject('Variant ID not found');
          }
          
          // Step 2: Remove the line item (set quantity to 0)
          console.log('Step 1: Removing line item...');
          return ShopifyCartAPI.changeItem(main_item_key, 0, {}, { 
            showLoading: false, 
            hideLoading: false, 
            dispatchRefresh: false 
          });
        })
        .then(data => {
          console.log('Step 1 complete: Item removed');
          
          // Step 3: Re-add the item without properties
          console.log('Step 2: Re-adding item without properties...');
          var itemToAdd = {
            id: itemVariantId,
            quantity: itemQuantity
            // No properties - this will add the item without any properties
          };
          
          return ShopifyCartAPI.addItems([itemToAdd], {
            showLoading: false,
            hideLoading: false,
            dispatchRefresh: false
          });
        })
        .then(data => {
          console.log('Step 2 complete: Item re-added', data);
          
          // Verify the properties were removed
          if (data && data.items) {
            // Find the newly added item (it will have a different key)
            var newItem = data.items.find(function(item) {
              return item.variant_id === itemVariantId || item.id === itemVariantId;
            });
            if (newItem) {
              console.log('New item key:', newItem.key);
              console.log('New item properties:', newItem.properties);
              if (!newItem.properties || Object.keys(newItem.properties).length === 0) {
                console.log('✓ Success: All properties removed!');
              } else {
                console.log('⚠ Warning: Properties still exist:', newItem.properties);
              }
            }
          }
          
          $('.jsc-page-loading').hide();
          if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
            document.dispatchEvent(new CustomEvent('customcart:refresh'));
          }
          if ($('.main-cart-section').length > 0) {
            document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
          }
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(error => {
          console.log("Error occurred:", error);
          $('.jsc-page-loading').hide();
          if ($('#Cart-Drawer').length > 0 && !window.location.pathname.includes('/cart')) {
            document.dispatchEvent(new CustomEvent('customcart:refresh'));
          }
          if ($('.main-cart-section').length > 0) {
            document.dispatchEvent(new CustomEvent('customcartpage:refresh'));
          }
          document.dispatchEvent(new CustomEvent('cart:updated'));
        });
    });
  }
}

copyPDPLink = () => {
  var currentURL = window.location.href;
  navigator.clipboard.writeText(currentURL)
    .then(() => {$(".success-copy-message").css("display", "flex");
      setTimeout(() => {
        $(".success-copy-message").css("display", "none");
      }, 2000);})
    .catch(err => console.error("Failed to copy URL: ", err));
}


// Start - bundle option to create from list
opencloseselectprod = (evt) => {
  const $evt = $(evt);
  const $target = $evt.siblings('.opt-bundle-prod');
  const $container = $evt.closest('.bundle-select-prod-main');

  // Toggle current element
  $target.toggle();

  // Hide other elements
  $container.find('.opt-bundle-prod').not($target).hide();

  // Click outside handler to close options
  $(document).off('click.closeOptions').on('click.closeOptions', (e) => {
    if (!$container.is(e.target) && $container.has(e.target).length === 0) {
        $target.hide();
        $(document).off('click.closeOptions'); // Remove the handler once closed
    }
  });
}

onclickselecrprod = (evt,selectmorethanone) => {
  const $evt = $(evt);
  const selectno = $evt.attr('data-select-no') || $evt.data('select-no');
  const prodTitle = $evt.attr('data-prod-title') || $evt.data('prod-title');
  const prodId = $evt.attr('data-prod-id') || $evt.data('prod-id');

  const $bundleMain = $evt.closest('.bundle-select-prod-main');
  const $collectionWrap = $evt.closest('.bundle-collection-wrap');
  const isCollectionBundle = $collectionWrap.length > 0 || $bundleMain.hasClass('bundle-collection-mode');
  const $optBundleProd = $evt.closest('.opt-bundle-prod');
  const $prodBundleSelect = $evt.closest('.prod-bundle-select');

  const $selectedBundleVar = $prodBundleSelect.find('.selected-prod-bundle-var');
  const $selectedBundleTitle = $evt.closest('.select-opt-bundle-wrap').find('.selected-bundle-prod-title');

  // Clone and prepare the selected product
  let $swatchSource = $bundleMain.siblings(`.bundlenocreate[data-product-id="${prodId}"]`);
  if ($swatchSource.length === 0) {
    $swatchSource = $collectionWrap.find('.bundle-collection-swatches .bundlenocreate[data-product-id="' + prodId + '"]');
  }
  if ($swatchSource.length === 0) {
    $swatchSource = $bundleMain.siblings('.bundle-collection-swatches').find(`.bundlenocreate[data-product-id="${prodId}"]`);
  }
  if (prodId !== 'default' && $swatchSource.length === 0) {
    console.warn('Bundle swatch not loaded yet for product', prodId);
    $optBundleProd.hide();
    return;
  }
  const $prodSelectedVar = $swatchSource
    .clone()
    .removeClass('bundlenocreate');

  // Update active state
  $optBundleProd.find('.active-bundle-select').removeClass('active-bundle-select');
  $evt.addClass('active-bundle-select');

  // Update selected product title and variants
  $selectedBundleTitle.text(prodTitle);
  $selectedBundleVar.empty();

  if (prodId !== 'default') {
    $prodSelectedVar.find('input').each(function () {
      var $input = $(this);
      var color = $input.data('value-nospace');
      var productId = $input.data('product-id');
      var inputnamedefault = $input.attr('name');
      var templateId = "24341136507249__main-product"; // Adjust if dynamic
    
      var newId = `swatch-0-bundle-${selectno}-${color}-${productId}-template--${templateId}`;
      var newName = `${inputnamedefault}-${selectno}`;
      $input.attr('id', newId);
      $input.attr('name', newName);
    
      var $label = $input.siblings('label'); // Assumes label is sibling
      if ($label.length > 0) {
        $label.attr('for', newId);
      }
    });

    $selectedBundleVar.append($prodSelectedVar);
    $selectedBundleVar.find('.jsc-each-swatch input[checked]').next().click();
  }

  // Hide current bundle selection and reset visibility
  $optBundleProd.hide();
  const $bundleItems = $optBundleProd.find('li').show();

  // Collection mode: each dropdown is scoped to its own collection only.
  // Product list mode: optionally hide picked products across all slots.
  if (!isCollectionBundle) {
    const $allBundleItems = $bundleMain.find('.opt-bundle-prod li').show();
    $allBundleItems.filter('.active-bundle-select').each(function () {
      const prodIdCheck = $(this).attr('data-prod-id') || $(this).data('prod-id');
      if (prodIdCheck !== 'default' && selectmorethanone == 'false') {
        $allBundleItems.filter(`[data-prod-id="${prodIdCheck}"]:not(.active-bundle-select)`).hide();
      }
    });
  } else {
    $bundleItems.filter('.active-bundle-select').each(function () {
      const prodIdCheck = $(this).attr('data-prod-id') || $(this).data('prod-id');
      if (prodIdCheck !== 'default' && selectmorethanone == 'false') {
        $bundleItems.filter(`[data-prod-id="${prodIdCheck}"]:not(.active-bundle-select)`).hide();
      }
    });
  }
  if (prodId == 'default') {
    $evt.parents('.bundle-select-prod-main').find(".feature-img-bundle").each(function () {
      var indeximg = $evt.parents('.prod-bundle-select').find('.feature-img-bundle').index(this);

      $(evt).parents('.thb-product-detail').find('.product-single__media .bundle-img-list').each(function(index) {
        if (index === indeximg) {
          const featimg = $(this).attr('data-default-src');
          // Widths you want in srcset
          var widths = [352, 832, 1200, 1920, 2000];

          // Build srcset by appending `&width=...` to featimg
          var srcset = widths.map(function(w) {
            return featimg + "&width=" + w + " " + w + "w";
          }).join(", ");

          $(this).attr('src', featimg + "&width=2000"); // Update src to high-res
          $(this).attr('srcset', srcset); // Update srcset with different sizes
        }
      });
      $(evt).parents('.thb-product-detail').find('.navCell .bundle-img-list').each(function(index) {
        if (index === indeximg) {
          const featimgnav = $(this).attr('data-default-src');
          $(this).attr('src', featimgnav); // Update src to high-res
        }
      });
    });
    $evt.parents('.prod-bundle-select').find('.feature-img-bundle').hide();
    $evt.parents('.prod-bundle-select').find('.opt-wrap').removeClass('opt-wrap-set');
    variantImageSwap('');
    if ($('.prod-bundle-select').length != countBundleSlotsWithLoadedVars($(document))) {
      $('.bundle-atc-form').attr('onclick', '');
    }
  }

  if (isCollectionBundle) {
    const $detail = $evt.closest('.thb-product-detail');
    updateCollectionBundlePriceDisplay(
      $detail,
      getCollectionBundlePriceTotals($bundleMain)
    );
    syncCollectionBundleEmbroideryUI($detail);
    syncCollectionBundleAtcState($detail);
  }
}
// End - bundle option to create from list

// Start - Collection bundle product loading
loadBundleCollectionProducts = async ($scope) => {
  const $root = $scope && $scope.length ? $scope : $(document);
  const $config = $root.find('.bundle-collection-config, #bundle-collection-config').first();
  if ($config.length === 0) return;

  let config;
  try {
    config = JSON.parse($config.text());
  } catch (e) {
    console.error('bundle collection config parse error', e);
    return;
  }

  if (!config.collections || config.collections.length === 0) {
    console.warn('loadBundleCollectionProducts: no collections configured');
    return;
  }

  const parentHandle = config.parentHandle;
  const selectMorethanone = config.selectMorethanone;
  const $collectionWrap = $config.closest('.bundle-collection-wrap');
  const $collectionMain = $collectionWrap.find('.bundle-collection-mode').first();
  const $collectionScope = $collectionMain.length ? $collectionMain : $root.find('.bundle-collection-mode');

  for (const coll of config.collections) {
    if (!coll.handle) continue;
    let page = 1;
    let hasMore = true;
    const existingIds = new Set();
    let $slot = $collectionScope.find(`.prod-bundle-select.bundle-collection-slot[data-slot="${coll.slot}"][data-collection-handle="${coll.handle}"]`);
    if ($slot.length === 0) {
      $slot = $collectionScope.find(`.prod-bundle-select[data-slot="${coll.slot}"][data-collection-handle="${coll.handle}"]`);
    }
    if ($slot.length === 0) {
      $slot = $collectionScope.find(`.prod-bundle-select[data-collection-handle="${coll.handle}"]`).first();
    }
    if ($slot.length === 0) {
      console.warn('loadBundleCollectionProducts: slot not found', coll.slot, coll.handle);
      continue;
    }
    let $ul = $slot.find(`ul.opt-bundle-prod[data-collection-handle="${coll.handle}"][data-slot="${coll.slot}"]`);
    if ($ul.length === 0) {
      $ul = $slot.find('ul.opt-bundle-prod').first();
    }
    const $swatchContainer = $collectionWrap.find('.bundle-collection-swatches').length
      ? $collectionWrap.find('.bundle-collection-swatches')
      : ($config.siblings('.bundle-collection-swatches').length
        ? $config.siblings('.bundle-collection-swatches')
        : $collectionScope.siblings('.bundle-collection-swatches'));

    $ul.find('li[data-prod-id]').each(function () {
      const prodId = $(this).attr('data-prod-id');
      if (prodId && prodId !== 'default') {
        existingIds.add(String(prodId));
      }
    });

    const needsPagination = (coll.productsCount || 0) > 50;
    if (!needsPagination && existingIds.size > 0) {
      continue;
    }

    while (hasMore) {
      try {
        const url = `/collections/${coll.handle}?view=bundle-products&page=${page}&bundle_parent=${encodeURIComponent(parentHandle)}&slot=${coll.slot}`;
        const res = await fetch(url);
        if (!res.ok) {
          console.warn('loadBundleCollectionProducts: request failed', url, res.status);
          break;
        }
        let data;
        try {
          data = JSON.parse(await res.text());
        } catch (parseErr) {
          console.error('loadBundleCollectionProducts: invalid JSON', url, parseErr);
          break;
        }

        (data.products || []).forEach((prod) => {
          if (existingIds.has(String(prod.id))) return;
          existingIds.add(String(prod.id));
          const escapedTitle = $('<div>').text(prod.title).html();
          const $li = $(`<li onclick="onclickselecrprod(this,'true')" data-select-no="${coll.slot}" data-prod-id="${prod.id}" data-prod-title="${escapedTitle}"><div>${escapedTitle}</div></li>`);
          $ul.append($li);
        });

        if (data.swatches_html) {
          $swatchContainer.append(data.swatches_html);
        }

        if (data.next_page) {
          page = data.next_page;
        } else {
          hasMore = false;
        }
      } catch (err) {
        console.error('loadBundleCollectionProducts error', err);
        hasMore = false;
      }
    }
  }

  onloadchecksoldoutBundle();
  syncCollectionBundlePriceDisplay();
  syncCollectionBundleAtcState($root.hasClass('thb-product-detail') ? $root : $root.find('.thb-product-detail').first());
  syncCollectionBundleEmbroideryUI($root);
};
// End - Collection bundle product loading

// Start - Dumpling bundle option preselect
preselectBundleProducts = () => {
  if ($('.bundle-select-prod-main.dumpling-bundle-option').length > 0) {
    console.log("RUN preselectBundleProducts");
    var firstProductLi = $('.prod-bundle-select').eq(0).find('.opt-bundle-prod li').eq(1);
    if (firstProductLi.length > 0) {
      onclickselecrprod(firstProductLi[0], 'true');
    }

    var secondProductLi = $('.prod-bundle-select').eq(1).find('.opt-bundle-prod li').eq(2);
    if (secondProductLi.length > 0) {
      onclickselecrprod(secondProductLi[0], 'true');
    }
  }
}
// End - Dumpling bundle option preselect

// Start - Password CP & PDP
passwordchecked = () => {
  var passwordvalue = $('#jscsale').val();
  var passwordinput = $('.password-form').val();
  var collectionurl = $('.password-form').attr('data-collection');
  if (passwordvalue === passwordinput) {
    sessionStorage.setItem('loginpresale', 'true');
    document.location.href = collectionurl;
  } else {
    $('.form-notification-password').addClass('active');
    setTimeout(function(){
      $('.form-notification-password').removeClass('active');
    },1500);
  }
}
// End - Password CP & PDP

// Start - Limit Reached for PWP Product
// Intercept clicks on PWP buttons BEFORE inline onclick handlers run using capture phase
document.addEventListener('click', function(e) {
  // Check if clicked element has PWP button classes
  var $target = $(e.target).closest('.jsc-pwp-cart-button, .quickatcgrid.jsc-pwp-cart-button');
  if ($target.length > 0) {
    if ($target.attr('data-pwp-general') === 'true') {
      return;
    }
    // Check if limit is reached by checking for .jsc-pwp-limit-new input
    if ($('.jsc-pwp-limit-new').length > 0) {
      // Show the limit-reach message
      var $element = $target;
      
      // Find the closest .limit-reach element near the clicked element
      var $limitReach = $element.closest('.product-information--inner, .product-card, .product-add-to-cart-container').find('.limit-reach');
      if ($limitReach.length === 0) {
        $limitReach = $element.siblings('.limit-reach');
      }
      if ($limitReach.length === 0) {
        $limitReach = $element.closest('.product-card--add-to-cart-button, .single-add-to-cart-button').siblings('.limit-reach');
      }
      if ($limitReach.length === 0) {
        $limitReach = $('.limit-reach');
      }
      $limitReach.show();
      
      // Hide the limit-reach message after 2.5 seconds
      setTimeout(function() {
        $limitReach.hide();
      }, 2500);
      
      // Prevent form submission
      var $form = $element.closest('form');
      if ($form.length > 0) {
        $form.off('submit.limitReached').on('submit.limitReached', function(evt) {
          evt.preventDefault();
          evt.stopPropagation();
          evt.stopImmediatePropagation();
          return false;
        });
      }
      
      // Stop event propagation and prevent inline onclick handlers from running
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      return false;
    }
    // Check if minimum quantity is not met by checking for .jsc-pwp-min-qty-not-met input
    if ($('.jsc-pwp-min-qty-not-met').length > 0) {
      // Show the min-reach-not-met message
      var $element = $target;
      
      // Find the closest .min-reach-not-met element near the clicked element
      var $minReachNotMet = $element.closest('.product-information--inner, .product-card, .product-add-to-cart-container').find('.min-reach-not-met');
      if ($minReachNotMet.length === 0) {
        $minReachNotMet = $element.siblings('.min-reach-not-met');
      }
      if ($minReachNotMet.length === 0) {
        $minReachNotMet = $element.closest('.product-card--add-to-cart-button, .single-add-to-cart-button').siblings('.min-reach-not-met');
      }
      if ($minReachNotMet.length === 0) {
        $minReachNotMet = $('.min-reach-not-met');
      }
      $minReachNotMet.show();
      
      // Hide the min-reach-not-met message after 2.5 seconds
      setTimeout(function() {
        $minReachNotMet.hide();
      }, 2500);
      
      // Prevent form submission
      var $form = $element.closest('form');
      if ($form.length > 0) {
        $form.off('submit.minQtyNotMet').on('submit.minQtyNotMet', function(evt) {
          evt.preventDefault();
          evt.stopPropagation();
          evt.stopImmediatePropagation();
          return false;
        });
      }
      
      // Stop event propagation and prevent inline onclick handlers from running
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      return false;
    }
  }
}, true); // Use capture phase to run before inline handlers

limitReachedForPWPProduct = (evt) => {
  var $el = evt && evt.jquery ? evt : $(evt);
  if ($el && $el.attr && $el.attr('data-pwp-general') === 'true') {
    return true;
  }
  // Check if limit is reached by checking for .jsc-pwp-limit-new input
  if ($('.jsc-pwp-limit-new').length > 0) {
    // Show the limit-reach message
    var $element = $(evt);
    
    // Find the closest .limit-reach element near the clicked element
    var $limitReach = $element.closest('.product-information--inner, .product-card, .product-add-to-cart-container').find('.limit-reach');
    if ($limitReach.length === 0) {
      $limitReach = $element.siblings('.limit-reach');
    }
    if ($limitReach.length === 0) {
      $limitReach = $element.closest('.product-card--add-to-cart-button, .single-add-to-cart-button').siblings('.limit-reach');
    }
    if ($limitReach.length === 0) {
      $limitReach = $('.limit-reach');
    }
    $limitReach.show();
    
    // Hide the limit-reach message after 2.5 seconds
    setTimeout(function() {
      $limitReach.hide();
    }, 2500);
    
    // Prevent form submission
    var $form = $element.closest('form');
    if ($form.length > 0) {
      $form.off('submit.limitReached').on('submit.limitReached', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      });
    }
    
    // Stop event propagation if evt is an event object
    if (evt && typeof evt === 'object' && evt.preventDefault) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();
    }
    
    // Prevent any other functions from running
    return false;
  }
  // Check if minimum quantity is not met by checking for .jsc-pwp-min-qty-not-met input
  if ($('.jsc-pwp-min-qty-not-met').length > 0) {
    // Show the min-reach-not-met message
    var $element = $(evt);
    
    // Find the closest .min-reach-not-met element near the clicked element
    var $minReachNotMet = $element.closest('.product-information--inner, .product-card, .product-add-to-cart-container').find('.min-reach-not-met');
    if ($minReachNotMet.length === 0) {
      $minReachNotMet = $element.siblings('.min-reach-not-met');
    }
    if ($minReachNotMet.length === 0) {
      $minReachNotMet = $element.closest('.product-card--add-to-cart-button, .single-add-to-cart-button').siblings('.min-reach-not-met');
    }
    if ($minReachNotMet.length === 0) {
      $minReachNotMet = $('.min-reach-not-met');
    }
    $minReachNotMet.show();
    
    // Hide the min-reach-not-met message after 2.5 seconds
    setTimeout(function() {
      $minReachNotMet.hide();
    }, 2500);
    
    // Prevent form submission
    var $form = $element.closest('form');
    if ($form.length > 0) {
      $form.off('submit.minQtyNotMet').on('submit.minQtyNotMet', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      });
    }
    
    // Stop event propagation if evt is an event object
    if (evt && typeof evt === 'object' && evt.preventDefault) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();
    }
    
    // Prevent any other functions from running
    return false;
  }
  
  // If limit not reached, allow normal execution
  return true;
}
// End - Limit Reached for PWP Product